/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddCollaboratorBadRequestError,
  AddCollaboratorBody,
  AddCollaboratorNotFoundError,
  AgentSummary,
  AggregatedAmount,
  AggregatedAmountBody,
  AggregatedAssets,
  AggregatedAssetsBody,
  AggregatedLiabilities,
  AggregatedLiabilitiesBody,
  AllocatedAmount,
  AllocatedAmountConflictError,
  AllocatedAmountNotFoundError,
  AllocatedAmountWriteNotFoundError,
  AllocatedGoalAmount,
  AllocatedGoalAmountBody,
  AmountMismatchError,
  AnalysesOverviewList,
  AnalysisClientListResult,
  AnalysisDetail,
  AnalysisInProgressError,
  AnalysisNotFoundError,
  AnalysisOwnerRequiredError,
  AnalysisPdfParams,
  AnalysisQuestionnaireEmptyPdfParams,
  AnalysisQuestionnairePdfParams,
  AnalysisReadOnlyAccessError,
  AnalysisSharedOutputs,
  AnalysisVersionSummary,
  AnalysisWriteForbiddenError,
  AnalyzerPartner,
  AssetItemContractOverview,
  AssetItemNotFoundError,
  AssetItemNotFoundOrContractShapeMismatchError,
  AssetItemOrContractNotFoundError,
  AssetOptionsList,
  AssetReallocationBody,
  AssetsOverview,
  AssignClientBadRequestError,
  AssignClientBody,
  AssignClientNotFoundError,
  AttachRelatedClientNotFoundError,
  AvailableAmount,
  BirthNumberLookupResult,
  BudgetBatchBadRequestError,
  BudgetOverview,
  CalculationParametersBody,
  ClientAnalysisVersionList,
  ClientBirthDateMissingError,
  ClientBudgetRecapitulation,
  ClientDetailBadRequestError,
  ClientDetailNotFoundError,
  ClientDetailResponse,
  ClientNotBelongToAnalysisError,
  CloneAnalysisBadRequestError,
  CloneAnalysisNotFoundError,
  CollaboratorList,
  ComplexExpenseItemNotFoundError,
  ComplexExpenseSettings,
  ComplexExpenseSettingsBody,
  ConsumptionExpense,
  ConsumptionExpenseBody,
  Contract,
  ContractBody,
  ContractNotFoundError,
  ContractProposalBase,
  ContractProposalsListResult,
  Country,
  CoverageParameters,
  CoverageParametersBody,
  CreateAllocatedAmountBody,
  CreateAnalysisBadRequestError,
  CreateAnalysisBody,
  CreateAnalysisNotFoundError,
  CreateAnalysisResult,
  CreateClient201,
  CreateClientBadRequestError,
  CreateClientBody,
  CreateComplexExpenseItemNotFoundError,
  CreateContractProposalBody,
  CreateCurrentContractBody,
  CreateInvestmentCaseInternalError,
  CreateInvestmentCaseNotFoundError,
  CreateIssueReportBadRequestError,
  CreateIssueReportBody,
  CreateIssueReportInternalError,
  CreateIssueReportNotFoundError,
  CreateIssueReportPayloadTooLargeError,
  CreateRiskBody,
  CurrentContractBase,
  CurrentContractsListResult,
  CurrentSolutionAssetOptionsList,
  DeleteAssetItemParams,
  DeleteClientBadRequestError,
  DeleteFinancialProductExpenseItemParams,
  DeleteLoanExpenseItemParams,
  DocumentNotFoundError,
  DocumentsList,
  DuplicateAnalysisBadRequestError,
  DuplicateAnalysisBody,
  DuplicateAnalysisNotFoundError,
  EmailQuestionnairePdfBadRequestError,
  EmailQuestionnairePdfNotFoundError,
  EnsureInvestmentCaseBadRequestError,
  EvaluateBadRequestError,
  EvaluatePortfolioBadRequestError,
  EvaluatePortfolioInternalError,
  EvaluatePortfolioRequest,
  EvaluatePortfolioResponse,
  EvaluateQuestionnaire,
  ExpensesBatchBody,
  FamilyGoalDto,
  FamilyGoalModelingPreview,
  FamilyGoalModelingPreviewRequest,
  FamilyGoalResponseDto,
  FamilyLiabilityOverview,
  FinancialAssetItem,
  FinancialAssetItemBody,
  FinancialProductExpense,
  FinancialProductExpenseItem,
  FinancialProductExpenseItemBody,
  FinancialReserveGoalDto,
  GetAnalysisByCaseIdNotFoundError,
  GetAnalysisClientsNotFoundError,
  GetAnalysisDocumentFileParams,
  GetAnalysisGoalsParams,
  GetContractProposal200,
  GetCurrentContract200,
  GetDashboardGraphParams,
  GetEvaluationNotFoundError,
  GetGoalsBadRequestError,
  GetGoalsConflictError,
  GetGoalsInternalError,
  GetGoalsNotFoundError,
  GetGrowUpLinkNotFoundError,
  GetInstrumentsParams,
  GetNotFoundError,
  GetNsureStatesNotFoundError,
  GetPortfoliosNotFoundError,
  GetQuestionnaireNotFoundError,
  GetSuitabilityStatementResponse,
  GoalModeling,
  GoalNotFoundError,
  GoalTypeMismatchError,
  GoalWriteNotFoundError,
  GoalsList,
  Graph,
  GrowUpLinkResult,
  HousingExpense,
  HousingExpenseBody,
  HousingMortgageGoalDto,
  HousingOtherGoalDto,
  HousingPropertyGoalDto,
  ImmovableAssetItem,
  ImmovableAssetItemBody,
  ImmovableContract,
  ImmovableContractBody,
  Income,
  IncomeBody,
  IncomeNotFoundError,
  IncomesBatchBody,
  Instrument,
  InstrumentNotFoundError,
  InstrumentsListResponse,
  InsuranceExpense,
  InsuranceExpenseItem,
  InsuranceExpenseItemBody,
  InsuranceExpenses,
  InsuranceIncreasedAmount,
  InvalidIncomeAmountTypeError,
  InvalidInsuranceIncreaseFrequencyError,
  LiabilityItem,
  LiabilityItemBody,
  LifeStyleExpense,
  LifeStyleExpenseBody,
  ListAnalysesOverviewParams,
  ListAnalyzerPartnersParams,
  ListRejectedCasesNotFoundError,
  LoadValuesOption,
  LoanExpense,
  LoanExpenseItem,
  LoanExpenseItemBody,
  LoginResponse,
  LoginZfpSsoCallbackParams,
  LoginZfpSsoParams,
  LogoutResponse,
  LogoutZfpSsoParams,
  LookupByBirthNumber,
  LookupByBirthNumberBadRequestError,
  ModelingRecapitulation,
  ModelingSnapshotMissingError,
  MovableAssetItem,
  MovableAssetItemBody,
  NoClientError,
  NotFoundError,
  NsureClientCaseState,
  OtherExpense,
  OtherExpenseBody,
  OtherGoalDto,
  OtherMovableContract,
  OtherMovableContractBody,
  PatchAnalysisBody,
  PatchAnalysisError,
  PatchContractProposalBody,
  PatchCurrentContractBody,
  PdfFileError,
  PensionGoalDto,
  PensionGoalModelingPreview,
  PensionGoalModelingPreviewRequest,
  PhonePrefix,
  PortfolioAssetAllocationOverview,
  PutConflictError,
  PutNotFoundError,
  Questionnaire,
  QuestionnaireEvaluation,
  QuestionnaireNotFoundError,
  QuestionnairePdfNotFoundError,
  QuestionnaireSignResend,
  QuestionnaireSignResponse,
  QuestionnaireSignVerify,
  RejectCaseBody,
  RejectCaseNotFoundError,
  RejectedCasesList,
  RelatedAssetItemMismatchError,
  RelatedExpenseItemMismatchError,
  ResendSignForbiddenError,
  ResendSignNotFoundError,
  ReturnEditAccessBadRequestError,
  ReturnEditAccessConflictError,
  Risk,
  RiskAlreadyExistsError,
  RiskNotFoundError,
  SaveAnswersBadRequestError,
  SaveAnswersNotFoundError,
  SaveQuestionnaireAnswers,
  SaveSuitabilityStatementBody,
  SearchAgentNotFoundError,
  SearchClients,
  SearchClientsResult,
  SearchCollaboratorBySsoIdParams,
  SetAnalysisStateBadRequestError,
  SetAnalysisStateBody,
  SetAnalysisStateNotFoundError,
  SetOrganizedByBody,
  SetOrganizedByError,
  SetPortfolioAssetAllocationRequiredBody,
  SetPortfolioAssetAllocationRequiredError,
  ShareAnalysisBadRequestError,
  ShareAnalysisBody,
  ShareAnalysisNotFoundError,
  SharePdfError,
  SharePdfForbiddenError,
  SharedAnalysisNotFoundError,
  SignBadRequestError,
  SignForbiddenError,
  SignGuardBadRequestError,
  SocialSupport,
  SocialSupportBody,
  StatusWithDbs,
  StrategyModelation,
  Summary,
  UnprocessableEntityError,
  UpdateAllocatedAmountBody,
  UpdateClient200,
  UpdateClientBadRequestError,
  UpdateClientBody,
  UpdateComplexExpenseItemNotFoundError,
  UpdateInsuranceIncreasedAmountBody,
  UpdateRiskBody,
  UserIsNotAdvisorError,
  UserProfile,
  VehicleContract,
  VehicleContractBody,
  VehicleGoalDto,
  VerifySignForbiddenError,
  VerifySignNotFoundError
} from './Schema';

import { customFetch } from '../Utils/CustomFetch';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Status endpoint
 */
export const status = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<StatusWithDbs>(
      {url: `/`, method: 'GET', signal
    },
      options);
    }
  



export const getStatusQueryKey = () => {
    return [
    `/`
    ] as const;
    }

    
export const getStatusQueryOptions = <TData = Awaited<ReturnType<typeof status>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof status>>> = ({ signal }) => status(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type StatusQueryResult = NonNullable<Awaited<ReturnType<typeof status>>>
export type StatusQueryError = void


export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof status>>,
          TError,
          Awaited<ReturnType<typeof status>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof status>>,
          TError,
          Awaited<ReturnType<typeof status>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Status endpoint
 */

export function useStatus<TData = Awaited<ReturnType<typeof status>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof status>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const loginZfpSso = (
    params: LoginZfpSsoParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<LoginResponse>(
      {url: `/v1/auth/login/zfp-sso`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getLoginZfpSsoQueryKey = (params?: LoginZfpSsoParams,) => {
    return [
    `/v1/auth/login/zfp-sso`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getLoginZfpSsoQueryOptions = <TData = Awaited<ReturnType<typeof loginZfpSso>>, TError = unknown>(params: LoginZfpSsoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginZfpSso>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoginZfpSsoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loginZfpSso>>> = ({ signal }) => loginZfpSso(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loginZfpSso>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LoginZfpSsoQueryResult = NonNullable<Awaited<ReturnType<typeof loginZfpSso>>>
export type LoginZfpSsoQueryError = unknown


export function useLoginZfpSso<TData = Awaited<ReturnType<typeof loginZfpSso>>, TError = unknown>(
 params: LoginZfpSsoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginZfpSso>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginZfpSso>>,
          TError,
          Awaited<ReturnType<typeof loginZfpSso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginZfpSso<TData = Awaited<ReturnType<typeof loginZfpSso>>, TError = unknown>(
 params: LoginZfpSsoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginZfpSso>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginZfpSso>>,
          TError,
          Awaited<ReturnType<typeof loginZfpSso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginZfpSso<TData = Awaited<ReturnType<typeof loginZfpSso>>, TError = unknown>(
 params: LoginZfpSsoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginZfpSso>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLoginZfpSso<TData = Awaited<ReturnType<typeof loginZfpSso>>, TError = unknown>(
 params: LoginZfpSsoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginZfpSso>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoginZfpSsoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const logoutZfpSso = (
    params: LogoutZfpSsoParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<LogoutResponse>(
      {url: `/v1/auth/logout/zfp-sso`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getLogoutZfpSsoQueryKey = (params?: LogoutZfpSsoParams,) => {
    return [
    `/v1/auth/logout/zfp-sso`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getLogoutZfpSsoQueryOptions = <TData = Awaited<ReturnType<typeof logoutZfpSso>>, TError = unknown>(params: LogoutZfpSsoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutZfpSso>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLogoutZfpSsoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof logoutZfpSso>>> = ({ signal }) => logoutZfpSso(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof logoutZfpSso>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LogoutZfpSsoQueryResult = NonNullable<Awaited<ReturnType<typeof logoutZfpSso>>>
export type LogoutZfpSsoQueryError = unknown


export function useLogoutZfpSso<TData = Awaited<ReturnType<typeof logoutZfpSso>>, TError = unknown>(
 params: LogoutZfpSsoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutZfpSso>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof logoutZfpSso>>,
          TError,
          Awaited<ReturnType<typeof logoutZfpSso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogoutZfpSso<TData = Awaited<ReturnType<typeof logoutZfpSso>>, TError = unknown>(
 params: LogoutZfpSsoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutZfpSso>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof logoutZfpSso>>,
          TError,
          Awaited<ReturnType<typeof logoutZfpSso>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLogoutZfpSso<TData = Awaited<ReturnType<typeof logoutZfpSso>>, TError = unknown>(
 params: LogoutZfpSsoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutZfpSso>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useLogoutZfpSso<TData = Awaited<ReturnType<typeof logoutZfpSso>>, TError = unknown>(
 params: LogoutZfpSsoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof logoutZfpSso>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLogoutZfpSsoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @deprecated
 * @summary Redirect back from Microsoft oauth
 */
export const loginZfpSsoCallback = (
    params: LoginZfpSsoCallbackParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<unknown>(
      {url: `/v1/auth/login/zfp-sso/callback`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getLoginZfpSsoCallbackQueryKey = (params?: LoginZfpSsoCallbackParams,) => {
    return [
    `/v1/auth/login/zfp-sso/callback`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getLoginZfpSsoCallbackQueryOptions = <TData = Awaited<ReturnType<typeof loginZfpSsoCallback>>, TError = void>(params: LoginZfpSsoCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginZfpSsoCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoginZfpSsoCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loginZfpSsoCallback>>> = ({ signal }) => loginZfpSsoCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loginZfpSsoCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LoginZfpSsoCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof loginZfpSsoCallback>>>
export type LoginZfpSsoCallbackQueryError = void


export function useLoginZfpSsoCallback<TData = Awaited<ReturnType<typeof loginZfpSsoCallback>>, TError = void>(
 params: LoginZfpSsoCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginZfpSsoCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginZfpSsoCallback>>,
          TError,
          Awaited<ReturnType<typeof loginZfpSsoCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginZfpSsoCallback<TData = Awaited<ReturnType<typeof loginZfpSsoCallback>>, TError = void>(
 params: LoginZfpSsoCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginZfpSsoCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginZfpSsoCallback>>,
          TError,
          Awaited<ReturnType<typeof loginZfpSsoCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginZfpSsoCallback<TData = Awaited<ReturnType<typeof loginZfpSsoCallback>>, TError = void>(
 params: LoginZfpSsoCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginZfpSsoCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 * @summary Redirect back from Microsoft oauth
 */

export function useLoginZfpSsoCallback<TData = Awaited<ReturnType<typeof loginZfpSsoCallback>>, TError = void>(
 params: LoginZfpSsoCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginZfpSsoCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoginZfpSsoCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Redirect back from nSure login
 */
export const loginNsureCallback = (
    sessionToken: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<unknown>(
      {url: `/v1/auth/login/nsure/callback/${sessionToken}`, method: 'GET', signal
    },
      options);
    }
  



export const getLoginNsureCallbackQueryKey = (sessionToken?: string,) => {
    return [
    `/v1/auth/login/nsure/callback/${sessionToken}`
    ] as const;
    }

    
export const getLoginNsureCallbackQueryOptions = <TData = Awaited<ReturnType<typeof loginNsureCallback>>, TError = void>(sessionToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginNsureCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoginNsureCallbackQueryKey(sessionToken);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loginNsureCallback>>> = ({ signal }) => loginNsureCallback(sessionToken, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(sessionToken), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loginNsureCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LoginNsureCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof loginNsureCallback>>>
export type LoginNsureCallbackQueryError = void


export function useLoginNsureCallback<TData = Awaited<ReturnType<typeof loginNsureCallback>>, TError = void>(
 sessionToken: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginNsureCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginNsureCallback>>,
          TError,
          Awaited<ReturnType<typeof loginNsureCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginNsureCallback<TData = Awaited<ReturnType<typeof loginNsureCallback>>, TError = void>(
 sessionToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginNsureCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loginNsureCallback>>,
          TError,
          Awaited<ReturnType<typeof loginNsureCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLoginNsureCallback<TData = Awaited<ReturnType<typeof loginNsureCallback>>, TError = void>(
 sessionToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginNsureCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Redirect back from nSure login
 */

export function useLoginNsureCallback<TData = Awaited<ReturnType<typeof loginNsureCallback>>, TError = void>(
 sessionToken: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loginNsureCallback>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLoginNsureCallbackQueryOptions(sessionToken,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const userProfile = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<UserProfile>(
      {url: `/v1/users/me`, method: 'GET', signal
    },
      options);
    }
  



export const getUserProfileQueryKey = () => {
    return [
    `/v1/users/me`
    ] as const;
    }

    
export const getUserProfileQueryOptions = <TData = Awaited<ReturnType<typeof userProfile>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userProfile>>> = ({ signal }) => userProfile(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof userProfile>>>
export type UserProfileQueryError = unknown


export function useUserProfile<TData = Awaited<ReturnType<typeof userProfile>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userProfile>>,
          TError,
          Awaited<ReturnType<typeof userProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserProfile<TData = Awaited<ReturnType<typeof userProfile>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userProfile>>,
          TError,
          Awaited<ReturnType<typeof userProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserProfile<TData = Awaited<ReturnType<typeof userProfile>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserProfile<TData = Awaited<ReturnType<typeof userProfile>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * The agents the UI offers when sharing an analysis
 */
export const listCollaborators = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<CollaboratorList>(
      {url: `/v1/users/me/collaborators`, method: 'GET', signal
    },
      options);
    }
  



export const getListCollaboratorsQueryKey = () => {
    return [
    `/v1/users/me/collaborators`
    ] as const;
    }

    
export const getListCollaboratorsQueryOptions = <TData = Awaited<ReturnType<typeof listCollaborators>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCollaboratorsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCollaborators>>> = ({ signal }) => listCollaborators(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCollaboratorsQueryResult = NonNullable<Awaited<ReturnType<typeof listCollaborators>>>
export type ListCollaboratorsQueryError = unknown


export function useListCollaborators<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCollaborators>>,
          TError,
          Awaited<ReturnType<typeof listCollaborators>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCollaborators<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCollaborators>>,
          TError,
          Awaited<ReturnType<typeof listCollaborators>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCollaborators<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCollaborators<TData = Awaited<ReturnType<typeof listCollaborators>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollaborators>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCollaboratorsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Adds an agent to the caller's group of at most 5 collaborators - idempotent
 */
export const addCollaborator = (
    addCollaboratorBody: AddCollaboratorBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/users/me/collaborators`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addCollaboratorBody, signal
    },
      options);
    }
  


export const getAddCollaboratorMutationOptions = <TError = AddCollaboratorBadRequestError | AddCollaboratorNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCollaborator>>, TError,{data: AddCollaboratorBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addCollaborator>>, TError,{data: AddCollaboratorBody}, TContext> => {

const mutationKey = ['addCollaborator'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCollaborator>>, {data: AddCollaboratorBody}> = (props) => {
          const {data} = props ?? {};

          return  addCollaborator(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddCollaboratorMutationResult = NonNullable<Awaited<ReturnType<typeof addCollaborator>>>
    export type AddCollaboratorMutationBody = AddCollaboratorBody
    export type AddCollaboratorMutationError = AddCollaboratorBadRequestError | AddCollaboratorNotFoundError

    export const useAddCollaborator = <TError = AddCollaboratorBadRequestError | AddCollaboratorNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCollaborator>>, TError,{data: AddCollaboratorBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCollaborator>>,
        TError,
        {data: AddCollaboratorBody},
        TContext
      > => {

      const mutationOptions = getAddCollaboratorMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Finds exactly one Analyzer agent by their OS number (SSO id)
 */
export const searchCollaboratorBySsoId = (
    params: SearchCollaboratorBySsoIdParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AgentSummary>(
      {url: `/v1/users/me/collaborators/search`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSearchCollaboratorBySsoIdQueryKey = (params?: SearchCollaboratorBySsoIdParams,) => {
    return [
    `/v1/users/me/collaborators/search`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchCollaboratorBySsoIdQueryOptions = <TData = Awaited<ReturnType<typeof searchCollaboratorBySsoId>>, TError = SearchAgentNotFoundError>(params: SearchCollaboratorBySsoIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCollaboratorBySsoId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCollaboratorBySsoIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCollaboratorBySsoId>>> = ({ signal }) => searchCollaboratorBySsoId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCollaboratorBySsoId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchCollaboratorBySsoIdQueryResult = NonNullable<Awaited<ReturnType<typeof searchCollaboratorBySsoId>>>
export type SearchCollaboratorBySsoIdQueryError = SearchAgentNotFoundError


export function useSearchCollaboratorBySsoId<TData = Awaited<ReturnType<typeof searchCollaboratorBySsoId>>, TError = SearchAgentNotFoundError>(
 params: SearchCollaboratorBySsoIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCollaboratorBySsoId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCollaboratorBySsoId>>,
          TError,
          Awaited<ReturnType<typeof searchCollaboratorBySsoId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchCollaboratorBySsoId<TData = Awaited<ReturnType<typeof searchCollaboratorBySsoId>>, TError = SearchAgentNotFoundError>(
 params: SearchCollaboratorBySsoIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCollaboratorBySsoId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCollaboratorBySsoId>>,
          TError,
          Awaited<ReturnType<typeof searchCollaboratorBySsoId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchCollaboratorBySsoId<TData = Awaited<ReturnType<typeof searchCollaboratorBySsoId>>, TError = SearchAgentNotFoundError>(
 params: SearchCollaboratorBySsoIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCollaboratorBySsoId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useSearchCollaboratorBySsoId<TData = Awaited<ReturnType<typeof searchCollaboratorBySsoId>>, TError = SearchAgentNotFoundError>(
 params: SearchCollaboratorBySsoIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCollaboratorBySsoId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchCollaboratorBySsoIdQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const removeCollaborator = (
    userGuid: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/users/me/collaborators/${userGuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getRemoveCollaboratorMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCollaborator>>, TError,{userGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCollaborator>>, TError,{userGuid: string}, TContext> => {

const mutationKey = ['removeCollaborator'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCollaborator>>, {userGuid: string}> = (props) => {
          const {userGuid} = props ?? {};

          return  removeCollaborator(userGuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveCollaboratorMutationResult = NonNullable<Awaited<ReturnType<typeof removeCollaborator>>>
    
    export type RemoveCollaboratorMutationError = unknown

    export const useRemoveCollaborator = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCollaborator>>, TError,{userGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeCollaborator>>,
        TError,
        {userGuid: string},
        TContext
      > => {

      const mutationOptions = getRemoveCollaboratorMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getDashboardSummary = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Summary>(
      {url: `/v1/dashboard/summary`, method: 'GET', signal
    },
      options);
    }
  



export const getGetDashboardSummaryQueryKey = () => {
    return [
    `/v1/dashboard/summary`
    ] as const;
    }

    
export const getGetDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryQueryError = unknown


export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardSummary>>,
          TError,
          Awaited<ReturnType<typeof getDashboardSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardSummary>>,
          TError,
          Awaited<ReturnType<typeof getDashboardSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getDashboardGraph = (
    params?: GetDashboardGraphParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Graph>(
      {url: `/v1/dashboard/graph`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetDashboardGraphQueryKey = (params?: GetDashboardGraphParams,) => {
    return [
    `/v1/dashboard/graph`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDashboardGraphQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardGraph>>, TError = unknown>(params?: GetDashboardGraphParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardGraph>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardGraphQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardGraph>>> = ({ signal }) => getDashboardGraph(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardGraph>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDashboardGraphQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardGraph>>>
export type GetDashboardGraphQueryError = unknown


export function useGetDashboardGraph<TData = Awaited<ReturnType<typeof getDashboardGraph>>, TError = unknown>(
 params: undefined |  GetDashboardGraphParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardGraph>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardGraph>>,
          TError,
          Awaited<ReturnType<typeof getDashboardGraph>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardGraph<TData = Awaited<ReturnType<typeof getDashboardGraph>>, TError = unknown>(
 params?: GetDashboardGraphParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardGraph>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDashboardGraph>>,
          TError,
          Awaited<ReturnType<typeof getDashboardGraph>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDashboardGraph<TData = Awaited<ReturnType<typeof getDashboardGraph>>, TError = unknown>(
 params?: GetDashboardGraphParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardGraph>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDashboardGraph<TData = Awaited<ReturnType<typeof getDashboardGraph>>, TError = unknown>(
 params?: GetDashboardGraphParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDashboardGraph>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDashboardGraphQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createClient = (
    createClientBody: CreateClientBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<CreateClient201>(
      {url: `/v1/clients`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClientBody, signal
    },
      options);
    }
  


export const getCreateClientMutationOptions = <TError = CreateClientBadRequestError | AttachRelatedClientNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClient>>, TError,{data: CreateClientBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createClient>>, TError,{data: CreateClientBody}, TContext> => {

const mutationKey = ['createClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClient>>, {data: CreateClientBody}> = (props) => {
          const {data} = props ?? {};

          return  createClient(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateClientMutationResult = NonNullable<Awaited<ReturnType<typeof createClient>>>
    export type CreateClientMutationBody = CreateClientBody
    export type CreateClientMutationError = CreateClientBadRequestError | AttachRelatedClientNotFoundError

    export const useCreateClient = <TError = CreateClientBadRequestError | AttachRelatedClientNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClient>>, TError,{data: CreateClientBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createClient>>,
        TError,
        {data: CreateClientBody},
        TContext
      > => {

      const mutationOptions = getCreateClientMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateClient = (
    clientGuid: string,
    updateClientBody: UpdateClientBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<UpdateClient200>(
      {url: `/v1/clients/${clientGuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateClientBody
    },
      options);
    }
  


export const getUpdateClientMutationOptions = <TError = UpdateClientBadRequestError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClient>>, TError,{clientGuid: string;data: UpdateClientBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateClient>>, TError,{clientGuid: string;data: UpdateClientBody}, TContext> => {

const mutationKey = ['updateClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateClient>>, {clientGuid: string;data: UpdateClientBody}> = (props) => {
          const {clientGuid,data} = props ?? {};

          return  updateClient(clientGuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateClientMutationResult = NonNullable<Awaited<ReturnType<typeof updateClient>>>
    export type UpdateClientMutationBody = UpdateClientBody
    export type UpdateClientMutationError = UpdateClientBadRequestError

    export const useUpdateClient = <TError = UpdateClientBadRequestError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateClient>>, TError,{clientGuid: string;data: UpdateClientBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateClient>>,
        TError,
        {clientGuid: string;data: UpdateClientBody},
        TContext
      > => {

      const mutationOptions = getUpdateClientMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteClient = (
    clientGuid: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<unknown>(
      {url: `/v1/clients/${clientGuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteClientMutationOptions = <TError = DeleteClientBadRequestError | NoClientError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClient>>, TError,{clientGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteClient>>, TError,{clientGuid: string}, TContext> => {

const mutationKey = ['deleteClient'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteClient>>, {clientGuid: string}> = (props) => {
          const {clientGuid} = props ?? {};

          return  deleteClient(clientGuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteClientMutationResult = NonNullable<Awaited<ReturnType<typeof deleteClient>>>
    
    export type DeleteClientMutationError = DeleteClientBadRequestError | NoClientError

    export const useDeleteClient = <TError = DeleteClientBadRequestError | NoClientError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteClient>>, TError,{clientGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteClient>>,
        TError,
        {clientGuid: string},
        TContext
      > => {

      const mutationOptions = getDeleteClientMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const clientDetail = (
    clientGuid: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ClientDetailResponse>(
      {url: `/v1/clients/${clientGuid}`, method: 'GET', signal
    },
      options);
    }
  



export const getClientDetailQueryKey = (clientGuid?: string,) => {
    return [
    `/v1/clients/${clientGuid}`
    ] as const;
    }

    
export const getClientDetailQueryOptions = <TData = Awaited<ReturnType<typeof clientDetail>>, TError = ClientDetailBadRequestError | ClientDetailNotFoundError>(clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getClientDetailQueryKey(clientGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof clientDetail>>> = ({ signal }) => clientDetail(clientGuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clientGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof clientDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ClientDetailQueryResult = NonNullable<Awaited<ReturnType<typeof clientDetail>>>
export type ClientDetailQueryError = ClientDetailBadRequestError | ClientDetailNotFoundError


export function useClientDetail<TData = Awaited<ReturnType<typeof clientDetail>>, TError = ClientDetailBadRequestError | ClientDetailNotFoundError>(
 clientGuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientDetail>>,
          TError,
          Awaited<ReturnType<typeof clientDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientDetail<TData = Awaited<ReturnType<typeof clientDetail>>, TError = ClientDetailBadRequestError | ClientDetailNotFoundError>(
 clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof clientDetail>>,
          TError,
          Awaited<ReturnType<typeof clientDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useClientDetail<TData = Awaited<ReturnType<typeof clientDetail>>, TError = ClientDetailBadRequestError | ClientDetailNotFoundError>(
 clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useClientDetail<TData = Awaited<ReturnType<typeof clientDetail>>, TError = ClientDetailBadRequestError | ClientDetailNotFoundError>(
 clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof clientDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getClientDetailQueryOptions(clientGuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const searchClients = (
    searchClients: SearchClients,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<SearchClientsResult>(
      {url: `/v1/clients/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchClients, signal
    },
      options);
    }
  


export const getSearchClientsMutationOptions = <TError = UserIsNotAdvisorError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchClients>>, TError,{data: SearchClients}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof searchClients>>, TError,{data: SearchClients}, TContext> => {

const mutationKey = ['searchClients'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchClients>>, {data: SearchClients}> = (props) => {
          const {data} = props ?? {};

          return  searchClients(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SearchClientsMutationResult = NonNullable<Awaited<ReturnType<typeof searchClients>>>
    export type SearchClientsMutationBody = SearchClients
    export type SearchClientsMutationError = UserIsNotAdvisorError

    export const useSearchClients = <TError = UserIsNotAdvisorError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchClients>>, TError,{data: SearchClients}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchClients>>,
        TError,
        {data: SearchClients},
        TContext
      > => {

      const mutationOptions = getSearchClientsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Exact birth-number lookup across all of Mango, to run before creating a Mango client. A POST so the birth number stays out of URLs and access logs.
 */
export const lookupClientByBirthNumber = (
    lookupByBirthNumber: LookupByBirthNumber,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<BirthNumberLookupResult>(
      {url: `/v1/clients/lookup-by-birth-number`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: lookupByBirthNumber, signal
    },
      options);
    }
  


export const getLookupClientByBirthNumberMutationOptions = <TError = LookupByBirthNumberBadRequestError | UserIsNotAdvisorError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lookupClientByBirthNumber>>, TError,{data: LookupByBirthNumber}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof lookupClientByBirthNumber>>, TError,{data: LookupByBirthNumber}, TContext> => {

const mutationKey = ['lookupClientByBirthNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lookupClientByBirthNumber>>, {data: LookupByBirthNumber}> = (props) => {
          const {data} = props ?? {};

          return  lookupClientByBirthNumber(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LookupClientByBirthNumberMutationResult = NonNullable<Awaited<ReturnType<typeof lookupClientByBirthNumber>>>
    export type LookupClientByBirthNumberMutationBody = LookupByBirthNumber
    export type LookupClientByBirthNumberMutationError = LookupByBirthNumberBadRequestError | UserIsNotAdvisorError

    export const useLookupClientByBirthNumber = <TError = LookupByBirthNumberBadRequestError | UserIsNotAdvisorError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lookupClientByBirthNumber>>, TError,{data: LookupByBirthNumber}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof lookupClientByBirthNumber>>,
        TError,
        {data: LookupByBirthNumber},
        TContext
      > => {

      const mutationOptions = getLookupClientByBirthNumberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createAnalysis = (
    createAnalysisBody: CreateAnalysisBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<CreateAnalysisResult>(
      {url: `/v1/analyses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAnalysisBody, signal
    },
      options);
    }
  


export const getCreateAnalysisMutationOptions = <TError = CreateAnalysisBadRequestError | CreateAnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysis>>, TError,{data: CreateAnalysisBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAnalysis>>, TError,{data: CreateAnalysisBody}, TContext> => {

const mutationKey = ['createAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnalysis>>, {data: CreateAnalysisBody}> = (props) => {
          const {data} = props ?? {};

          return  createAnalysis(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof createAnalysis>>>
    export type CreateAnalysisMutationBody = CreateAnalysisBody
    export type CreateAnalysisMutationError = CreateAnalysisBadRequestError | CreateAnalysisNotFoundError

    export const useCreateAnalysis = <TError = CreateAnalysisBadRequestError | CreateAnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysis>>, TError,{data: CreateAnalysisBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAnalysis>>,
        TError,
        {data: CreateAnalysisBody},
        TContext
      > => {

      const mutationOptions = getCreateAnalysisMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAnalysisByInvestmentCaseId = (
    caseId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AnalysisDetail>(
      {url: `/v1/analyses/by-investment-case-id/${caseId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAnalysisByInvestmentCaseIdQueryKey = (caseId?: string,) => {
    return [
    `/v1/analyses/by-investment-case-id/${caseId}`
    ] as const;
    }

    
export const getGetAnalysisByInvestmentCaseIdQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>, TError = GetAnalysisByCaseIdNotFoundError>(caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisByInvestmentCaseIdQueryKey(caseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>> = ({ signal }) => getAnalysisByInvestmentCaseId(caseId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(caseId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisByInvestmentCaseIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>>
export type GetAnalysisByInvestmentCaseIdQueryError = GetAnalysisByCaseIdNotFoundError


export function useGetAnalysisByInvestmentCaseId<TData = Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>, TError = GetAnalysisByCaseIdNotFoundError>(
 caseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisByInvestmentCaseId<TData = Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>, TError = GetAnalysisByCaseIdNotFoundError>(
 caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisByInvestmentCaseId<TData = Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>, TError = GetAnalysisByCaseIdNotFoundError>(
 caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAnalysisByInvestmentCaseId<TData = Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>, TError = GetAnalysisByCaseIdNotFoundError>(
 caseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisByInvestmentCaseId>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisByInvestmentCaseIdQueryOptions(caseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listAnalysesOverview = (
    params?: ListAnalysesOverviewParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AnalysesOverviewList>(
      {url: `/v1/analyses/overview`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListAnalysesOverviewQueryKey = (params?: ListAnalysesOverviewParams,) => {
    return [
    `/v1/analyses/overview`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListAnalysesOverviewQueryOptions = <TData = Awaited<ReturnType<typeof listAnalysesOverview>>, TError = unknown>(params?: ListAnalysesOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalysesOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnalysesOverviewQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnalysesOverview>>> = ({ signal }) => listAnalysesOverview(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAnalysesOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAnalysesOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof listAnalysesOverview>>>
export type ListAnalysesOverviewQueryError = unknown


export function useListAnalysesOverview<TData = Awaited<ReturnType<typeof listAnalysesOverview>>, TError = unknown>(
 params: undefined |  ListAnalysesOverviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalysesOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnalysesOverview>>,
          TError,
          Awaited<ReturnType<typeof listAnalysesOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnalysesOverview<TData = Awaited<ReturnType<typeof listAnalysesOverview>>, TError = unknown>(
 params?: ListAnalysesOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalysesOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnalysesOverview>>,
          TError,
          Awaited<ReturnType<typeof listAnalysesOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnalysesOverview<TData = Awaited<ReturnType<typeof listAnalysesOverview>>, TError = unknown>(
 params?: ListAnalysesOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalysesOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAnalysesOverview<TData = Awaited<ReturnType<typeof listAnalysesOverview>>, TError = unknown>(
 params?: ListAnalysesOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalysesOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAnalysesOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listClientAnalysisVersions = (
    clientGuid: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ClientAnalysisVersionList>(
      {url: `/v1/analyses/versions/${clientGuid}`, method: 'GET', signal
    },
      options);
    }
  



export const getListClientAnalysisVersionsQueryKey = (clientGuid?: string,) => {
    return [
    `/v1/analyses/versions/${clientGuid}`
    ] as const;
    }

    
export const getListClientAnalysisVersionsQueryOptions = <TData = Awaited<ReturnType<typeof listClientAnalysisVersions>>, TError = unknown>(clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClientAnalysisVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListClientAnalysisVersionsQueryKey(clientGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listClientAnalysisVersions>>> = ({ signal }) => listClientAnalysisVersions(clientGuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clientGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listClientAnalysisVersions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListClientAnalysisVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listClientAnalysisVersions>>>
export type ListClientAnalysisVersionsQueryError = unknown


export function useListClientAnalysisVersions<TData = Awaited<ReturnType<typeof listClientAnalysisVersions>>, TError = unknown>(
 clientGuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClientAnalysisVersions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClientAnalysisVersions>>,
          TError,
          Awaited<ReturnType<typeof listClientAnalysisVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClientAnalysisVersions<TData = Awaited<ReturnType<typeof listClientAnalysisVersions>>, TError = unknown>(
 clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClientAnalysisVersions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listClientAnalysisVersions>>,
          TError,
          Awaited<ReturnType<typeof listClientAnalysisVersions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListClientAnalysisVersions<TData = Awaited<ReturnType<typeof listClientAnalysisVersions>>, TError = unknown>(
 clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClientAnalysisVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListClientAnalysisVersions<TData = Awaited<ReturnType<typeof listClientAnalysisVersions>>, TError = unknown>(
 clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listClientAnalysisVersions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListClientAnalysisVersionsQueryOptions(clientGuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const assignClientToAnalysis = (
    analysisId: string,
    versionId: string,
    assignClientBody: AssignClientBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assign-client`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assignClientBody, signal
    },
      options);
    }
  


export const getAssignClientToAnalysisMutationOptions = <TError = AssignClientBadRequestError | AssignClientNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignClientToAnalysis>>, TError,{analysisId: string;versionId: string;data: AssignClientBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignClientToAnalysis>>, TError,{analysisId: string;versionId: string;data: AssignClientBody}, TContext> => {

const mutationKey = ['assignClientToAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignClientToAnalysis>>, {analysisId: string;versionId: string;data: AssignClientBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  assignClientToAnalysis(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignClientToAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof assignClientToAnalysis>>>
    export type AssignClientToAnalysisMutationBody = AssignClientBody
    export type AssignClientToAnalysisMutationError = AssignClientBadRequestError | AssignClientNotFoundError

    export const useAssignClientToAnalysis = <TError = AssignClientBadRequestError | AssignClientNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignClientToAnalysis>>, TError,{analysisId: string;versionId: string;data: AssignClientBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignClientToAnalysis>>,
        TError,
        {analysisId: string;versionId: string;data: AssignClientBody},
        TContext
      > => {

      const mutationOptions = getAssignClientToAnalysisMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAnalysis = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AnalysisDetail>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAnalysisQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}`
    ] as const;
    }

    
export const getGetAnalysisQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysis>>, TError = GetAnalysisByCaseIdNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysis>>> = ({ signal }) => getAnalysis(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysis>>>
export type GetAnalysisQueryError = GetAnalysisByCaseIdNotFoundError


export function useGetAnalysis<TData = Awaited<ReturnType<typeof getAnalysis>>, TError = GetAnalysisByCaseIdNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getAnalysis>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysis<TData = Awaited<ReturnType<typeof getAnalysis>>, TError = GetAnalysisByCaseIdNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysis>>,
          TError,
          Awaited<ReturnType<typeof getAnalysis>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysis<TData = Awaited<ReturnType<typeof getAnalysis>>, TError = GetAnalysisByCaseIdNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAnalysis<TData = Awaited<ReturnType<typeof getAnalysis>>, TError = GetAnalysisByCaseIdNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysis>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const patchAnalysis = (
    analysisId: string,
    versionId: string,
    patchAnalysisBody: PatchAnalysisBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchAnalysisBody
    },
      options);
    }
  


export const getPatchAnalysisMutationOptions = <TError = PatchAnalysisError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAnalysis>>, TError,{analysisId: string;versionId: string;data: PatchAnalysisBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchAnalysis>>, TError,{analysisId: string;versionId: string;data: PatchAnalysisBody}, TContext> => {

const mutationKey = ['patchAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchAnalysis>>, {analysisId: string;versionId: string;data: PatchAnalysisBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  patchAnalysis(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof patchAnalysis>>>
    export type PatchAnalysisMutationBody = PatchAnalysisBody
    export type PatchAnalysisMutationError = PatchAnalysisError

    export const usePatchAnalysis = <TError = PatchAnalysisError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchAnalysis>>, TError,{analysisId: string;versionId: string;data: PatchAnalysisBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchAnalysis>>,
        TError,
        {analysisId: string;versionId: string;data: PatchAnalysisBody},
        TContext
      > => {

      const mutationOptions = getPatchAnalysisMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createAnalysisInvestmentCase = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AnalysisDetail | void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/investment-case`, method: 'POST', signal
    },
      options);
    }
  


export const getCreateAnalysisInvestmentCaseMutationOptions = <TError = EnsureInvestmentCaseBadRequestError | CreateInvestmentCaseNotFoundError | CreateInvestmentCaseInternalError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysisInvestmentCase>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAnalysisInvestmentCase>>, TError,{analysisId: string;versionId: string}, TContext> => {

const mutationKey = ['createAnalysisInvestmentCase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnalysisInvestmentCase>>, {analysisId: string;versionId: string}> = (props) => {
          const {analysisId,versionId} = props ?? {};

          return  createAnalysisInvestmentCase(analysisId,versionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAnalysisInvestmentCaseMutationResult = NonNullable<Awaited<ReturnType<typeof createAnalysisInvestmentCase>>>
    
    export type CreateAnalysisInvestmentCaseMutationError = EnsureInvestmentCaseBadRequestError | CreateInvestmentCaseNotFoundError | CreateInvestmentCaseInternalError

    export const useCreateAnalysisInvestmentCase = <TError = EnsureInvestmentCaseBadRequestError | CreateInvestmentCaseNotFoundError | CreateInvestmentCaseInternalError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysisInvestmentCase>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAnalysisInvestmentCase>>,
        TError,
        {analysisId: string;versionId: string},
        TContext
      > => {

      const mutationOptions = getCreateAnalysisInvestmentCaseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const cloneAnalysis = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AnalysisVersionSummary>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clone`, method: 'POST', signal
    },
      options);
    }
  


export const getCloneAnalysisMutationOptions = <TError = CloneAnalysisBadRequestError | AnalysisReadOnlyAccessError | CloneAnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneAnalysis>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cloneAnalysis>>, TError,{analysisId: string;versionId: string}, TContext> => {

const mutationKey = ['cloneAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cloneAnalysis>>, {analysisId: string;versionId: string}> = (props) => {
          const {analysisId,versionId} = props ?? {};

          return  cloneAnalysis(analysisId,versionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CloneAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof cloneAnalysis>>>
    
    export type CloneAnalysisMutationError = CloneAnalysisBadRequestError | AnalysisReadOnlyAccessError | CloneAnalysisNotFoundError

    export const useCloneAnalysis = <TError = CloneAnalysisBadRequestError | AnalysisReadOnlyAccessError | CloneAnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cloneAnalysis>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cloneAnalysis>>,
        TError,
        {analysisId: string;versionId: string},
        TContext
      > => {

      const mutationOptions = getCloneAnalysisMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Copies any version of an own analysis into a new version of that same analysis (its latest version must be closed). Any version of an analysis ever shared with the caller is copied into a new analysis owned by the caller - or, when they already have an analysis of the same Mango client, into its new version (its latest version must be closed). That conflict is reported as `analysis_already_exists_for_client`, with the existing analysis' `analysisId` and latest `versionId`, until the request confirms it with `confirmConflict`. Local and related clients of a shared analysis are copied along.
 */
export const duplicateAnalysis = (
    duplicateAnalysisBody: DuplicateAnalysisBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AnalysisVersionSummary>(
      {url: `/v1/analyses/duplicate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: duplicateAnalysisBody, signal
    },
      options);
    }
  


export const getDuplicateAnalysisMutationOptions = <TError = DuplicateAnalysisBadRequestError | DuplicateAnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateAnalysis>>, TError,{data: DuplicateAnalysisBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateAnalysis>>, TError,{data: DuplicateAnalysisBody}, TContext> => {

const mutationKey = ['duplicateAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateAnalysis>>, {data: DuplicateAnalysisBody}> = (props) => {
          const {data} = props ?? {};

          return  duplicateAnalysis(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DuplicateAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateAnalysis>>>
    export type DuplicateAnalysisMutationBody = DuplicateAnalysisBody
    export type DuplicateAnalysisMutationError = DuplicateAnalysisBadRequestError | DuplicateAnalysisNotFoundError

    export const useDuplicateAnalysis = <TError = DuplicateAnalysisBadRequestError | DuplicateAnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateAnalysis>>, TError,{data: DuplicateAnalysisBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof duplicateAnalysis>>,
        TError,
        {data: DuplicateAnalysisBody},
        TContext
      > => {

      const mutationOptions = getDuplicateAnalysisMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setAnalysisOrganizedBy = (
    analysisId: string,
    versionId: string,
    setOrganizedByBody: SetOrganizedByBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/organized-by`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setOrganizedByBody
    },
      options);
    }
  


export const getSetAnalysisOrganizedByMutationOptions = <TError = SetOrganizedByError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAnalysisOrganizedBy>>, TError,{analysisId: string;versionId: string;data: SetOrganizedByBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAnalysisOrganizedBy>>, TError,{analysisId: string;versionId: string;data: SetOrganizedByBody}, TContext> => {

const mutationKey = ['setAnalysisOrganizedBy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAnalysisOrganizedBy>>, {analysisId: string;versionId: string;data: SetOrganizedByBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  setAnalysisOrganizedBy(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetAnalysisOrganizedByMutationResult = NonNullable<Awaited<ReturnType<typeof setAnalysisOrganizedBy>>>
    export type SetAnalysisOrganizedByMutationBody = SetOrganizedByBody
    export type SetAnalysisOrganizedByMutationError = SetOrganizedByError

    export const useSetAnalysisOrganizedBy = <TError = SetOrganizedByError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAnalysisOrganizedBy>>, TError,{analysisId: string;versionId: string;data: SetOrganizedByBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAnalysisOrganizedBy>>,
        TError,
        {analysisId: string;versionId: string;data: SetOrganizedByBody},
        TContext
      > => {

      const mutationOptions = getSetAnalysisOrganizedByMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getGrowUpContractingLink = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<GrowUpLinkResult>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/growup-contracting-link`, method: 'GET', signal
    },
      options);
    }
  



export const getGetGrowUpContractingLinkQueryKey = (analysisId?: string,
    versionId?: string,
    clientGuid?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/growup-contracting-link`
    ] as const;
    }

    
export const getGetGrowUpContractingLinkQueryOptions = <TData = Awaited<ReturnType<typeof getGrowUpContractingLink>>, TError = GetGrowUpLinkNotFoundError>(analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrowUpContractingLink>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGrowUpContractingLinkQueryKey(analysisId,versionId,clientGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGrowUpContractingLink>>> = ({ signal }) => getGrowUpContractingLink(analysisId,versionId,clientGuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && clientGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGrowUpContractingLink>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGrowUpContractingLinkQueryResult = NonNullable<Awaited<ReturnType<typeof getGrowUpContractingLink>>>
export type GetGrowUpContractingLinkQueryError = GetGrowUpLinkNotFoundError


export function useGetGrowUpContractingLink<TData = Awaited<ReturnType<typeof getGrowUpContractingLink>>, TError = GetGrowUpLinkNotFoundError>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrowUpContractingLink>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGrowUpContractingLink>>,
          TError,
          Awaited<ReturnType<typeof getGrowUpContractingLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGrowUpContractingLink<TData = Awaited<ReturnType<typeof getGrowUpContractingLink>>, TError = GetGrowUpLinkNotFoundError>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrowUpContractingLink>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGrowUpContractingLink>>,
          TError,
          Awaited<ReturnType<typeof getGrowUpContractingLink>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGrowUpContractingLink<TData = Awaited<ReturnType<typeof getGrowUpContractingLink>>, TError = GetGrowUpLinkNotFoundError>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrowUpContractingLink>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGrowUpContractingLink<TData = Awaited<ReturnType<typeof getGrowUpContractingLink>>, TError = GetGrowUpLinkNotFoundError>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrowUpContractingLink>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGrowUpContractingLinkQueryOptions(analysisId,versionId,clientGuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const setPortfolioAssetAllocationRequired = (
    analysisId: string,
    versionId: string,
    setPortfolioAssetAllocationRequiredBody: SetPortfolioAssetAllocationRequiredBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/portfolio-asset-allocation-required`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setPortfolioAssetAllocationRequiredBody
    },
      options);
    }
  


export const getSetPortfolioAssetAllocationRequiredMutationOptions = <TError = SetPortfolioAssetAllocationRequiredError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPortfolioAssetAllocationRequired>>, TError,{analysisId: string;versionId: string;data: SetPortfolioAssetAllocationRequiredBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPortfolioAssetAllocationRequired>>, TError,{analysisId: string;versionId: string;data: SetPortfolioAssetAllocationRequiredBody}, TContext> => {

const mutationKey = ['setPortfolioAssetAllocationRequired'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPortfolioAssetAllocationRequired>>, {analysisId: string;versionId: string;data: SetPortfolioAssetAllocationRequiredBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  setPortfolioAssetAllocationRequired(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetPortfolioAssetAllocationRequiredMutationResult = NonNullable<Awaited<ReturnType<typeof setPortfolioAssetAllocationRequired>>>
    export type SetPortfolioAssetAllocationRequiredMutationBody = SetPortfolioAssetAllocationRequiredBody
    export type SetPortfolioAssetAllocationRequiredMutationError = SetPortfolioAssetAllocationRequiredError

    export const useSetPortfolioAssetAllocationRequired = <TError = SetPortfolioAssetAllocationRequiredError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPortfolioAssetAllocationRequired>>, TError,{analysisId: string;versionId: string;data: SetPortfolioAssetAllocationRequiredBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setPortfolioAssetAllocationRequired>>,
        TError,
        {analysisId: string;versionId: string;data: SetPortfolioAssetAllocationRequiredBody},
        TContext
      > => {

      const mutationOptions = getSetPortfolioAssetAllocationRequiredMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setAnalysisState = (
    analysisId: string,
    versionId: string,
    setAnalysisStateBody: SetAnalysisStateBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/state`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setAnalysisStateBody
    },
      options);
    }
  


export const getSetAnalysisStateMutationOptions = <TError = SetAnalysisStateBadRequestError | SetAnalysisStateNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAnalysisState>>, TError,{analysisId: string;versionId: string;data: SetAnalysisStateBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setAnalysisState>>, TError,{analysisId: string;versionId: string;data: SetAnalysisStateBody}, TContext> => {

const mutationKey = ['setAnalysisState'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAnalysisState>>, {analysisId: string;versionId: string;data: SetAnalysisStateBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  setAnalysisState(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetAnalysisStateMutationResult = NonNullable<Awaited<ReturnType<typeof setAnalysisState>>>
    export type SetAnalysisStateMutationBody = SetAnalysisStateBody
    export type SetAnalysisStateMutationError = SetAnalysisStateBadRequestError | SetAnalysisStateNotFoundError

    export const useSetAnalysisState = <TError = SetAnalysisStateBadRequestError | SetAnalysisStateNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAnalysisState>>, TError,{analysisId: string;versionId: string;data: SetAnalysisStateBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAnalysisState>>,
        TError,
        {analysisId: string;versionId: string;data: SetAnalysisStateBody},
        TContext
      > => {

      const mutationOptions = getSetAnalysisStateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const analysisSharedOutputs = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AnalysisSharedOutputs>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/shared-outputs`, method: 'GET', signal
    },
      options);
    }
  



export const getAnalysisSharedOutputsQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/shared-outputs`
    ] as const;
    }

    
export const getAnalysisSharedOutputsQueryOptions = <TData = Awaited<ReturnType<typeof analysisSharedOutputs>>, TError = unknown>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisSharedOutputs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAnalysisSharedOutputsQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof analysisSharedOutputs>>> = ({ signal }) => analysisSharedOutputs(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof analysisSharedOutputs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AnalysisSharedOutputsQueryResult = NonNullable<Awaited<ReturnType<typeof analysisSharedOutputs>>>
export type AnalysisSharedOutputsQueryError = unknown


export function useAnalysisSharedOutputs<TData = Awaited<ReturnType<typeof analysisSharedOutputs>>, TError = unknown>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisSharedOutputs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof analysisSharedOutputs>>,
          TError,
          Awaited<ReturnType<typeof analysisSharedOutputs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnalysisSharedOutputs<TData = Awaited<ReturnType<typeof analysisSharedOutputs>>, TError = unknown>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisSharedOutputs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof analysisSharedOutputs>>,
          TError,
          Awaited<ReturnType<typeof analysisSharedOutputs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnalysisSharedOutputs<TData = Awaited<ReturnType<typeof analysisSharedOutputs>>, TError = unknown>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisSharedOutputs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAnalysisSharedOutputs<TData = Awaited<ReturnType<typeof analysisSharedOutputs>>, TError = unknown>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisSharedOutputs>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAnalysisSharedOutputsQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const analysisPdf = (
    analysisId: string,
    versionId: string,
    params?: AnalysisPdfParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Blob>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/pdf`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  



export const getAnalysisPdfQueryKey = (analysisId?: string,
    versionId?: string,
    params?: AnalysisPdfParams,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/pdf`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAnalysisPdfQueryOptions = <TData = Awaited<ReturnType<typeof analysisPdf>>, TError = PdfFileError>(analysisId: string,
    versionId: string,
    params?: AnalysisPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisPdf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAnalysisPdfQueryKey(analysisId,versionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof analysisPdf>>> = ({ signal }) => analysisPdf(analysisId,versionId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof analysisPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AnalysisPdfQueryResult = NonNullable<Awaited<ReturnType<typeof analysisPdf>>>
export type AnalysisPdfQueryError = PdfFileError


export function useAnalysisPdf<TData = Awaited<ReturnType<typeof analysisPdf>>, TError = PdfFileError>(
 analysisId: string,
    versionId: string,
    params: undefined |  AnalysisPdfParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof analysisPdf>>,
          TError,
          Awaited<ReturnType<typeof analysisPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnalysisPdf<TData = Awaited<ReturnType<typeof analysisPdf>>, TError = PdfFileError>(
 analysisId: string,
    versionId: string,
    params?: AnalysisPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof analysisPdf>>,
          TError,
          Awaited<ReturnType<typeof analysisPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnalysisPdf<TData = Awaited<ReturnType<typeof analysisPdf>>, TError = PdfFileError>(
 analysisId: string,
    versionId: string,
    params?: AnalysisPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisPdf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAnalysisPdf<TData = Awaited<ReturnType<typeof analysisPdf>>, TError = PdfFileError>(
 analysisId: string,
    versionId: string,
    params?: AnalysisPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisPdf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAnalysisPdfQueryOptions(analysisId,versionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const emailAnalysisPdf = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/email-pdf`, method: 'POST', signal
    },
      options);
    }
  


export const getEmailAnalysisPdfMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailAnalysisPdf>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof emailAnalysisPdf>>, TError,{analysisId: string;versionId: string}, TContext> => {

const mutationKey = ['emailAnalysisPdf'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailAnalysisPdf>>, {analysisId: string;versionId: string}> = (props) => {
          const {analysisId,versionId} = props ?? {};

          return  emailAnalysisPdf(analysisId,versionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EmailAnalysisPdfMutationResult = NonNullable<Awaited<ReturnType<typeof emailAnalysisPdf>>>
    
    export type EmailAnalysisPdfMutationError = unknown

    export const useEmailAnalysisPdf = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailAnalysisPdf>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof emailAnalysisPdf>>,
        TError,
        {analysisId: string;versionId: string},
        TContext
      > => {

      const mutationOptions = getEmailAnalysisPdfMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const shareShannonAnalysisPdf = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/shannon-pdf`, method: 'POST', signal
    },
      options);
    }
  


export const getShareShannonAnalysisPdfMutationOptions = <TError = SharePdfForbiddenError | SharePdfError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareShannonAnalysisPdf>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shareShannonAnalysisPdf>>, TError,{analysisId: string;versionId: string}, TContext> => {

const mutationKey = ['shareShannonAnalysisPdf'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareShannonAnalysisPdf>>, {analysisId: string;versionId: string}> = (props) => {
          const {analysisId,versionId} = props ?? {};

          return  shareShannonAnalysisPdf(analysisId,versionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShareShannonAnalysisPdfMutationResult = NonNullable<Awaited<ReturnType<typeof shareShannonAnalysisPdf>>>
    
    export type ShareShannonAnalysisPdfMutationError = SharePdfForbiddenError | SharePdfError

    export const useShareShannonAnalysisPdf = <TError = SharePdfForbiddenError | SharePdfError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareShannonAnalysisPdf>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shareShannonAnalysisPdf>>,
        TError,
        {analysisId: string;versionId: string},
        TContext
      > => {

      const mutationOptions = getShareShannonAnalysisPdfMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteShannonAnalysisPdfSharing = (
    pdfGuid: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/shannon-pdf/${pdfGuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteShannonAnalysisPdfSharingMutationOptions = <TError = SharePdfForbiddenError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShannonAnalysisPdfSharing>>, TError,{pdfGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteShannonAnalysisPdfSharing>>, TError,{pdfGuid: string}, TContext> => {

const mutationKey = ['deleteShannonAnalysisPdfSharing'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteShannonAnalysisPdfSharing>>, {pdfGuid: string}> = (props) => {
          const {pdfGuid} = props ?? {};

          return  deleteShannonAnalysisPdfSharing(pdfGuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteShannonAnalysisPdfSharingMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShannonAnalysisPdfSharing>>>
    
    export type DeleteShannonAnalysisPdfSharingMutationError = SharePdfForbiddenError

    export const useDeleteShannonAnalysisPdfSharing = <TError = SharePdfForbiddenError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShannonAnalysisPdfSharing>>, TError,{pdfGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteShannonAnalysisPdfSharing>>,
        TError,
        {pdfGuid: string},
        TContext
      > => {

      const mutationOptions = getDeleteShannonAnalysisPdfSharingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAnalysisClients = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AnalysisClientListResult>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAnalysisClientsQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/clients`
    ] as const;
    }

    
export const getGetAnalysisClientsQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisClients>>, TError = GetAnalysisClientsNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisClients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisClientsQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisClients>>> = ({ signal }) => getAnalysisClients(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisClients>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisClientsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisClients>>>
export type GetAnalysisClientsQueryError = GetAnalysisClientsNotFoundError


export function useGetAnalysisClients<TData = Awaited<ReturnType<typeof getAnalysisClients>>, TError = GetAnalysisClientsNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisClients>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisClients>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisClients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisClients<TData = Awaited<ReturnType<typeof getAnalysisClients>>, TError = GetAnalysisClientsNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisClients>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisClients>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisClients>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisClients<TData = Awaited<ReturnType<typeof getAnalysisClients>>, TError = GetAnalysisClientsNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisClients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAnalysisClients<TData = Awaited<ReturnType<typeof getAnalysisClients>>, TError = GetAnalysisClientsNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisClients>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisClientsQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const rejectAnalysisInvestmentCase = (
    analysisId: string,
    versionId: string,
    rejectCaseBody: RejectCaseBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/reject-investment-case`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rejectCaseBody, signal
    },
      options);
    }
  


export const getRejectAnalysisInvestmentCaseMutationOptions = <TError = RejectCaseNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAnalysisInvestmentCase>>, TError,{analysisId: string;versionId: string;data: RejectCaseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectAnalysisInvestmentCase>>, TError,{analysisId: string;versionId: string;data: RejectCaseBody}, TContext> => {

const mutationKey = ['rejectAnalysisInvestmentCase'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectAnalysisInvestmentCase>>, {analysisId: string;versionId: string;data: RejectCaseBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  rejectAnalysisInvestmentCase(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RejectAnalysisInvestmentCaseMutationResult = NonNullable<Awaited<ReturnType<typeof rejectAnalysisInvestmentCase>>>
    export type RejectAnalysisInvestmentCaseMutationBody = RejectCaseBody
    export type RejectAnalysisInvestmentCaseMutationError = RejectCaseNotFoundError

    export const useRejectAnalysisInvestmentCase = <TError = RejectCaseNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectAnalysisInvestmentCase>>, TError,{analysisId: string;versionId: string;data: RejectCaseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectAnalysisInvestmentCase>>,
        TError,
        {analysisId: string;versionId: string;data: RejectCaseBody},
        TContext
      > => {

      const mutationOptions = getRejectAnalysisInvestmentCaseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listRejectedInvestmentCases = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<RejectedCasesList>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/rejected-investment-cases`, method: 'GET', signal
    },
      options);
    }
  



export const getListRejectedInvestmentCasesQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/rejected-investment-cases`
    ] as const;
    }

    
export const getListRejectedInvestmentCasesQueryOptions = <TData = Awaited<ReturnType<typeof listRejectedInvestmentCases>>, TError = ListRejectedCasesNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRejectedInvestmentCases>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRejectedInvestmentCasesQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRejectedInvestmentCases>>> = ({ signal }) => listRejectedInvestmentCases(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRejectedInvestmentCases>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRejectedInvestmentCasesQueryResult = NonNullable<Awaited<ReturnType<typeof listRejectedInvestmentCases>>>
export type ListRejectedInvestmentCasesQueryError = ListRejectedCasesNotFoundError


export function useListRejectedInvestmentCases<TData = Awaited<ReturnType<typeof listRejectedInvestmentCases>>, TError = ListRejectedCasesNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRejectedInvestmentCases>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRejectedInvestmentCases>>,
          TError,
          Awaited<ReturnType<typeof listRejectedInvestmentCases>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRejectedInvestmentCases<TData = Awaited<ReturnType<typeof listRejectedInvestmentCases>>, TError = ListRejectedCasesNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRejectedInvestmentCases>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRejectedInvestmentCases>>,
          TError,
          Awaited<ReturnType<typeof listRejectedInvestmentCases>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRejectedInvestmentCases<TData = Awaited<ReturnType<typeof listRejectedInvestmentCases>>, TError = ListRejectedCasesNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRejectedInvestmentCases>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListRejectedInvestmentCases<TData = Awaited<ReturnType<typeof listRejectedInvestmentCases>>, TError = ListRejectedCasesNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRejectedInvestmentCases>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRejectedInvestmentCasesQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAnalysisInvestmentStates = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<NsureClientCaseState[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/investment-states`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAnalysisInvestmentStatesQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/investment-states`
    ] as const;
    }

    
export const getGetAnalysisInvestmentStatesQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisInvestmentStates>>, TError = GetNsureStatesNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisInvestmentStates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisInvestmentStatesQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisInvestmentStates>>> = ({ signal }) => getAnalysisInvestmentStates(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisInvestmentStates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisInvestmentStatesQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisInvestmentStates>>>
export type GetAnalysisInvestmentStatesQueryError = GetNsureStatesNotFoundError


export function useGetAnalysisInvestmentStates<TData = Awaited<ReturnType<typeof getAnalysisInvestmentStates>>, TError = GetNsureStatesNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisInvestmentStates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisInvestmentStates>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisInvestmentStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisInvestmentStates<TData = Awaited<ReturnType<typeof getAnalysisInvestmentStates>>, TError = GetNsureStatesNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisInvestmentStates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisInvestmentStates>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisInvestmentStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisInvestmentStates<TData = Awaited<ReturnType<typeof getAnalysisInvestmentStates>>, TError = GetNsureStatesNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisInvestmentStates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAnalysisInvestmentStates<TData = Awaited<ReturnType<typeof getAnalysisInvestmentStates>>, TError = GetNsureStatesNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisInvestmentStates>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisInvestmentStatesQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listAnalysisDocuments = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<DocumentsList>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/documents`, method: 'GET', signal
    },
      options);
    }
  



export const getListAnalysisDocumentsQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/documents`
    ] as const;
    }

    
export const getListAnalysisDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listAnalysisDocuments>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalysisDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnalysisDocumentsQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnalysisDocuments>>> = ({ signal }) => listAnalysisDocuments(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAnalysisDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAnalysisDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAnalysisDocuments>>>
export type ListAnalysisDocumentsQueryError = AnalysisNotFoundError


export function useListAnalysisDocuments<TData = Awaited<ReturnType<typeof listAnalysisDocuments>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalysisDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnalysisDocuments>>,
          TError,
          Awaited<ReturnType<typeof listAnalysisDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnalysisDocuments<TData = Awaited<ReturnType<typeof listAnalysisDocuments>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalysisDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnalysisDocuments>>,
          TError,
          Awaited<ReturnType<typeof listAnalysisDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnalysisDocuments<TData = Awaited<ReturnType<typeof listAnalysisDocuments>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalysisDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAnalysisDocuments<TData = Awaited<ReturnType<typeof listAnalysisDocuments>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalysisDocuments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAnalysisDocumentsQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAnalysisDocumentFile = (
    analysisId: string,
    versionId: string,
    documentGuid: string,
    params?: GetAnalysisDocumentFileParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Blob>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/documents/${documentGuid}/file`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  



export const getGetAnalysisDocumentFileQueryKey = (analysisId?: string,
    versionId?: string,
    documentGuid?: string,
    params?: GetAnalysisDocumentFileParams,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/documents/${documentGuid}/file`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAnalysisDocumentFileQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisDocumentFile>>, TError = DocumentNotFoundError>(analysisId: string,
    versionId: string,
    documentGuid: string,
    params?: GetAnalysisDocumentFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisDocumentFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisDocumentFileQueryKey(analysisId,versionId,documentGuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisDocumentFile>>> = ({ signal }) => getAnalysisDocumentFile(analysisId,versionId,documentGuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && documentGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisDocumentFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisDocumentFileQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisDocumentFile>>>
export type GetAnalysisDocumentFileQueryError = DocumentNotFoundError


export function useGetAnalysisDocumentFile<TData = Awaited<ReturnType<typeof getAnalysisDocumentFile>>, TError = DocumentNotFoundError>(
 analysisId: string,
    versionId: string,
    documentGuid: string,
    params: undefined |  GetAnalysisDocumentFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisDocumentFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisDocumentFile>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisDocumentFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisDocumentFile<TData = Awaited<ReturnType<typeof getAnalysisDocumentFile>>, TError = DocumentNotFoundError>(
 analysisId: string,
    versionId: string,
    documentGuid: string,
    params?: GetAnalysisDocumentFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisDocumentFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisDocumentFile>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisDocumentFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisDocumentFile<TData = Awaited<ReturnType<typeof getAnalysisDocumentFile>>, TError = DocumentNotFoundError>(
 analysisId: string,
    versionId: string,
    documentGuid: string,
    params?: GetAnalysisDocumentFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisDocumentFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAnalysisDocumentFile<TData = Awaited<ReturnType<typeof getAnalysisDocumentFile>>, TError = DocumentNotFoundError>(
 analysisId: string,
    versionId: string,
    documentGuid: string,
    params?: GetAnalysisDocumentFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisDocumentFile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisDocumentFileQueryOptions(analysisId,versionId,documentGuid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAnalysisQuestionnaire = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Questionnaire>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAnalysisQuestionnaireQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire`
    ] as const;
    }

    
export const getGetAnalysisQuestionnaireQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisQuestionnaire>>, TError = EnsureInvestmentCaseBadRequestError | GetQuestionnaireNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisQuestionnaireQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisQuestionnaire>>> = ({ signal }) => getAnalysisQuestionnaire(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaire>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisQuestionnaireQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisQuestionnaire>>>
export type GetAnalysisQuestionnaireQueryError = EnsureInvestmentCaseBadRequestError | GetQuestionnaireNotFoundError


export function useGetAnalysisQuestionnaire<TData = Awaited<ReturnType<typeof getAnalysisQuestionnaire>>, TError = EnsureInvestmentCaseBadRequestError | GetQuestionnaireNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaire>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisQuestionnaire<TData = Awaited<ReturnType<typeof getAnalysisQuestionnaire>>, TError = EnsureInvestmentCaseBadRequestError | GetQuestionnaireNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaire>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisQuestionnaire>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisQuestionnaire>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisQuestionnaire<TData = Awaited<ReturnType<typeof getAnalysisQuestionnaire>>, TError = EnsureInvestmentCaseBadRequestError | GetQuestionnaireNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAnalysisQuestionnaire<TData = Awaited<ReturnType<typeof getAnalysisQuestionnaire>>, TError = EnsureInvestmentCaseBadRequestError | GetQuestionnaireNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaire>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisQuestionnaireQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const analysisQuestionnaireEmptyPdf = (
    analysisId: string,
    versionId: string,
    params?: AnalysisQuestionnaireEmptyPdfParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Blob>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/pdf-empty`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  



export const getAnalysisQuestionnaireEmptyPdfQueryKey = (analysisId?: string,
    versionId?: string,
    params?: AnalysisQuestionnaireEmptyPdfParams,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/pdf-empty`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAnalysisQuestionnaireEmptyPdfQueryOptions = <TData = Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>, TError = QuestionnairePdfNotFoundError>(analysisId: string,
    versionId: string,
    params?: AnalysisQuestionnaireEmptyPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAnalysisQuestionnaireEmptyPdfQueryKey(analysisId,versionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>> = ({ signal }) => analysisQuestionnaireEmptyPdf(analysisId,versionId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AnalysisQuestionnaireEmptyPdfQueryResult = NonNullable<Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>>
export type AnalysisQuestionnaireEmptyPdfQueryError = QuestionnairePdfNotFoundError


export function useAnalysisQuestionnaireEmptyPdf<TData = Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>, TError = QuestionnairePdfNotFoundError>(
 analysisId: string,
    versionId: string,
    params: undefined |  AnalysisQuestionnaireEmptyPdfParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>,
          TError,
          Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnalysisQuestionnaireEmptyPdf<TData = Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>, TError = QuestionnairePdfNotFoundError>(
 analysisId: string,
    versionId: string,
    params?: AnalysisQuestionnaireEmptyPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>,
          TError,
          Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnalysisQuestionnaireEmptyPdf<TData = Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>, TError = QuestionnairePdfNotFoundError>(
 analysisId: string,
    versionId: string,
    params?: AnalysisQuestionnaireEmptyPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAnalysisQuestionnaireEmptyPdf<TData = Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>, TError = QuestionnairePdfNotFoundError>(
 analysisId: string,
    versionId: string,
    params?: AnalysisQuestionnaireEmptyPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnaireEmptyPdf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAnalysisQuestionnaireEmptyPdfQueryOptions(analysisId,versionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const emailAnalysisQuestionnaireEmptyPdf = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/email-pdf-empty`, method: 'POST', signal
    },
      options);
    }
  


export const getEmailAnalysisQuestionnaireEmptyPdfMutationOptions = <TError = EmailQuestionnairePdfBadRequestError | EmailQuestionnairePdfNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailAnalysisQuestionnaireEmptyPdf>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof emailAnalysisQuestionnaireEmptyPdf>>, TError,{analysisId: string;versionId: string}, TContext> => {

const mutationKey = ['emailAnalysisQuestionnaireEmptyPdf'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailAnalysisQuestionnaireEmptyPdf>>, {analysisId: string;versionId: string}> = (props) => {
          const {analysisId,versionId} = props ?? {};

          return  emailAnalysisQuestionnaireEmptyPdf(analysisId,versionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EmailAnalysisQuestionnaireEmptyPdfMutationResult = NonNullable<Awaited<ReturnType<typeof emailAnalysisQuestionnaireEmptyPdf>>>
    
    export type EmailAnalysisQuestionnaireEmptyPdfMutationError = EmailQuestionnairePdfBadRequestError | EmailQuestionnairePdfNotFoundError

    export const useEmailAnalysisQuestionnaireEmptyPdf = <TError = EmailQuestionnairePdfBadRequestError | EmailQuestionnairePdfNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailAnalysisQuestionnaireEmptyPdf>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof emailAnalysisQuestionnaireEmptyPdf>>,
        TError,
        {analysisId: string;versionId: string},
        TContext
      > => {

      const mutationOptions = getEmailAnalysisQuestionnaireEmptyPdfMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Filled questionnaire, including its evaluation when the questionnaire has a valid one
 */
export const analysisQuestionnairePdf = (
    analysisId: string,
    versionId: string,
    params?: AnalysisQuestionnairePdfParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Blob>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/pdf`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  



export const getAnalysisQuestionnairePdfQueryKey = (analysisId?: string,
    versionId?: string,
    params?: AnalysisQuestionnairePdfParams,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/pdf`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAnalysisQuestionnairePdfQueryOptions = <TData = Awaited<ReturnType<typeof analysisQuestionnairePdf>>, TError = QuestionnairePdfNotFoundError>(analysisId: string,
    versionId: string,
    params?: AnalysisQuestionnairePdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnairePdf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAnalysisQuestionnairePdfQueryKey(analysisId,versionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof analysisQuestionnairePdf>>> = ({ signal }) => analysisQuestionnairePdf(analysisId,versionId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnairePdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AnalysisQuestionnairePdfQueryResult = NonNullable<Awaited<ReturnType<typeof analysisQuestionnairePdf>>>
export type AnalysisQuestionnairePdfQueryError = QuestionnairePdfNotFoundError


export function useAnalysisQuestionnairePdf<TData = Awaited<ReturnType<typeof analysisQuestionnairePdf>>, TError = QuestionnairePdfNotFoundError>(
 analysisId: string,
    versionId: string,
    params: undefined |  AnalysisQuestionnairePdfParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnairePdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof analysisQuestionnairePdf>>,
          TError,
          Awaited<ReturnType<typeof analysisQuestionnairePdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnalysisQuestionnairePdf<TData = Awaited<ReturnType<typeof analysisQuestionnairePdf>>, TError = QuestionnairePdfNotFoundError>(
 analysisId: string,
    versionId: string,
    params?: AnalysisQuestionnairePdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnairePdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof analysisQuestionnairePdf>>,
          TError,
          Awaited<ReturnType<typeof analysisQuestionnairePdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAnalysisQuestionnairePdf<TData = Awaited<ReturnType<typeof analysisQuestionnairePdf>>, TError = QuestionnairePdfNotFoundError>(
 analysisId: string,
    versionId: string,
    params?: AnalysisQuestionnairePdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnairePdf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAnalysisQuestionnairePdf<TData = Awaited<ReturnType<typeof analysisQuestionnairePdf>>, TError = QuestionnairePdfNotFoundError>(
 analysisId: string,
    versionId: string,
    params?: AnalysisQuestionnairePdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof analysisQuestionnairePdf>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAnalysisQuestionnairePdfQueryOptions(analysisId,versionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Filled questionnaire, including its evaluation when the questionnaire has a valid one
 */
export const emailAnalysisQuestionnairePdf = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/email-pdf`, method: 'POST', signal
    },
      options);
    }
  


export const getEmailAnalysisQuestionnairePdfMutationOptions = <TError = EmailQuestionnairePdfBadRequestError | EmailQuestionnairePdfNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailAnalysisQuestionnairePdf>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof emailAnalysisQuestionnairePdf>>, TError,{analysisId: string;versionId: string}, TContext> => {

const mutationKey = ['emailAnalysisQuestionnairePdf'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof emailAnalysisQuestionnairePdf>>, {analysisId: string;versionId: string}> = (props) => {
          const {analysisId,versionId} = props ?? {};

          return  emailAnalysisQuestionnairePdf(analysisId,versionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EmailAnalysisQuestionnairePdfMutationResult = NonNullable<Awaited<ReturnType<typeof emailAnalysisQuestionnairePdf>>>
    
    export type EmailAnalysisQuestionnairePdfMutationError = EmailQuestionnairePdfBadRequestError | EmailQuestionnairePdfNotFoundError

    export const useEmailAnalysisQuestionnairePdf = <TError = EmailQuestionnairePdfBadRequestError | EmailQuestionnairePdfNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof emailAnalysisQuestionnairePdf>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof emailAnalysisQuestionnairePdf>>,
        TError,
        {analysisId: string;versionId: string},
        TContext
      > => {

      const mutationOptions = getEmailAnalysisQuestionnairePdfMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const saveAnalysisQuestionnaireAnswer = (
    analysisId: string,
    versionId: string,
    saveQuestionnaireAnswers: SaveQuestionnaireAnswers,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/answers`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveQuestionnaireAnswers
    },
      options);
    }
  


export const getSaveAnalysisQuestionnaireAnswerMutationOptions = <TError = SaveAnswersBadRequestError | SaveAnswersNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAnalysisQuestionnaireAnswer>>, TError,{analysisId: string;versionId: string;data: SaveQuestionnaireAnswers}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveAnalysisQuestionnaireAnswer>>, TError,{analysisId: string;versionId: string;data: SaveQuestionnaireAnswers}, TContext> => {

const mutationKey = ['saveAnalysisQuestionnaireAnswer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveAnalysisQuestionnaireAnswer>>, {analysisId: string;versionId: string;data: SaveQuestionnaireAnswers}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  saveAnalysisQuestionnaireAnswer(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveAnalysisQuestionnaireAnswerMutationResult = NonNullable<Awaited<ReturnType<typeof saveAnalysisQuestionnaireAnswer>>>
    export type SaveAnalysisQuestionnaireAnswerMutationBody = SaveQuestionnaireAnswers
    export type SaveAnalysisQuestionnaireAnswerMutationError = SaveAnswersBadRequestError | SaveAnswersNotFoundError

    export const useSaveAnalysisQuestionnaireAnswer = <TError = SaveAnswersBadRequestError | SaveAnswersNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAnalysisQuestionnaireAnswer>>, TError,{analysisId: string;versionId: string;data: SaveQuestionnaireAnswers}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveAnalysisQuestionnaireAnswer>>,
        TError,
        {analysisId: string;versionId: string;data: SaveQuestionnaireAnswers},
        TContext
      > => {

      const mutationOptions = getSaveAnalysisQuestionnaireAnswerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAnalysisQuestionnaireEvaluation = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<QuestionnaireEvaluation>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/evaluation`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAnalysisQuestionnaireEvaluationQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/evaluation`
    ] as const;
    }

    
export const getGetAnalysisQuestionnaireEvaluationQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>, TError = GetEvaluationNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisQuestionnaireEvaluationQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>> = ({ signal }) => getAnalysisQuestionnaireEvaluation(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisQuestionnaireEvaluationQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>>
export type GetAnalysisQuestionnaireEvaluationQueryError = GetEvaluationNotFoundError


export function useGetAnalysisQuestionnaireEvaluation<TData = Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>, TError = GetEvaluationNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisQuestionnaireEvaluation<TData = Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>, TError = GetEvaluationNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisQuestionnaireEvaluation<TData = Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>, TError = GetEvaluationNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAnalysisQuestionnaireEvaluation<TData = Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>, TError = GetEvaluationNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisQuestionnaireEvaluation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisQuestionnaireEvaluationQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const evaluateAnalysisQuestionnaire = (
    analysisId: string,
    versionId: string,
    evaluateQuestionnaire: EvaluateQuestionnaire,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<QuestionnaireEvaluation>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/evaluation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: evaluateQuestionnaire, signal
    },
      options);
    }
  


export const getEvaluateAnalysisQuestionnaireMutationOptions = <TError = EvaluateBadRequestError | QuestionnaireNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateAnalysisQuestionnaire>>, TError,{analysisId: string;versionId: string;data: EvaluateQuestionnaire}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof evaluateAnalysisQuestionnaire>>, TError,{analysisId: string;versionId: string;data: EvaluateQuestionnaire}, TContext> => {

const mutationKey = ['evaluateAnalysisQuestionnaire'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof evaluateAnalysisQuestionnaire>>, {analysisId: string;versionId: string;data: EvaluateQuestionnaire}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  evaluateAnalysisQuestionnaire(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EvaluateAnalysisQuestionnaireMutationResult = NonNullable<Awaited<ReturnType<typeof evaluateAnalysisQuestionnaire>>>
    export type EvaluateAnalysisQuestionnaireMutationBody = EvaluateQuestionnaire
    export type EvaluateAnalysisQuestionnaireMutationError = EvaluateBadRequestError | QuestionnaireNotFoundError

    export const useEvaluateAnalysisQuestionnaire = <TError = EvaluateBadRequestError | QuestionnaireNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateAnalysisQuestionnaire>>, TError,{analysisId: string;versionId: string;data: EvaluateQuestionnaire}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof evaluateAnalysisQuestionnaire>>,
        TError,
        {analysisId: string;versionId: string;data: EvaluateQuestionnaire},
        TContext
      > => {

      const mutationOptions = getEvaluateAnalysisQuestionnaireMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createQuestionnaireSignRequest = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<QuestionnaireSignResponse>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/sign`, method: 'POST', signal
    },
      options);
    }
  


export const getCreateQuestionnaireSignRequestMutationOptions = <TError = SignBadRequestError | SignForbiddenError | QuestionnaireNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuestionnaireSignRequest>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createQuestionnaireSignRequest>>, TError,{analysisId: string;versionId: string}, TContext> => {

const mutationKey = ['createQuestionnaireSignRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createQuestionnaireSignRequest>>, {analysisId: string;versionId: string}> = (props) => {
          const {analysisId,versionId} = props ?? {};

          return  createQuestionnaireSignRequest(analysisId,versionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateQuestionnaireSignRequestMutationResult = NonNullable<Awaited<ReturnType<typeof createQuestionnaireSignRequest>>>
    
    export type CreateQuestionnaireSignRequestMutationError = SignBadRequestError | SignForbiddenError | QuestionnaireNotFoundError

    export const useCreateQuestionnaireSignRequest = <TError = SignBadRequestError | SignForbiddenError | QuestionnaireNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createQuestionnaireSignRequest>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createQuestionnaireSignRequest>>,
        TError,
        {analysisId: string;versionId: string},
        TContext
      > => {

      const mutationOptions = getCreateQuestionnaireSignRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const resendQuestionnaireSignRequest = (
    analysisId: string,
    versionId: string,
    questionnaireSignResend: QuestionnaireSignResend,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<QuestionnaireSignResponse>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/sign-resend`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: questionnaireSignResend, signal
    },
      options);
    }
  


export const getResendQuestionnaireSignRequestMutationOptions = <TError = SignGuardBadRequestError | ResendSignForbiddenError | ResendSignNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendQuestionnaireSignRequest>>, TError,{analysisId: string;versionId: string;data: QuestionnaireSignResend}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resendQuestionnaireSignRequest>>, TError,{analysisId: string;versionId: string;data: QuestionnaireSignResend}, TContext> => {

const mutationKey = ['resendQuestionnaireSignRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resendQuestionnaireSignRequest>>, {analysisId: string;versionId: string;data: QuestionnaireSignResend}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  resendQuestionnaireSignRequest(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResendQuestionnaireSignRequestMutationResult = NonNullable<Awaited<ReturnType<typeof resendQuestionnaireSignRequest>>>
    export type ResendQuestionnaireSignRequestMutationBody = QuestionnaireSignResend
    export type ResendQuestionnaireSignRequestMutationError = SignGuardBadRequestError | ResendSignForbiddenError | ResendSignNotFoundError

    export const useResendQuestionnaireSignRequest = <TError = SignGuardBadRequestError | ResendSignForbiddenError | ResendSignNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resendQuestionnaireSignRequest>>, TError,{analysisId: string;versionId: string;data: QuestionnaireSignResend}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resendQuestionnaireSignRequest>>,
        TError,
        {analysisId: string;versionId: string;data: QuestionnaireSignResend},
        TContext
      > => {

      const mutationOptions = getResendQuestionnaireSignRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const verifyQuestionnaireSign = (
    analysisId: string,
    versionId: string,
    questionnaireSignVerify: QuestionnaireSignVerify,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/questionnaire/sign-verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: questionnaireSignVerify, signal
    },
      options);
    }
  


export const getVerifyQuestionnaireSignMutationOptions = <TError = SignGuardBadRequestError | VerifySignForbiddenError | VerifySignNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyQuestionnaireSign>>, TError,{analysisId: string;versionId: string;data: QuestionnaireSignVerify}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof verifyQuestionnaireSign>>, TError,{analysisId: string;versionId: string;data: QuestionnaireSignVerify}, TContext> => {

const mutationKey = ['verifyQuestionnaireSign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyQuestionnaireSign>>, {analysisId: string;versionId: string;data: QuestionnaireSignVerify}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  verifyQuestionnaireSign(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyQuestionnaireSignMutationResult = NonNullable<Awaited<ReturnType<typeof verifyQuestionnaireSign>>>
    export type VerifyQuestionnaireSignMutationBody = QuestionnaireSignVerify
    export type VerifyQuestionnaireSignMutationError = SignGuardBadRequestError | VerifySignForbiddenError | VerifySignNotFoundError

    export const useVerifyQuestionnaireSign = <TError = SignGuardBadRequestError | VerifySignForbiddenError | VerifySignNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyQuestionnaireSign>>, TError,{analysisId: string;versionId: string;data: QuestionnaireSignVerify}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyQuestionnaireSign>>,
        TError,
        {analysisId: string;versionId: string;data: QuestionnaireSignVerify},
        TContext
      > => {

      const mutationOptions = getVerifyQuestionnaireSignMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listContractProposals = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ContractProposalsListResult>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/contract-proposals`, method: 'GET', signal
    },
      options);
    }
  



export const getListContractProposalsQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/contract-proposals`
    ] as const;
    }

    
export const getListContractProposalsQueryOptions = <TData = Awaited<ReturnType<typeof listContractProposals>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractProposals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListContractProposalsQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listContractProposals>>> = ({ signal }) => listContractProposals(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listContractProposals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListContractProposalsQueryResult = NonNullable<Awaited<ReturnType<typeof listContractProposals>>>
export type ListContractProposalsQueryError = AnalysisNotFoundError


export function useListContractProposals<TData = Awaited<ReturnType<typeof listContractProposals>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractProposals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContractProposals>>,
          TError,
          Awaited<ReturnType<typeof listContractProposals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListContractProposals<TData = Awaited<ReturnType<typeof listContractProposals>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractProposals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listContractProposals>>,
          TError,
          Awaited<ReturnType<typeof listContractProposals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListContractProposals<TData = Awaited<ReturnType<typeof listContractProposals>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractProposals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListContractProposals<TData = Awaited<ReturnType<typeof listContractProposals>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listContractProposals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListContractProposalsQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createContractProposal = (
    analysisId: string,
    versionId: string,
    createContractProposalBody: CreateContractProposalBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ContractProposalBase[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/contract-proposals`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createContractProposalBody, signal
    },
      options);
    }
  


export const getCreateContractProposalMutationOptions = <TError = ClientNotBelongToAnalysisError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractProposal>>, TError,{analysisId: string;versionId: string;data: CreateContractProposalBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createContractProposal>>, TError,{analysisId: string;versionId: string;data: CreateContractProposalBody}, TContext> => {

const mutationKey = ['createContractProposal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createContractProposal>>, {analysisId: string;versionId: string;data: CreateContractProposalBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createContractProposal(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateContractProposalMutationResult = NonNullable<Awaited<ReturnType<typeof createContractProposal>>>
    export type CreateContractProposalMutationBody = CreateContractProposalBody
    export type CreateContractProposalMutationError = ClientNotBelongToAnalysisError | AnalysisNotFoundError

    export const useCreateContractProposal = <TError = ClientNotBelongToAnalysisError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createContractProposal>>, TError,{analysisId: string;versionId: string;data: CreateContractProposalBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createContractProposal>>,
        TError,
        {analysisId: string;versionId: string;data: CreateContractProposalBody},
        TContext
      > => {

      const mutationOptions = getCreateContractProposalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getContractProposal = (
    analysisId: string,
    versionId: string,
    contractProposalGuid: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<GetContractProposal200>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/contract-proposals/${contractProposalGuid}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetContractProposalQueryKey = (analysisId?: string,
    versionId?: string,
    contractProposalGuid?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/contract-proposals/${contractProposalGuid}`
    ] as const;
    }

    
export const getGetContractProposalQueryOptions = <TData = Awaited<ReturnType<typeof getContractProposal>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string,
    contractProposalGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractProposal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContractProposalQueryKey(analysisId,versionId,contractProposalGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContractProposal>>> = ({ signal }) => getContractProposal(analysisId,versionId,contractProposalGuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && contractProposalGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContractProposal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContractProposalQueryResult = NonNullable<Awaited<ReturnType<typeof getContractProposal>>>
export type GetContractProposalQueryError = AnalysisNotFoundError


export function useGetContractProposal<TData = Awaited<ReturnType<typeof getContractProposal>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string,
    contractProposalGuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractProposal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractProposal>>,
          TError,
          Awaited<ReturnType<typeof getContractProposal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractProposal<TData = Awaited<ReturnType<typeof getContractProposal>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string,
    contractProposalGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractProposal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContractProposal>>,
          TError,
          Awaited<ReturnType<typeof getContractProposal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContractProposal<TData = Awaited<ReturnType<typeof getContractProposal>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string,
    contractProposalGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractProposal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetContractProposal<TData = Awaited<ReturnType<typeof getContractProposal>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string,
    contractProposalGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContractProposal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContractProposalQueryOptions(analysisId,versionId,contractProposalGuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const patchContractProposal = (
    analysisId: string,
    versionId: string,
    contractProposalGuid: string,
    patchContractProposalBody: PatchContractProposalBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<ContractProposalBase>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/contract-proposals/${contractProposalGuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchContractProposalBody
    },
      options);
    }
  


export const getPatchContractProposalMutationOptions = <TError = ClientNotBelongToAnalysisError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchContractProposal>>, TError,{analysisId: string;versionId: string;contractProposalGuid: string;data: PatchContractProposalBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchContractProposal>>, TError,{analysisId: string;versionId: string;contractProposalGuid: string;data: PatchContractProposalBody}, TContext> => {

const mutationKey = ['patchContractProposal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchContractProposal>>, {analysisId: string;versionId: string;contractProposalGuid: string;data: PatchContractProposalBody}> = (props) => {
          const {analysisId,versionId,contractProposalGuid,data} = props ?? {};

          return  patchContractProposal(analysisId,versionId,contractProposalGuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchContractProposalMutationResult = NonNullable<Awaited<ReturnType<typeof patchContractProposal>>>
    export type PatchContractProposalMutationBody = PatchContractProposalBody
    export type PatchContractProposalMutationError = ClientNotBelongToAnalysisError | AnalysisNotFoundError

    export const usePatchContractProposal = <TError = ClientNotBelongToAnalysisError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchContractProposal>>, TError,{analysisId: string;versionId: string;contractProposalGuid: string;data: PatchContractProposalBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchContractProposal>>,
        TError,
        {analysisId: string;versionId: string;contractProposalGuid: string;data: PatchContractProposalBody},
        TContext
      > => {

      const mutationOptions = getPatchContractProposalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteContractProposal = (
    analysisId: string,
    versionId: string,
    contractProposalGuid: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/contract-proposals/${contractProposalGuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteContractProposalMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContractProposal>>, TError,{analysisId: string;versionId: string;contractProposalGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteContractProposal>>, TError,{analysisId: string;versionId: string;contractProposalGuid: string}, TContext> => {

const mutationKey = ['deleteContractProposal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteContractProposal>>, {analysisId: string;versionId: string;contractProposalGuid: string}> = (props) => {
          const {analysisId,versionId,contractProposalGuid} = props ?? {};

          return  deleteContractProposal(analysisId,versionId,contractProposalGuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteContractProposalMutationResult = NonNullable<Awaited<ReturnType<typeof deleteContractProposal>>>
    
    export type DeleteContractProposalMutationError = AnalysisNotFoundError

    export const useDeleteContractProposal = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteContractProposal>>, TError,{analysisId: string;versionId: string;contractProposalGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteContractProposal>>,
        TError,
        {analysisId: string;versionId: string;contractProposalGuid: string},
        TContext
      > => {

      const mutationOptions = getDeleteContractProposalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listCurrentContracts = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<CurrentContractsListResult>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/current-contracts`, method: 'GET', signal
    },
      options);
    }
  



export const getListCurrentContractsQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/current-contracts`
    ] as const;
    }

    
export const getListCurrentContractsQueryOptions = <TData = Awaited<ReturnType<typeof listCurrentContracts>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurrentContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCurrentContractsQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurrentContracts>>> = ({ signal }) => listCurrentContracts(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCurrentContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCurrentContractsQueryResult = NonNullable<Awaited<ReturnType<typeof listCurrentContracts>>>
export type ListCurrentContractsQueryError = AnalysisNotFoundError


export function useListCurrentContracts<TData = Awaited<ReturnType<typeof listCurrentContracts>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurrentContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCurrentContracts>>,
          TError,
          Awaited<ReturnType<typeof listCurrentContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCurrentContracts<TData = Awaited<ReturnType<typeof listCurrentContracts>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurrentContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCurrentContracts>>,
          TError,
          Awaited<ReturnType<typeof listCurrentContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCurrentContracts<TData = Awaited<ReturnType<typeof listCurrentContracts>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurrentContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCurrentContracts<TData = Awaited<ReturnType<typeof listCurrentContracts>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurrentContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCurrentContractsQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createCurrentContract = (
    analysisId: string,
    versionId: string,
    createCurrentContractBody: CreateCurrentContractBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<CurrentContractBase>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/current-contracts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCurrentContractBody, signal
    },
      options);
    }
  


export const getCreateCurrentContractMutationOptions = <TError = ClientNotBelongToAnalysisError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCurrentContract>>, TError,{analysisId: string;versionId: string;data: CreateCurrentContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCurrentContract>>, TError,{analysisId: string;versionId: string;data: CreateCurrentContractBody}, TContext> => {

const mutationKey = ['createCurrentContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCurrentContract>>, {analysisId: string;versionId: string;data: CreateCurrentContractBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createCurrentContract(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCurrentContractMutationResult = NonNullable<Awaited<ReturnType<typeof createCurrentContract>>>
    export type CreateCurrentContractMutationBody = CreateCurrentContractBody
    export type CreateCurrentContractMutationError = ClientNotBelongToAnalysisError | AnalysisNotFoundError

    export const useCreateCurrentContract = <TError = ClientNotBelongToAnalysisError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCurrentContract>>, TError,{analysisId: string;versionId: string;data: CreateCurrentContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCurrentContract>>,
        TError,
        {analysisId: string;versionId: string;data: CreateCurrentContractBody},
        TContext
      > => {

      const mutationOptions = getCreateCurrentContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getCurrentContract = (
    analysisId: string,
    versionId: string,
    currentContractGuid: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<GetCurrentContract200>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/current-contracts/${currentContractGuid}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCurrentContractQueryKey = (analysisId?: string,
    versionId?: string,
    currentContractGuid?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/current-contracts/${currentContractGuid}`
    ] as const;
    }

    
export const getGetCurrentContractQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentContract>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string,
    currentContractGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentContractQueryKey(analysisId,versionId,currentContractGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentContract>>> = ({ signal }) => getCurrentContract(analysisId,versionId,currentContractGuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && currentContractGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCurrentContractQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentContract>>>
export type GetCurrentContractQueryError = AnalysisNotFoundError


export function useGetCurrentContract<TData = Awaited<ReturnType<typeof getCurrentContract>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string,
    currentContractGuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentContract>>,
          TError,
          Awaited<ReturnType<typeof getCurrentContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentContract<TData = Awaited<ReturnType<typeof getCurrentContract>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string,
    currentContractGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentContract>>,
          TError,
          Awaited<ReturnType<typeof getCurrentContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCurrentContract<TData = Awaited<ReturnType<typeof getCurrentContract>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string,
    currentContractGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCurrentContract<TData = Awaited<ReturnType<typeof getCurrentContract>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string,
    currentContractGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCurrentContractQueryOptions(analysisId,versionId,currentContractGuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const patchCurrentContract = (
    analysisId: string,
    versionId: string,
    currentContractGuid: string,
    patchCurrentContractBody: PatchCurrentContractBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<CurrentContractBase>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/current-contracts/${currentContractGuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchCurrentContractBody
    },
      options);
    }
  


export const getPatchCurrentContractMutationOptions = <TError = ClientNotBelongToAnalysisError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCurrentContract>>, TError,{analysisId: string;versionId: string;currentContractGuid: string;data: PatchCurrentContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCurrentContract>>, TError,{analysisId: string;versionId: string;currentContractGuid: string;data: PatchCurrentContractBody}, TContext> => {

const mutationKey = ['patchCurrentContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCurrentContract>>, {analysisId: string;versionId: string;currentContractGuid: string;data: PatchCurrentContractBody}> = (props) => {
          const {analysisId,versionId,currentContractGuid,data} = props ?? {};

          return  patchCurrentContract(analysisId,versionId,currentContractGuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCurrentContractMutationResult = NonNullable<Awaited<ReturnType<typeof patchCurrentContract>>>
    export type PatchCurrentContractMutationBody = PatchCurrentContractBody
    export type PatchCurrentContractMutationError = ClientNotBelongToAnalysisError | AnalysisNotFoundError

    export const usePatchCurrentContract = <TError = ClientNotBelongToAnalysisError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCurrentContract>>, TError,{analysisId: string;versionId: string;currentContractGuid: string;data: PatchCurrentContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCurrentContract>>,
        TError,
        {analysisId: string;versionId: string;currentContractGuid: string;data: PatchCurrentContractBody},
        TContext
      > => {

      const mutationOptions = getPatchCurrentContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteCurrentContract = (
    analysisId: string,
    versionId: string,
    currentContractGuid: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/current-contracts/${currentContractGuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCurrentContractMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCurrentContract>>, TError,{analysisId: string;versionId: string;currentContractGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCurrentContract>>, TError,{analysisId: string;versionId: string;currentContractGuid: string}, TContext> => {

const mutationKey = ['deleteCurrentContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCurrentContract>>, {analysisId: string;versionId: string;currentContractGuid: string}> = (props) => {
          const {analysisId,versionId,currentContractGuid} = props ?? {};

          return  deleteCurrentContract(analysisId,versionId,currentContractGuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCurrentContractMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCurrentContract>>>
    
    export type DeleteCurrentContractMutationError = AnalysisNotFoundError

    export const useDeleteCurrentContract = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCurrentContract>>, TError,{analysisId: string;versionId: string;currentContractGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCurrentContract>>,
        TError,
        {analysisId: string;versionId: string;currentContractGuid: string},
        TContext
      > => {

      const mutationOptions = getDeleteCurrentContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAnalysisPortfolios = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<StrategyModelation[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/portfolios`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAnalysisPortfoliosQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/portfolios`
    ] as const;
    }

    
export const getGetAnalysisPortfoliosQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisPortfolios>>, TError = EnsureInvestmentCaseBadRequestError | GetPortfoliosNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisPortfolios>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisPortfoliosQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisPortfolios>>> = ({ signal }) => getAnalysisPortfolios(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisPortfolios>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisPortfoliosQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisPortfolios>>>
export type GetAnalysisPortfoliosQueryError = EnsureInvestmentCaseBadRequestError | GetPortfoliosNotFoundError


export function useGetAnalysisPortfolios<TData = Awaited<ReturnType<typeof getAnalysisPortfolios>>, TError = EnsureInvestmentCaseBadRequestError | GetPortfoliosNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisPortfolios>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisPortfolios>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisPortfolios>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisPortfolios<TData = Awaited<ReturnType<typeof getAnalysisPortfolios>>, TError = EnsureInvestmentCaseBadRequestError | GetPortfoliosNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisPortfolios>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisPortfolios>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisPortfolios>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisPortfolios<TData = Awaited<ReturnType<typeof getAnalysisPortfolios>>, TError = EnsureInvestmentCaseBadRequestError | GetPortfoliosNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisPortfolios>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAnalysisPortfolios<TData = Awaited<ReturnType<typeof getAnalysisPortfolios>>, TError = EnsureInvestmentCaseBadRequestError | GetPortfoliosNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisPortfolios>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisPortfoliosQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const evaluateAnalysisPortfolio = (
    analysisId: string,
    versionId: string,
    evaluatePortfolioRequest: EvaluatePortfolioRequest,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<EvaluatePortfolioResponse>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/portfolios/evaluate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: evaluatePortfolioRequest, signal
    },
      options);
    }
  


export const getEvaluateAnalysisPortfolioMutationOptions = <TError = EvaluatePortfolioBadRequestError | GetPortfoliosNotFoundError | EvaluatePortfolioInternalError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateAnalysisPortfolio>>, TError,{analysisId: string;versionId: string;data: EvaluatePortfolioRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof evaluateAnalysisPortfolio>>, TError,{analysisId: string;versionId: string;data: EvaluatePortfolioRequest}, TContext> => {

const mutationKey = ['evaluateAnalysisPortfolio'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof evaluateAnalysisPortfolio>>, {analysisId: string;versionId: string;data: EvaluatePortfolioRequest}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  evaluateAnalysisPortfolio(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EvaluateAnalysisPortfolioMutationResult = NonNullable<Awaited<ReturnType<typeof evaluateAnalysisPortfolio>>>
    export type EvaluateAnalysisPortfolioMutationBody = EvaluatePortfolioRequest
    export type EvaluateAnalysisPortfolioMutationError = EvaluatePortfolioBadRequestError | GetPortfoliosNotFoundError | EvaluatePortfolioInternalError

    export const useEvaluateAnalysisPortfolio = <TError = EvaluatePortfolioBadRequestError | GetPortfoliosNotFoundError | EvaluatePortfolioInternalError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof evaluateAnalysisPortfolio>>, TError,{analysisId: string;versionId: string;data: EvaluatePortfolioRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof evaluateAnalysisPortfolio>>,
        TError,
        {analysisId: string;versionId: string;data: EvaluatePortfolioRequest},
        TContext
      > => {

      const mutationOptions = getEvaluateAnalysisPortfolioMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAnalysisSuitabilityStatement = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<GetSuitabilityStatementResponse>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/suitability-statement`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAnalysisSuitabilityStatementQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/suitability-statement`
    ] as const;
    }

    
export const getGetAnalysisSuitabilityStatementQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>, TError = GetNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisSuitabilityStatementQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>> = ({ signal }) => getAnalysisSuitabilityStatement(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisSuitabilityStatementQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>>
export type GetAnalysisSuitabilityStatementQueryError = GetNotFoundError


export function useGetAnalysisSuitabilityStatement<TData = Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>, TError = GetNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisSuitabilityStatement<TData = Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>, TError = GetNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisSuitabilityStatement<TData = Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>, TError = GetNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAnalysisSuitabilityStatement<TData = Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>, TError = GetNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisSuitabilityStatement>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisSuitabilityStatementQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const saveAnalysisSuitabilityStatement = (
    analysisId: string,
    versionId: string,
    saveSuitabilityStatementBody: SaveSuitabilityStatementBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/suitability-statement`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: saveSuitabilityStatementBody
    },
      options);
    }
  


export const getSaveAnalysisSuitabilityStatementMutationOptions = <TError = PutNotFoundError | PutConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAnalysisSuitabilityStatement>>, TError,{analysisId: string;versionId: string;data: SaveSuitabilityStatementBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveAnalysisSuitabilityStatement>>, TError,{analysisId: string;versionId: string;data: SaveSuitabilityStatementBody}, TContext> => {

const mutationKey = ['saveAnalysisSuitabilityStatement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveAnalysisSuitabilityStatement>>, {analysisId: string;versionId: string;data: SaveSuitabilityStatementBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  saveAnalysisSuitabilityStatement(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveAnalysisSuitabilityStatementMutationResult = NonNullable<Awaited<ReturnType<typeof saveAnalysisSuitabilityStatement>>>
    export type SaveAnalysisSuitabilityStatementMutationBody = SaveSuitabilityStatementBody
    export type SaveAnalysisSuitabilityStatementMutationError = PutNotFoundError | PutConflictError

    export const useSaveAnalysisSuitabilityStatement = <TError = PutNotFoundError | PutConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAnalysisSuitabilityStatement>>, TError,{analysisId: string;versionId: string;data: SaveSuitabilityStatementBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveAnalysisSuitabilityStatement>>,
        TError,
        {analysisId: string;versionId: string;data: SaveSuitabilityStatementBody},
        TContext
      > => {

      const mutationOptions = getSaveAnalysisSuitabilityStatementMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const validateAnalysisContractCreation = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/contract-validation`, method: 'GET', signal
    },
      options);
    }
  



export const getValidateAnalysisContractCreationQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/contract-validation`
    ] as const;
    }

    
export const getValidateAnalysisContractCreationQueryOptions = <TData = Awaited<ReturnType<typeof validateAnalysisContractCreation>>, TError = NotFoundError | UnprocessableEntityError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateAnalysisContractCreation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getValidateAnalysisContractCreationQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof validateAnalysisContractCreation>>> = ({ signal }) => validateAnalysisContractCreation(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof validateAnalysisContractCreation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ValidateAnalysisContractCreationQueryResult = NonNullable<Awaited<ReturnType<typeof validateAnalysisContractCreation>>>
export type ValidateAnalysisContractCreationQueryError = NotFoundError | UnprocessableEntityError


export function useValidateAnalysisContractCreation<TData = Awaited<ReturnType<typeof validateAnalysisContractCreation>>, TError = NotFoundError | UnprocessableEntityError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateAnalysisContractCreation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateAnalysisContractCreation>>,
          TError,
          Awaited<ReturnType<typeof validateAnalysisContractCreation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateAnalysisContractCreation<TData = Awaited<ReturnType<typeof validateAnalysisContractCreation>>, TError = NotFoundError | UnprocessableEntityError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateAnalysisContractCreation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof validateAnalysisContractCreation>>,
          TError,
          Awaited<ReturnType<typeof validateAnalysisContractCreation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useValidateAnalysisContractCreation<TData = Awaited<ReturnType<typeof validateAnalysisContractCreation>>, TError = NotFoundError | UnprocessableEntityError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateAnalysisContractCreation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useValidateAnalysisContractCreation<TData = Awaited<ReturnType<typeof validateAnalysisContractCreation>>, TError = NotFoundError | UnprocessableEntityError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof validateAnalysisContractCreation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getValidateAnalysisContractCreationQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createAnalysisIssueReport = (
    analysisId: string,
    versionId: string,
    createIssueReportBody: CreateIssueReportBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`description`, createIssueReportBody.description)
formData.append(`pageUrl`, createIssueReportBody.pageUrl)
formData.append(`analysisName`, createIssueReportBody.analysisName)
if(createIssueReportBody.analysisVersion !== undefined) {
 formData.append(`analysisVersion`, createIssueReportBody.analysisVersion.toString())
 }
formData.append(`reporterName`, createIssueReportBody.reporterName)
formData.append(`browser`, createIssueReportBody.browser)
formData.append(`os`, createIssueReportBody.os)
formData.append(`device`, createIssueReportBody.device)
formData.append(`userAgent`, createIssueReportBody.userAgent)
if(createIssueReportBody.attachments !== undefined) {
 createIssueReportBody.attachments.forEach(value => formData.append(`attachments`, value));
 }

      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/issue-report`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getCreateAnalysisIssueReportMutationOptions = <TError = CreateIssueReportBadRequestError | CreateIssueReportNotFoundError | CreateIssueReportPayloadTooLargeError | CreateIssueReportInternalError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysisIssueReport>>, TError,{analysisId: string;versionId: string;data: CreateIssueReportBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAnalysisIssueReport>>, TError,{analysisId: string;versionId: string;data: CreateIssueReportBody}, TContext> => {

const mutationKey = ['createAnalysisIssueReport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnalysisIssueReport>>, {analysisId: string;versionId: string;data: CreateIssueReportBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createAnalysisIssueReport(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAnalysisIssueReportMutationResult = NonNullable<Awaited<ReturnType<typeof createAnalysisIssueReport>>>
    export type CreateAnalysisIssueReportMutationBody = CreateIssueReportBody
    export type CreateAnalysisIssueReportMutationError = CreateIssueReportBadRequestError | CreateIssueReportNotFoundError | CreateIssueReportPayloadTooLargeError | CreateIssueReportInternalError

    export const useCreateAnalysisIssueReport = <TError = CreateIssueReportBadRequestError | CreateIssueReportNotFoundError | CreateIssueReportPayloadTooLargeError | CreateIssueReportInternalError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnalysisIssueReport>>, TError,{analysisId: string;versionId: string;data: CreateIssueReportBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAnalysisIssueReport>>,
        TError,
        {analysisId: string;versionId: string;data: CreateIssueReportBody},
        TContext
      > => {

      const mutationOptions = getCreateAnalysisIssueReportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Owner only, any state and any version of the analysis. Hands the edit access to the given agent, taking it from whoever held it (that agent receives `analysis_edit_access_revoked` over the socket), and makes them the agent of the analysis' nSure cases while it is in progress. Sharing a closed or older version does not change its state rules - only the latest version can still change state, and only by whoever holds the edit access. Everyone the analysis was ever shared with keeps read-only access. Sharing with the agent who already holds the edit access is a no-op (204, no notification). Every Mango client of the analysis (main and additional) the receiving agent cannot see yet is made visible to them in Mango (ZVIDITELNENI, permanent) and in the client search. 404 `mango_agent_not_found`: the receiving agent has no agent record in Mango, so the clients could not be made visible - nothing has changed. 404 `nsure_agent_not_found`: the receiving agent has no nSure account, so the cases could not be handed over - the edit access stays where it was (client visibility already granted is kept).
 */
export const shareAnalysis = (
    analysisId: string,
    versionId: string,
    shareAnalysisBody: ShareAnalysisBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/sharing`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shareAnalysisBody, signal
    },
      options);
    }
  


export const getShareAnalysisMutationOptions = <TError = ShareAnalysisBadRequestError | AnalysisOwnerRequiredError | ShareAnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareAnalysis>>, TError,{analysisId: string;versionId: string;data: ShareAnalysisBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof shareAnalysis>>, TError,{analysisId: string;versionId: string;data: ShareAnalysisBody}, TContext> => {

const mutationKey = ['shareAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shareAnalysis>>, {analysisId: string;versionId: string;data: ShareAnalysisBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  shareAnalysis(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShareAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof shareAnalysis>>>
    export type ShareAnalysisMutationBody = ShareAnalysisBody
    export type ShareAnalysisMutationError = ShareAnalysisBadRequestError | AnalysisOwnerRequiredError | ShareAnalysisNotFoundError

    export const useShareAnalysis = <TError = ShareAnalysisBadRequestError | AnalysisOwnerRequiredError | ShareAnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shareAnalysis>>, TError,{analysisId: string;versionId: string;data: ShareAnalysisBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shareAnalysis>>,
        TError,
        {analysisId: string;versionId: string;data: ShareAnalysisBody},
        TContext
      > => {

      const mutationOptions = getShareAnalysisMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * The editing agent hands the edit access back to the owner (who receives `analysis_returned` over the socket) and drops to read-only. 409 `analysis_edit_access_not_held`: the caller does not hold the edit access (anymore). 404 `nsure_agent_not_found`: the owner has no nSure account, so the cases could not be handed back - nothing has changed.
 */
export const returnAnalysisEditAccess = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/sharing/return`, method: 'POST', signal
    },
      options);
    }
  


export const getReturnAnalysisEditAccessMutationOptions = <TError = ReturnEditAccessBadRequestError | SharedAnalysisNotFoundError | ReturnEditAccessConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof returnAnalysisEditAccess>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof returnAnalysisEditAccess>>, TError,{analysisId: string;versionId: string}, TContext> => {

const mutationKey = ['returnAnalysisEditAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof returnAnalysisEditAccess>>, {analysisId: string;versionId: string}> = (props) => {
          const {analysisId,versionId} = props ?? {};

          return  returnAnalysisEditAccess(analysisId,versionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReturnAnalysisEditAccessMutationResult = NonNullable<Awaited<ReturnType<typeof returnAnalysisEditAccess>>>
    
    export type ReturnAnalysisEditAccessMutationError = ReturnEditAccessBadRequestError | SharedAnalysisNotFoundError | ReturnEditAccessConflictError

    export const useReturnAnalysisEditAccess = <TError = ReturnEditAccessBadRequestError | SharedAnalysisNotFoundError | ReturnEditAccessConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof returnAnalysisEditAccess>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof returnAnalysisEditAccess>>,
        TError,
        {analysisId: string;versionId: string},
        TContext
      > => {

      const mutationOptions = getReturnAnalysisEditAccessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Owner only - takes the edit access back from whoever holds it (that agent receives `analysis_edit_access_revoked` over the socket and keeps read-only access). Idempotent: when the owner already holds it, nothing happens (204). 404 `nsure_agent_not_found`: the owner has no nSure account, so the cases could not be handed back - nothing has changed.
 */
export const takeBackAnalysisEditAccess = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/sharing/take-back`, method: 'POST', signal
    },
      options);
    }
  


export const getTakeBackAnalysisEditAccessMutationOptions = <TError = AnalysisOwnerRequiredError | SharedAnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof takeBackAnalysisEditAccess>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof takeBackAnalysisEditAccess>>, TError,{analysisId: string;versionId: string}, TContext> => {

const mutationKey = ['takeBackAnalysisEditAccess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof takeBackAnalysisEditAccess>>, {analysisId: string;versionId: string}> = (props) => {
          const {analysisId,versionId} = props ?? {};

          return  takeBackAnalysisEditAccess(analysisId,versionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TakeBackAnalysisEditAccessMutationResult = NonNullable<Awaited<ReturnType<typeof takeBackAnalysisEditAccess>>>
    
    export type TakeBackAnalysisEditAccessMutationError = AnalysisOwnerRequiredError | SharedAnalysisNotFoundError

    export const useTakeBackAnalysisEditAccess = <TError = AnalysisOwnerRequiredError | SharedAnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof takeBackAnalysisEditAccess>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof takeBackAnalysisEditAccess>>,
        TError,
        {analysisId: string;versionId: string},
        TContext
      > => {

      const mutationOptions = getTakeBackAnalysisEditAccessMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAnalysisGoals = (
    analysisId: string,
    versionId: string,
    params?: GetAnalysisGoalsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<GoalsList>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAnalysisGoalsQueryKey = (analysisId?: string,
    versionId?: string,
    params?: GetAnalysisGoalsParams,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goals`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAnalysisGoalsQueryOptions = <TData = Awaited<ReturnType<typeof getAnalysisGoals>>, TError = GetGoalsBadRequestError | GetGoalsNotFoundError | GetGoalsConflictError | GetGoalsInternalError>(analysisId: string,
    versionId: string,
    params?: GetAnalysisGoalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisGoals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalysisGoalsQueryKey(analysisId,versionId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalysisGoals>>> = ({ signal }) => getAnalysisGoals(analysisId,versionId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalysisGoals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalysisGoalsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalysisGoals>>>
export type GetAnalysisGoalsQueryError = GetGoalsBadRequestError | GetGoalsNotFoundError | GetGoalsConflictError | GetGoalsInternalError


export function useGetAnalysisGoals<TData = Awaited<ReturnType<typeof getAnalysisGoals>>, TError = GetGoalsBadRequestError | GetGoalsNotFoundError | GetGoalsConflictError | GetGoalsInternalError>(
 analysisId: string,
    versionId: string,
    params: undefined |  GetAnalysisGoalsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisGoals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisGoals>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisGoals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisGoals<TData = Awaited<ReturnType<typeof getAnalysisGoals>>, TError = GetGoalsBadRequestError | GetGoalsNotFoundError | GetGoalsConflictError | GetGoalsInternalError>(
 analysisId: string,
    versionId: string,
    params?: GetAnalysisGoalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisGoals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalysisGoals>>,
          TError,
          Awaited<ReturnType<typeof getAnalysisGoals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalysisGoals<TData = Awaited<ReturnType<typeof getAnalysisGoals>>, TError = GetGoalsBadRequestError | GetGoalsNotFoundError | GetGoalsConflictError | GetGoalsInternalError>(
 analysisId: string,
    versionId: string,
    params?: GetAnalysisGoalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisGoals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAnalysisGoals<TData = Awaited<ReturnType<typeof getAnalysisGoals>>, TError = GetGoalsBadRequestError | GetGoalsNotFoundError | GetGoalsConflictError | GetGoalsInternalError>(
 analysisId: string,
    versionId: string,
    params?: GetAnalysisGoalsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalysisGoals>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalysisGoalsQueryOptions(analysisId,versionId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const deleteGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteGoalMutationOptions = <TError = AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGoal>>, TError,{analysisId: string;versionId: string;goalId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGoal>>, TError,{analysisId: string;versionId: string;goalId: string}, TContext> => {

const mutationKey = ['deleteGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGoal>>, {analysisId: string;versionId: string;goalId: string}> = (props) => {
          const {analysisId,versionId,goalId} = props ?? {};

          return  deleteGoal(analysisId,versionId,goalId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteGoalMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGoal>>>
    
    export type DeleteGoalMutationError = AnalysisWriteForbiddenError | GoalWriteNotFoundError

    export const useDeleteGoal = <TError = AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGoal>>, TError,{analysisId: string;versionId: string;goalId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGoal>>,
        TError,
        {analysisId: string;versionId: string;goalId: string},
        TContext
      > => {

      const mutationOptions = getDeleteGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateGoalProgressStatus = (
    analysisId: string,
    versionId: string,
    goalId: string,
    progressStatus: 'in_progress' | 'completed',
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/progress-status/${progressStatus}`, method: 'PATCH'
    },
      options);
    }
  


export const getUpdateGoalProgressStatusMutationOptions = <TError = GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGoalProgressStatus>>, TError,{analysisId: string;versionId: string;goalId: string;progressStatus: 'in_progress' | 'completed'}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGoalProgressStatus>>, TError,{analysisId: string;versionId: string;goalId: string;progressStatus: 'in_progress' | 'completed'}, TContext> => {

const mutationKey = ['updateGoalProgressStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGoalProgressStatus>>, {analysisId: string;versionId: string;goalId: string;progressStatus: 'in_progress' | 'completed'}> = (props) => {
          const {analysisId,versionId,goalId,progressStatus} = props ?? {};

          return  updateGoalProgressStatus(analysisId,versionId,goalId,progressStatus,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGoalProgressStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateGoalProgressStatus>>>
    
    export type UpdateGoalProgressStatusMutationError = GoalWriteNotFoundError

    export const useUpdateGoalProgressStatus = <TError = GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGoalProgressStatus>>, TError,{analysisId: string;versionId: string;goalId: string;progressStatus: 'in_progress' | 'completed'}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGoalProgressStatus>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;progressStatus: 'in_progress' | 'completed'},
        TContext
      > => {

      const mutationOptions = getUpdateGoalProgressStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateGoalLifecycleStatus = (
    analysisId: string,
    versionId: string,
    goalId: string,
    lifecycleStatus: 'active' | 'archived',
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/lifecycle-status/${lifecycleStatus}`, method: 'PATCH'
    },
      options);
    }
  


export const getUpdateGoalLifecycleStatusMutationOptions = <TError = GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGoalLifecycleStatus>>, TError,{analysisId: string;versionId: string;goalId: string;lifecycleStatus: 'active' | 'archived'}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGoalLifecycleStatus>>, TError,{analysisId: string;versionId: string;goalId: string;lifecycleStatus: 'active' | 'archived'}, TContext> => {

const mutationKey = ['updateGoalLifecycleStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGoalLifecycleStatus>>, {analysisId: string;versionId: string;goalId: string;lifecycleStatus: 'active' | 'archived'}> = (props) => {
          const {analysisId,versionId,goalId,lifecycleStatus} = props ?? {};

          return  updateGoalLifecycleStatus(analysisId,versionId,goalId,lifecycleStatus,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGoalLifecycleStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateGoalLifecycleStatus>>>
    
    export type UpdateGoalLifecycleStatusMutationError = GoalWriteNotFoundError

    export const useUpdateGoalLifecycleStatus = <TError = GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGoalLifecycleStatus>>, TError,{analysisId: string;versionId: string;goalId: string;lifecycleStatus: 'active' | 'archived'}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGoalLifecycleStatus>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;lifecycleStatus: 'active' | 'archived'},
        TContext
      > => {

      const mutationOptions = getUpdateGoalLifecycleStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createVehicleGoal = (
    analysisId: string,
    versionId: string,
    vehicleGoalDto: VehicleGoalDto,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<VehicleGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/vehicle`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vehicleGoalDto, signal
    },
      options);
    }
  


export const getCreateVehicleGoalMutationOptions = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicleGoal>>, TError,{analysisId: string;versionId: string;data: VehicleGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVehicleGoal>>, TError,{analysisId: string;versionId: string;data: VehicleGoalDto}, TContext> => {

const mutationKey = ['createVehicleGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVehicleGoal>>, {analysisId: string;versionId: string;data: VehicleGoalDto}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createVehicleGoal(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVehicleGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createVehicleGoal>>>
    export type CreateVehicleGoalMutationBody = VehicleGoalDto
    export type CreateVehicleGoalMutationError = AnalysisWriteForbiddenError | GetGoalsNotFoundError

    export const useCreateVehicleGoal = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicleGoal>>, TError,{analysisId: string;versionId: string;data: VehicleGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVehicleGoal>>,
        TError,
        {analysisId: string;versionId: string;data: VehicleGoalDto},
        TContext
      > => {

      const mutationOptions = getCreateVehicleGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateVehicleGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
    vehicleGoalDto: VehicleGoalDto,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<VehicleGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/vehicle`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: vehicleGoalDto
    },
      options);
    }
  


export const getUpdateVehicleGoalMutationOptions = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: VehicleGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVehicleGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: VehicleGoalDto}, TContext> => {

const mutationKey = ['updateVehicleGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVehicleGoal>>, {analysisId: string;versionId: string;goalId: string;data: VehicleGoalDto}> = (props) => {
          const {analysisId,versionId,goalId,data} = props ?? {};

          return  updateVehicleGoal(analysisId,versionId,goalId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVehicleGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updateVehicleGoal>>>
    export type UpdateVehicleGoalMutationBody = VehicleGoalDto
    export type UpdateVehicleGoalMutationError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError

    export const useUpdateVehicleGoal = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: VehicleGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVehicleGoal>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;data: VehicleGoalDto},
        TContext
      > => {

      const mutationOptions = getUpdateVehicleGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getVehicleGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<VehicleGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/vehicle`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVehicleGoalQueryKey = (analysisId?: string,
    versionId?: string,
    goalId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/vehicle`
    ] as const;
    }

    
export const getGetVehicleGoalQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleGoalQueryKey(analysisId,versionId,goalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleGoal>>> = ({ signal }) => getVehicleGoal(analysisId,versionId,goalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && goalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicleGoal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleGoalQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleGoal>>>
export type GetVehicleGoalQueryError = GoalTypeMismatchError | GoalWriteNotFoundError


export function useGetVehicleGoal<TData = Awaited<ReturnType<typeof getVehicleGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleGoal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleGoal>>,
          TError,
          Awaited<ReturnType<typeof getVehicleGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleGoal<TData = Awaited<ReturnType<typeof getVehicleGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleGoal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleGoal>>,
          TError,
          Awaited<ReturnType<typeof getVehicleGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleGoal<TData = Awaited<ReturnType<typeof getVehicleGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVehicleGoal<TData = Awaited<ReturnType<typeof getVehicleGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleGoalQueryOptions(analysisId,versionId,goalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createOtherGoal = (
    analysisId: string,
    versionId: string,
    otherGoalDto: OtherGoalDto,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<OtherGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/other`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: otherGoalDto, signal
    },
      options);
    }
  


export const getCreateOtherGoalMutationOptions = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOtherGoal>>, TError,{analysisId: string;versionId: string;data: OtherGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOtherGoal>>, TError,{analysisId: string;versionId: string;data: OtherGoalDto}, TContext> => {

const mutationKey = ['createOtherGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOtherGoal>>, {analysisId: string;versionId: string;data: OtherGoalDto}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createOtherGoal(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOtherGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createOtherGoal>>>
    export type CreateOtherGoalMutationBody = OtherGoalDto
    export type CreateOtherGoalMutationError = AnalysisWriteForbiddenError | GetGoalsNotFoundError

    export const useCreateOtherGoal = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOtherGoal>>, TError,{analysisId: string;versionId: string;data: OtherGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOtherGoal>>,
        TError,
        {analysisId: string;versionId: string;data: OtherGoalDto},
        TContext
      > => {

      const mutationOptions = getCreateOtherGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateOtherGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
    otherGoalDto: OtherGoalDto,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<OtherGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/other`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: otherGoalDto
    },
      options);
    }
  


export const getUpdateOtherGoalMutationOptions = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOtherGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: OtherGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOtherGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: OtherGoalDto}, TContext> => {

const mutationKey = ['updateOtherGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOtherGoal>>, {analysisId: string;versionId: string;goalId: string;data: OtherGoalDto}> = (props) => {
          const {analysisId,versionId,goalId,data} = props ?? {};

          return  updateOtherGoal(analysisId,versionId,goalId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOtherGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updateOtherGoal>>>
    export type UpdateOtherGoalMutationBody = OtherGoalDto
    export type UpdateOtherGoalMutationError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError

    export const useUpdateOtherGoal = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOtherGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: OtherGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOtherGoal>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;data: OtherGoalDto},
        TContext
      > => {

      const mutationOptions = getUpdateOtherGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getOtherGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<OtherGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/other`, method: 'GET', signal
    },
      options);
    }
  



export const getGetOtherGoalQueryKey = (analysisId?: string,
    versionId?: string,
    goalId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/other`
    ] as const;
    }

    
export const getGetOtherGoalQueryOptions = <TData = Awaited<ReturnType<typeof getOtherGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOtherGoalQueryKey(analysisId,versionId,goalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOtherGoal>>> = ({ signal }) => getOtherGoal(analysisId,versionId,goalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && goalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOtherGoal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOtherGoalQueryResult = NonNullable<Awaited<ReturnType<typeof getOtherGoal>>>
export type GetOtherGoalQueryError = GoalTypeMismatchError | GoalWriteNotFoundError


export function useGetOtherGoal<TData = Awaited<ReturnType<typeof getOtherGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherGoal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOtherGoal>>,
          TError,
          Awaited<ReturnType<typeof getOtherGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOtherGoal<TData = Awaited<ReturnType<typeof getOtherGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherGoal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOtherGoal>>,
          TError,
          Awaited<ReturnType<typeof getOtherGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOtherGoal<TData = Awaited<ReturnType<typeof getOtherGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOtherGoal<TData = Awaited<ReturnType<typeof getOtherGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOtherGoalQueryOptions(analysisId,versionId,goalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createFinancialReserveGoal = (
    analysisId: string,
    versionId: string,
    financialReserveGoalDto: FinancialReserveGoalDto,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FinancialReserveGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/financial-reserve`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: financialReserveGoalDto, signal
    },
      options);
    }
  


export const getCreateFinancialReserveGoalMutationOptions = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFinancialReserveGoal>>, TError,{analysisId: string;versionId: string;data: FinancialReserveGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFinancialReserveGoal>>, TError,{analysisId: string;versionId: string;data: FinancialReserveGoalDto}, TContext> => {

const mutationKey = ['createFinancialReserveGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFinancialReserveGoal>>, {analysisId: string;versionId: string;data: FinancialReserveGoalDto}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createFinancialReserveGoal(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFinancialReserveGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createFinancialReserveGoal>>>
    export type CreateFinancialReserveGoalMutationBody = FinancialReserveGoalDto
    export type CreateFinancialReserveGoalMutationError = AnalysisWriteForbiddenError | GetGoalsNotFoundError

    export const useCreateFinancialReserveGoal = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFinancialReserveGoal>>, TError,{analysisId: string;versionId: string;data: FinancialReserveGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFinancialReserveGoal>>,
        TError,
        {analysisId: string;versionId: string;data: FinancialReserveGoalDto},
        TContext
      > => {

      const mutationOptions = getCreateFinancialReserveGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateFinancialReserveGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
    financialReserveGoalDto: FinancialReserveGoalDto,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<FinancialReserveGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/financial-reserve`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: financialReserveGoalDto
    },
      options);
    }
  


export const getUpdateFinancialReserveGoalMutationOptions = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFinancialReserveGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: FinancialReserveGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFinancialReserveGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: FinancialReserveGoalDto}, TContext> => {

const mutationKey = ['updateFinancialReserveGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFinancialReserveGoal>>, {analysisId: string;versionId: string;goalId: string;data: FinancialReserveGoalDto}> = (props) => {
          const {analysisId,versionId,goalId,data} = props ?? {};

          return  updateFinancialReserveGoal(analysisId,versionId,goalId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFinancialReserveGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updateFinancialReserveGoal>>>
    export type UpdateFinancialReserveGoalMutationBody = FinancialReserveGoalDto
    export type UpdateFinancialReserveGoalMutationError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError

    export const useUpdateFinancialReserveGoal = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFinancialReserveGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: FinancialReserveGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFinancialReserveGoal>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;data: FinancialReserveGoalDto},
        TContext
      > => {

      const mutationOptions = getUpdateFinancialReserveGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getFinancialReserveGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FinancialReserveGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/financial-reserve`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFinancialReserveGoalQueryKey = (analysisId?: string,
    versionId?: string,
    goalId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/financial-reserve`
    ] as const;
    }

    
export const getGetFinancialReserveGoalQueryOptions = <TData = Awaited<ReturnType<typeof getFinancialReserveGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialReserveGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFinancialReserveGoalQueryKey(analysisId,versionId,goalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinancialReserveGoal>>> = ({ signal }) => getFinancialReserveGoal(analysisId,versionId,goalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && goalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFinancialReserveGoal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFinancialReserveGoalQueryResult = NonNullable<Awaited<ReturnType<typeof getFinancialReserveGoal>>>
export type GetFinancialReserveGoalQueryError = GoalTypeMismatchError | GoalWriteNotFoundError


export function useGetFinancialReserveGoal<TData = Awaited<ReturnType<typeof getFinancialReserveGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialReserveGoal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialReserveGoal>>,
          TError,
          Awaited<ReturnType<typeof getFinancialReserveGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialReserveGoal<TData = Awaited<ReturnType<typeof getFinancialReserveGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialReserveGoal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialReserveGoal>>,
          TError,
          Awaited<ReturnType<typeof getFinancialReserveGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialReserveGoal<TData = Awaited<ReturnType<typeof getFinancialReserveGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialReserveGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFinancialReserveGoal<TData = Awaited<ReturnType<typeof getFinancialReserveGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialReserveGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFinancialReserveGoalQueryOptions(analysisId,versionId,goalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createFamilyGoal = (
    analysisId: string,
    versionId: string,
    familyGoalDto: FamilyGoalDto,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FamilyGoalResponseDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/family`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: familyGoalDto, signal
    },
      options);
    }
  


export const getCreateFamilyGoalMutationOptions = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFamilyGoal>>, TError,{analysisId: string;versionId: string;data: FamilyGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFamilyGoal>>, TError,{analysisId: string;versionId: string;data: FamilyGoalDto}, TContext> => {

const mutationKey = ['createFamilyGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFamilyGoal>>, {analysisId: string;versionId: string;data: FamilyGoalDto}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createFamilyGoal(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFamilyGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createFamilyGoal>>>
    export type CreateFamilyGoalMutationBody = FamilyGoalDto
    export type CreateFamilyGoalMutationError = AnalysisWriteForbiddenError | GetGoalsNotFoundError

    export const useCreateFamilyGoal = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFamilyGoal>>, TError,{analysisId: string;versionId: string;data: FamilyGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFamilyGoal>>,
        TError,
        {analysisId: string;versionId: string;data: FamilyGoalDto},
        TContext
      > => {

      const mutationOptions = getCreateFamilyGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateFamilyGoal = (
    analysisId: string,
    versionId: string,
    groupId: string,
    familyGoalDto: FamilyGoalDto,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<FamilyGoalResponseDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/family/${groupId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: familyGoalDto
    },
      options);
    }
  


export const getUpdateFamilyGoalMutationOptions = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFamilyGoal>>, TError,{analysisId: string;versionId: string;groupId: string;data: FamilyGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFamilyGoal>>, TError,{analysisId: string;versionId: string;groupId: string;data: FamilyGoalDto}, TContext> => {

const mutationKey = ['updateFamilyGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFamilyGoal>>, {analysisId: string;versionId: string;groupId: string;data: FamilyGoalDto}> = (props) => {
          const {analysisId,versionId,groupId,data} = props ?? {};

          return  updateFamilyGoal(analysisId,versionId,groupId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFamilyGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updateFamilyGoal>>>
    export type UpdateFamilyGoalMutationBody = FamilyGoalDto
    export type UpdateFamilyGoalMutationError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError

    export const useUpdateFamilyGoal = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFamilyGoal>>, TError,{analysisId: string;versionId: string;groupId: string;data: FamilyGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFamilyGoal>>,
        TError,
        {analysisId: string;versionId: string;groupId: string;data: FamilyGoalDto},
        TContext
      > => {

      const mutationOptions = getUpdateFamilyGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getFamilyGoal = (
    analysisId: string,
    versionId: string,
    groupId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FamilyGoalResponseDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/family/${groupId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFamilyGoalQueryKey = (analysisId?: string,
    versionId?: string,
    groupId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goals/family/${groupId}`
    ] as const;
    }

    
export const getGetFamilyGoalQueryOptions = <TData = Awaited<ReturnType<typeof getFamilyGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(analysisId: string,
    versionId: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFamilyGoalQueryKey(analysisId,versionId,groupId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFamilyGoal>>> = ({ signal }) => getFamilyGoal(analysisId,versionId,groupId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && groupId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFamilyGoalQueryResult = NonNullable<Awaited<ReturnType<typeof getFamilyGoal>>>
export type GetFamilyGoalQueryError = GoalTypeMismatchError | GoalWriteNotFoundError


export function useGetFamilyGoal<TData = Awaited<ReturnType<typeof getFamilyGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    groupId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFamilyGoal>>,
          TError,
          Awaited<ReturnType<typeof getFamilyGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFamilyGoal<TData = Awaited<ReturnType<typeof getFamilyGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFamilyGoal>>,
          TError,
          Awaited<ReturnType<typeof getFamilyGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFamilyGoal<TData = Awaited<ReturnType<typeof getFamilyGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFamilyGoal<TData = Awaited<ReturnType<typeof getFamilyGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFamilyGoalQueryOptions(analysisId,versionId,groupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createPensionGoal = (
    analysisId: string,
    versionId: string,
    pensionGoalDto: PensionGoalDto,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<PensionGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/pension`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pensionGoalDto, signal
    },
      options);
    }
  


export const getCreatePensionGoalMutationOptions = <TError = ClientBirthDateMissingError | AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPensionGoal>>, TError,{analysisId: string;versionId: string;data: PensionGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPensionGoal>>, TError,{analysisId: string;versionId: string;data: PensionGoalDto}, TContext> => {

const mutationKey = ['createPensionGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPensionGoal>>, {analysisId: string;versionId: string;data: PensionGoalDto}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createPensionGoal(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePensionGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createPensionGoal>>>
    export type CreatePensionGoalMutationBody = PensionGoalDto
    export type CreatePensionGoalMutationError = ClientBirthDateMissingError | AnalysisWriteForbiddenError | GetGoalsNotFoundError

    export const useCreatePensionGoal = <TError = ClientBirthDateMissingError | AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPensionGoal>>, TError,{analysisId: string;versionId: string;data: PensionGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPensionGoal>>,
        TError,
        {analysisId: string;versionId: string;data: PensionGoalDto},
        TContext
      > => {

      const mutationOptions = getCreatePensionGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updatePensionGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
    pensionGoalDto: PensionGoalDto,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<PensionGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/pension`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: pensionGoalDto
    },
      options);
    }
  


export const getUpdatePensionGoalMutationOptions = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePensionGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: PensionGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePensionGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: PensionGoalDto}, TContext> => {

const mutationKey = ['updatePensionGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePensionGoal>>, {analysisId: string;versionId: string;goalId: string;data: PensionGoalDto}> = (props) => {
          const {analysisId,versionId,goalId,data} = props ?? {};

          return  updatePensionGoal(analysisId,versionId,goalId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePensionGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updatePensionGoal>>>
    export type UpdatePensionGoalMutationBody = PensionGoalDto
    export type UpdatePensionGoalMutationError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError

    export const useUpdatePensionGoal = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePensionGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: PensionGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePensionGoal>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;data: PensionGoalDto},
        TContext
      > => {

      const mutationOptions = getUpdatePensionGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getPensionGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<PensionGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/pension`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPensionGoalQueryKey = (analysisId?: string,
    versionId?: string,
    goalId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/pension`
    ] as const;
    }

    
export const getGetPensionGoalQueryOptions = <TData = Awaited<ReturnType<typeof getPensionGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPensionGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPensionGoalQueryKey(analysisId,versionId,goalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPensionGoal>>> = ({ signal }) => getPensionGoal(analysisId,versionId,goalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && goalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPensionGoal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPensionGoalQueryResult = NonNullable<Awaited<ReturnType<typeof getPensionGoal>>>
export type GetPensionGoalQueryError = GoalTypeMismatchError | GoalWriteNotFoundError


export function useGetPensionGoal<TData = Awaited<ReturnType<typeof getPensionGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPensionGoal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPensionGoal>>,
          TError,
          Awaited<ReturnType<typeof getPensionGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPensionGoal<TData = Awaited<ReturnType<typeof getPensionGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPensionGoal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPensionGoal>>,
          TError,
          Awaited<ReturnType<typeof getPensionGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPensionGoal<TData = Awaited<ReturnType<typeof getPensionGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPensionGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPensionGoal<TData = Awaited<ReturnType<typeof getPensionGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPensionGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPensionGoalQueryOptions(analysisId,versionId,goalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createHousingPropertyGoal = (
    analysisId: string,
    versionId: string,
    housingPropertyGoalDto: HousingPropertyGoalDto,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<HousingPropertyGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/housing/property`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: housingPropertyGoalDto, signal
    },
      options);
    }
  


export const getCreateHousingPropertyGoalMutationOptions = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHousingPropertyGoal>>, TError,{analysisId: string;versionId: string;data: HousingPropertyGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHousingPropertyGoal>>, TError,{analysisId: string;versionId: string;data: HousingPropertyGoalDto}, TContext> => {

const mutationKey = ['createHousingPropertyGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHousingPropertyGoal>>, {analysisId: string;versionId: string;data: HousingPropertyGoalDto}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createHousingPropertyGoal(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateHousingPropertyGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createHousingPropertyGoal>>>
    export type CreateHousingPropertyGoalMutationBody = HousingPropertyGoalDto
    export type CreateHousingPropertyGoalMutationError = AnalysisWriteForbiddenError | GetGoalsNotFoundError

    export const useCreateHousingPropertyGoal = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHousingPropertyGoal>>, TError,{analysisId: string;versionId: string;data: HousingPropertyGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createHousingPropertyGoal>>,
        TError,
        {analysisId: string;versionId: string;data: HousingPropertyGoalDto},
        TContext
      > => {

      const mutationOptions = getCreateHousingPropertyGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateHousingPropertyGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
    housingPropertyGoalDto: HousingPropertyGoalDto,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<HousingPropertyGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/housing/property`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: housingPropertyGoalDto
    },
      options);
    }
  


export const getUpdateHousingPropertyGoalMutationOptions = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHousingPropertyGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: HousingPropertyGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHousingPropertyGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: HousingPropertyGoalDto}, TContext> => {

const mutationKey = ['updateHousingPropertyGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHousingPropertyGoal>>, {analysisId: string;versionId: string;goalId: string;data: HousingPropertyGoalDto}> = (props) => {
          const {analysisId,versionId,goalId,data} = props ?? {};

          return  updateHousingPropertyGoal(analysisId,versionId,goalId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateHousingPropertyGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updateHousingPropertyGoal>>>
    export type UpdateHousingPropertyGoalMutationBody = HousingPropertyGoalDto
    export type UpdateHousingPropertyGoalMutationError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError

    export const useUpdateHousingPropertyGoal = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHousingPropertyGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: HousingPropertyGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateHousingPropertyGoal>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;data: HousingPropertyGoalDto},
        TContext
      > => {

      const mutationOptions = getUpdateHousingPropertyGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getHousingPropertyGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<HousingPropertyGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/housing/property`, method: 'GET', signal
    },
      options);
    }
  



export const getGetHousingPropertyGoalQueryKey = (analysisId?: string,
    versionId?: string,
    goalId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/housing/property`
    ] as const;
    }

    
export const getGetHousingPropertyGoalQueryOptions = <TData = Awaited<ReturnType<typeof getHousingPropertyGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingPropertyGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHousingPropertyGoalQueryKey(analysisId,versionId,goalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHousingPropertyGoal>>> = ({ signal }) => getHousingPropertyGoal(analysisId,versionId,goalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && goalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHousingPropertyGoal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHousingPropertyGoalQueryResult = NonNullable<Awaited<ReturnType<typeof getHousingPropertyGoal>>>
export type GetHousingPropertyGoalQueryError = GoalTypeMismatchError | GoalWriteNotFoundError


export function useGetHousingPropertyGoal<TData = Awaited<ReturnType<typeof getHousingPropertyGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingPropertyGoal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHousingPropertyGoal>>,
          TError,
          Awaited<ReturnType<typeof getHousingPropertyGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHousingPropertyGoal<TData = Awaited<ReturnType<typeof getHousingPropertyGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingPropertyGoal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHousingPropertyGoal>>,
          TError,
          Awaited<ReturnType<typeof getHousingPropertyGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHousingPropertyGoal<TData = Awaited<ReturnType<typeof getHousingPropertyGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingPropertyGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetHousingPropertyGoal<TData = Awaited<ReturnType<typeof getHousingPropertyGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingPropertyGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHousingPropertyGoalQueryOptions(analysisId,versionId,goalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createHousingMortgageGoal = (
    analysisId: string,
    versionId: string,
    housingMortgageGoalDto: HousingMortgageGoalDto,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<HousingMortgageGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/housing/mortgage`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: housingMortgageGoalDto, signal
    },
      options);
    }
  


export const getCreateHousingMortgageGoalMutationOptions = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHousingMortgageGoal>>, TError,{analysisId: string;versionId: string;data: HousingMortgageGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHousingMortgageGoal>>, TError,{analysisId: string;versionId: string;data: HousingMortgageGoalDto}, TContext> => {

const mutationKey = ['createHousingMortgageGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHousingMortgageGoal>>, {analysisId: string;versionId: string;data: HousingMortgageGoalDto}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createHousingMortgageGoal(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateHousingMortgageGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createHousingMortgageGoal>>>
    export type CreateHousingMortgageGoalMutationBody = HousingMortgageGoalDto
    export type CreateHousingMortgageGoalMutationError = AnalysisWriteForbiddenError | GetGoalsNotFoundError

    export const useCreateHousingMortgageGoal = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHousingMortgageGoal>>, TError,{analysisId: string;versionId: string;data: HousingMortgageGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createHousingMortgageGoal>>,
        TError,
        {analysisId: string;versionId: string;data: HousingMortgageGoalDto},
        TContext
      > => {

      const mutationOptions = getCreateHousingMortgageGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateHousingMortgageGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
    housingMortgageGoalDto: HousingMortgageGoalDto,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<HousingMortgageGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/housing/mortgage`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: housingMortgageGoalDto
    },
      options);
    }
  


export const getUpdateHousingMortgageGoalMutationOptions = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHousingMortgageGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: HousingMortgageGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHousingMortgageGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: HousingMortgageGoalDto}, TContext> => {

const mutationKey = ['updateHousingMortgageGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHousingMortgageGoal>>, {analysisId: string;versionId: string;goalId: string;data: HousingMortgageGoalDto}> = (props) => {
          const {analysisId,versionId,goalId,data} = props ?? {};

          return  updateHousingMortgageGoal(analysisId,versionId,goalId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateHousingMortgageGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updateHousingMortgageGoal>>>
    export type UpdateHousingMortgageGoalMutationBody = HousingMortgageGoalDto
    export type UpdateHousingMortgageGoalMutationError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError

    export const useUpdateHousingMortgageGoal = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHousingMortgageGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: HousingMortgageGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateHousingMortgageGoal>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;data: HousingMortgageGoalDto},
        TContext
      > => {

      const mutationOptions = getUpdateHousingMortgageGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getHousingMortgageGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<HousingMortgageGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/housing/mortgage`, method: 'GET', signal
    },
      options);
    }
  



export const getGetHousingMortgageGoalQueryKey = (analysisId?: string,
    versionId?: string,
    goalId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/housing/mortgage`
    ] as const;
    }

    
export const getGetHousingMortgageGoalQueryOptions = <TData = Awaited<ReturnType<typeof getHousingMortgageGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingMortgageGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHousingMortgageGoalQueryKey(analysisId,versionId,goalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHousingMortgageGoal>>> = ({ signal }) => getHousingMortgageGoal(analysisId,versionId,goalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && goalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHousingMortgageGoal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHousingMortgageGoalQueryResult = NonNullable<Awaited<ReturnType<typeof getHousingMortgageGoal>>>
export type GetHousingMortgageGoalQueryError = GoalTypeMismatchError | GoalWriteNotFoundError


export function useGetHousingMortgageGoal<TData = Awaited<ReturnType<typeof getHousingMortgageGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingMortgageGoal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHousingMortgageGoal>>,
          TError,
          Awaited<ReturnType<typeof getHousingMortgageGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHousingMortgageGoal<TData = Awaited<ReturnType<typeof getHousingMortgageGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingMortgageGoal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHousingMortgageGoal>>,
          TError,
          Awaited<ReturnType<typeof getHousingMortgageGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHousingMortgageGoal<TData = Awaited<ReturnType<typeof getHousingMortgageGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingMortgageGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetHousingMortgageGoal<TData = Awaited<ReturnType<typeof getHousingMortgageGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingMortgageGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHousingMortgageGoalQueryOptions(analysisId,versionId,goalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createHousingOtherGoal = (
    analysisId: string,
    versionId: string,
    housingOtherGoalDto: HousingOtherGoalDto,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<HousingOtherGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/housing/other`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: housingOtherGoalDto, signal
    },
      options);
    }
  


export const getCreateHousingOtherGoalMutationOptions = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHousingOtherGoal>>, TError,{analysisId: string;versionId: string;data: HousingOtherGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createHousingOtherGoal>>, TError,{analysisId: string;versionId: string;data: HousingOtherGoalDto}, TContext> => {

const mutationKey = ['createHousingOtherGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHousingOtherGoal>>, {analysisId: string;versionId: string;data: HousingOtherGoalDto}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createHousingOtherGoal(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateHousingOtherGoalMutationResult = NonNullable<Awaited<ReturnType<typeof createHousingOtherGoal>>>
    export type CreateHousingOtherGoalMutationBody = HousingOtherGoalDto
    export type CreateHousingOtherGoalMutationError = AnalysisWriteForbiddenError | GetGoalsNotFoundError

    export const useCreateHousingOtherGoal = <TError = AnalysisWriteForbiddenError | GetGoalsNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHousingOtherGoal>>, TError,{analysisId: string;versionId: string;data: HousingOtherGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createHousingOtherGoal>>,
        TError,
        {analysisId: string;versionId: string;data: HousingOtherGoalDto},
        TContext
      > => {

      const mutationOptions = getCreateHousingOtherGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateHousingOtherGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
    housingOtherGoalDto: HousingOtherGoalDto,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<HousingOtherGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/housing/other`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: housingOtherGoalDto
    },
      options);
    }
  


export const getUpdateHousingOtherGoalMutationOptions = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHousingOtherGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: HousingOtherGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateHousingOtherGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: HousingOtherGoalDto}, TContext> => {

const mutationKey = ['updateHousingOtherGoal'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHousingOtherGoal>>, {analysisId: string;versionId: string;goalId: string;data: HousingOtherGoalDto}> = (props) => {
          const {analysisId,versionId,goalId,data} = props ?? {};

          return  updateHousingOtherGoal(analysisId,versionId,goalId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateHousingOtherGoalMutationResult = NonNullable<Awaited<ReturnType<typeof updateHousingOtherGoal>>>
    export type UpdateHousingOtherGoalMutationBody = HousingOtherGoalDto
    export type UpdateHousingOtherGoalMutationError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError

    export const useUpdateHousingOtherGoal = <TError = GoalTypeMismatchError | AnalysisWriteForbiddenError | GoalWriteNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHousingOtherGoal>>, TError,{analysisId: string;versionId: string;goalId: string;data: HousingOtherGoalDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateHousingOtherGoal>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;data: HousingOtherGoalDto},
        TContext
      > => {

      const mutationOptions = getUpdateHousingOtherGoalMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getHousingOtherGoal = (
    analysisId: string,
    versionId: string,
    goalId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<HousingOtherGoalDto>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/housing/other`, method: 'GET', signal
    },
      options);
    }
  



export const getGetHousingOtherGoalQueryKey = (analysisId?: string,
    versionId?: string,
    goalId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/housing/other`
    ] as const;
    }

    
export const getGetHousingOtherGoalQueryOptions = <TData = Awaited<ReturnType<typeof getHousingOtherGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingOtherGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHousingOtherGoalQueryKey(analysisId,versionId,goalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHousingOtherGoal>>> = ({ signal }) => getHousingOtherGoal(analysisId,versionId,goalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && goalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHousingOtherGoal>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHousingOtherGoalQueryResult = NonNullable<Awaited<ReturnType<typeof getHousingOtherGoal>>>
export type GetHousingOtherGoalQueryError = GoalTypeMismatchError | GoalWriteNotFoundError


export function useGetHousingOtherGoal<TData = Awaited<ReturnType<typeof getHousingOtherGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingOtherGoal>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHousingOtherGoal>>,
          TError,
          Awaited<ReturnType<typeof getHousingOtherGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHousingOtherGoal<TData = Awaited<ReturnType<typeof getHousingOtherGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingOtherGoal>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHousingOtherGoal>>,
          TError,
          Awaited<ReturnType<typeof getHousingOtherGoal>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHousingOtherGoal<TData = Awaited<ReturnType<typeof getHousingOtherGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingOtherGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetHousingOtherGoal<TData = Awaited<ReturnType<typeof getHousingOtherGoal>>, TError = GoalTypeMismatchError | GoalWriteNotFoundError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingOtherGoal>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHousingOtherGoalQueryOptions(analysisId,versionId,goalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getAssetAllocationOverview = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<PortfolioAssetAllocationOverview>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goal-fulfillment/asset-allocation-overview`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAssetAllocationOverviewQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goal-fulfillment/asset-allocation-overview`
    ] as const;
    }

    
export const getGetAssetAllocationOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getAssetAllocationOverview>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAllocationOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetAllocationOverviewQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetAllocationOverview>>> = ({ signal }) => getAssetAllocationOverview(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetAllocationOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetAllocationOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetAllocationOverview>>>
export type GetAssetAllocationOverviewQueryError = AnalysisNotFoundError


export function useGetAssetAllocationOverview<TData = Awaited<ReturnType<typeof getAssetAllocationOverview>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAllocationOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetAllocationOverview>>,
          TError,
          Awaited<ReturnType<typeof getAssetAllocationOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetAllocationOverview<TData = Awaited<ReturnType<typeof getAssetAllocationOverview>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAllocationOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetAllocationOverview>>,
          TError,
          Awaited<ReturnType<typeof getAssetAllocationOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetAllocationOverview<TData = Awaited<ReturnType<typeof getAssetAllocationOverview>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAllocationOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAssetAllocationOverview<TData = Awaited<ReturnType<typeof getAssetAllocationOverview>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAllocationOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetAllocationOverviewQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listCurrentSolutionAssetOptions = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<CurrentSolutionAssetOptionsList>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goal-fulfillment/asset-options`, method: 'GET', signal
    },
      options);
    }
  



export const getListCurrentSolutionAssetOptionsQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goal-fulfillment/asset-options`
    ] as const;
    }

    
export const getListCurrentSolutionAssetOptionsQueryOptions = <TData = Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCurrentSolutionAssetOptionsQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>> = ({ signal }) => listCurrentSolutionAssetOptions(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCurrentSolutionAssetOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>>
export type ListCurrentSolutionAssetOptionsQueryError = AnalysisNotFoundError


export function useListCurrentSolutionAssetOptions<TData = Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>,
          TError,
          Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCurrentSolutionAssetOptions<TData = Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>,
          TError,
          Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCurrentSolutionAssetOptions<TData = Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCurrentSolutionAssetOptions<TData = Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCurrentSolutionAssetOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCurrentSolutionAssetOptionsQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getGoalModelingDetail = (
    analysisId: string,
    versionId: string,
    goalId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<GoalModeling>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/modeling`, method: 'GET', signal
    },
      options);
    }
  



export const getGetGoalModelingDetailQueryKey = (analysisId?: string,
    versionId?: string,
    goalId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/modeling`
    ] as const;
    }

    
export const getGetGoalModelingDetailQueryOptions = <TData = Awaited<ReturnType<typeof getGoalModelingDetail>>, TError = GoalNotFoundError | ModelingSnapshotMissingError>(analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoalModelingDetailQueryKey(analysisId,versionId,goalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoalModelingDetail>>> = ({ signal }) => getGoalModelingDetail(analysisId,versionId,goalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && goalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGoalModelingDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getGoalModelingDetail>>>
export type GetGoalModelingDetailQueryError = GoalNotFoundError | ModelingSnapshotMissingError


export function useGetGoalModelingDetail<TData = Awaited<ReturnType<typeof getGoalModelingDetail>>, TError = GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoalModelingDetail>>,
          TError,
          Awaited<ReturnType<typeof getGoalModelingDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoalModelingDetail<TData = Awaited<ReturnType<typeof getGoalModelingDetail>>, TError = GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoalModelingDetail>>,
          TError,
          Awaited<ReturnType<typeof getGoalModelingDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoalModelingDetail<TData = Awaited<ReturnType<typeof getGoalModelingDetail>>, TError = GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGoalModelingDetail<TData = Awaited<ReturnType<typeof getGoalModelingDetail>>, TError = GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGoalModelingDetailQueryOptions(analysisId,versionId,goalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getGoalModelingAssetOptions = (
    analysisId: string,
    versionId: string,
    goalId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AssetOptionsList>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/modeling/asset-options`, method: 'GET', signal
    },
      options);
    }
  



export const getGetGoalModelingAssetOptionsQueryKey = (analysisId?: string,
    versionId?: string,
    goalId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/modeling/asset-options`
    ] as const;
    }

    
export const getGetGoalModelingAssetOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getGoalModelingAssetOptions>>, TError = GoalNotFoundError | ModelingSnapshotMissingError>(analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingAssetOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoalModelingAssetOptionsQueryKey(analysisId,versionId,goalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoalModelingAssetOptions>>> = ({ signal }) => getGoalModelingAssetOptions(analysisId,versionId,goalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && goalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingAssetOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGoalModelingAssetOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getGoalModelingAssetOptions>>>
export type GetGoalModelingAssetOptionsQueryError = GoalNotFoundError | ModelingSnapshotMissingError


export function useGetGoalModelingAssetOptions<TData = Awaited<ReturnType<typeof getGoalModelingAssetOptions>>, TError = GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingAssetOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoalModelingAssetOptions>>,
          TError,
          Awaited<ReturnType<typeof getGoalModelingAssetOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoalModelingAssetOptions<TData = Awaited<ReturnType<typeof getGoalModelingAssetOptions>>, TError = GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingAssetOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoalModelingAssetOptions>>,
          TError,
          Awaited<ReturnType<typeof getGoalModelingAssetOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGoalModelingAssetOptions<TData = Awaited<ReturnType<typeof getGoalModelingAssetOptions>>, TError = GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingAssetOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetGoalModelingAssetOptions<TData = Awaited<ReturnType<typeof getGoalModelingAssetOptions>>, TError = GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoalModelingAssetOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGoalModelingAssetOptionsQueryOptions(analysisId,versionId,goalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createGoalModelingAllocatedAmount = (
    analysisId: string,
    versionId: string,
    goalId: string,
    createAllocatedAmountBody: CreateAllocatedAmountBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AllocatedAmount>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/modeling/allocated-amounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAllocatedAmountBody, signal
    },
      options);
    }
  


export const getCreateGoalModelingAllocatedAmountMutationOptions = <TError = AnalysisWriteForbiddenError | AllocatedAmountWriteNotFoundError | AllocatedAmountConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGoalModelingAllocatedAmount>>, TError,{analysisId: string;versionId: string;goalId: string;data: CreateAllocatedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createGoalModelingAllocatedAmount>>, TError,{analysisId: string;versionId: string;goalId: string;data: CreateAllocatedAmountBody}, TContext> => {

const mutationKey = ['createGoalModelingAllocatedAmount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGoalModelingAllocatedAmount>>, {analysisId: string;versionId: string;goalId: string;data: CreateAllocatedAmountBody}> = (props) => {
          const {analysisId,versionId,goalId,data} = props ?? {};

          return  createGoalModelingAllocatedAmount(analysisId,versionId,goalId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateGoalModelingAllocatedAmountMutationResult = NonNullable<Awaited<ReturnType<typeof createGoalModelingAllocatedAmount>>>
    export type CreateGoalModelingAllocatedAmountMutationBody = CreateAllocatedAmountBody
    export type CreateGoalModelingAllocatedAmountMutationError = AnalysisWriteForbiddenError | AllocatedAmountWriteNotFoundError | AllocatedAmountConflictError

    export const useCreateGoalModelingAllocatedAmount = <TError = AnalysisWriteForbiddenError | AllocatedAmountWriteNotFoundError | AllocatedAmountConflictError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGoalModelingAllocatedAmount>>, TError,{analysisId: string;versionId: string;goalId: string;data: CreateAllocatedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGoalModelingAllocatedAmount>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;data: CreateAllocatedAmountBody},
        TContext
      > => {

      const mutationOptions = getCreateGoalModelingAllocatedAmountMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateGoalModelingAllocatedAmount = (
    analysisId: string,
    versionId: string,
    goalId: string,
    allocatedAmountId: number,
    updateAllocatedAmountBody: UpdateAllocatedAmountBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AllocatedAmount>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/modeling/allocated-amounts/${allocatedAmountId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateAllocatedAmountBody
    },
      options);
    }
  


export const getUpdateGoalModelingAllocatedAmountMutationOptions = <TError = AnalysisWriteForbiddenError | AllocatedAmountNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGoalModelingAllocatedAmount>>, TError,{analysisId: string;versionId: string;goalId: string;allocatedAmountId: number;data: UpdateAllocatedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGoalModelingAllocatedAmount>>, TError,{analysisId: string;versionId: string;goalId: string;allocatedAmountId: number;data: UpdateAllocatedAmountBody}, TContext> => {

const mutationKey = ['updateGoalModelingAllocatedAmount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGoalModelingAllocatedAmount>>, {analysisId: string;versionId: string;goalId: string;allocatedAmountId: number;data: UpdateAllocatedAmountBody}> = (props) => {
          const {analysisId,versionId,goalId,allocatedAmountId,data} = props ?? {};

          return  updateGoalModelingAllocatedAmount(analysisId,versionId,goalId,allocatedAmountId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGoalModelingAllocatedAmountMutationResult = NonNullable<Awaited<ReturnType<typeof updateGoalModelingAllocatedAmount>>>
    export type UpdateGoalModelingAllocatedAmountMutationBody = UpdateAllocatedAmountBody
    export type UpdateGoalModelingAllocatedAmountMutationError = AnalysisWriteForbiddenError | AllocatedAmountNotFoundError

    export const useUpdateGoalModelingAllocatedAmount = <TError = AnalysisWriteForbiddenError | AllocatedAmountNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGoalModelingAllocatedAmount>>, TError,{analysisId: string;versionId: string;goalId: string;allocatedAmountId: number;data: UpdateAllocatedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGoalModelingAllocatedAmount>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;allocatedAmountId: number;data: UpdateAllocatedAmountBody},
        TContext
      > => {

      const mutationOptions = getUpdateGoalModelingAllocatedAmountMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteGoalModelingAllocatedAmount = (
    analysisId: string,
    versionId: string,
    goalId: string,
    allocatedAmountId: number,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/goals/${goalId}/modeling/allocated-amounts/${allocatedAmountId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteGoalModelingAllocatedAmountMutationOptions = <TError = AnalysisWriteForbiddenError | AllocatedAmountNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGoalModelingAllocatedAmount>>, TError,{analysisId: string;versionId: string;goalId: string;allocatedAmountId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGoalModelingAllocatedAmount>>, TError,{analysisId: string;versionId: string;goalId: string;allocatedAmountId: number}, TContext> => {

const mutationKey = ['deleteGoalModelingAllocatedAmount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGoalModelingAllocatedAmount>>, {analysisId: string;versionId: string;goalId: string;allocatedAmountId: number}> = (props) => {
          const {analysisId,versionId,goalId,allocatedAmountId} = props ?? {};

          return  deleteGoalModelingAllocatedAmount(analysisId,versionId,goalId,allocatedAmountId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteGoalModelingAllocatedAmountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGoalModelingAllocatedAmount>>>
    
    export type DeleteGoalModelingAllocatedAmountMutationError = AnalysisWriteForbiddenError | AllocatedAmountNotFoundError

    export const useDeleteGoalModelingAllocatedAmount = <TError = AnalysisWriteForbiddenError | AllocatedAmountNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGoalModelingAllocatedAmount>>, TError,{analysisId: string;versionId: string;goalId: string;allocatedAmountId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteGoalModelingAllocatedAmount>>,
        TError,
        {analysisId: string;versionId: string;goalId: string;allocatedAmountId: number},
        TContext
      > => {

      const mutationOptions = getDeleteGoalModelingAllocatedAmountMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getModelingAvailableAmount = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AvailableAmount>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/available-amount`, method: 'GET', signal
    },
      options);
    }
  



export const getGetModelingAvailableAmountQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/modeling/available-amount`
    ] as const;
    }

    
export const getGetModelingAvailableAmountQueryOptions = <TData = Awaited<ReturnType<typeof getModelingAvailableAmount>>, TError = ModelingSnapshotMissingError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAmount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelingAvailableAmountQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelingAvailableAmount>>> = ({ signal }) => getModelingAvailableAmount(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAmount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelingAvailableAmountQueryResult = NonNullable<Awaited<ReturnType<typeof getModelingAvailableAmount>>>
export type GetModelingAvailableAmountQueryError = ModelingSnapshotMissingError


export function useGetModelingAvailableAmount<TData = Awaited<ReturnType<typeof getModelingAvailableAmount>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAmount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelingAvailableAmount>>,
          TError,
          Awaited<ReturnType<typeof getModelingAvailableAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelingAvailableAmount<TData = Awaited<ReturnType<typeof getModelingAvailableAmount>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAmount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelingAvailableAmount>>,
          TError,
          Awaited<ReturnType<typeof getModelingAvailableAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelingAvailableAmount<TData = Awaited<ReturnType<typeof getModelingAvailableAmount>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAmount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetModelingAvailableAmount<TData = Awaited<ReturnType<typeof getModelingAvailableAmount>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAmount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelingAvailableAmountQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getModelingAvailableAssetAmount = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AvailableAmount>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/available-asset-amount`, method: 'GET', signal
    },
      options);
    }
  



export const getGetModelingAvailableAssetAmountQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/modeling/available-asset-amount`
    ] as const;
    }

    
export const getGetModelingAvailableAssetAmountQueryOptions = <TData = Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>, TError = ModelingSnapshotMissingError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelingAvailableAssetAmountQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>> = ({ signal }) => getModelingAvailableAssetAmount(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelingAvailableAssetAmountQueryResult = NonNullable<Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>>
export type GetModelingAvailableAssetAmountQueryError = ModelingSnapshotMissingError


export function useGetModelingAvailableAssetAmount<TData = Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>,
          TError,
          Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelingAvailableAssetAmount<TData = Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>,
          TError,
          Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelingAvailableAssetAmount<TData = Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetModelingAvailableAssetAmount<TData = Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingAvailableAssetAmount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelingAvailableAssetAmountQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getModelingRecapitulation = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ModelingRecapitulation>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/recapitulation`, method: 'GET', signal
    },
      options);
    }
  



export const getGetModelingRecapitulationQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/modeling/recapitulation`
    ] as const;
    }

    
export const getGetModelingRecapitulationQueryOptions = <TData = Awaited<ReturnType<typeof getModelingRecapitulation>>, TError = ModelingSnapshotMissingError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingRecapitulation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelingRecapitulationQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelingRecapitulation>>> = ({ signal }) => getModelingRecapitulation(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelingRecapitulation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelingRecapitulationQueryResult = NonNullable<Awaited<ReturnType<typeof getModelingRecapitulation>>>
export type GetModelingRecapitulationQueryError = ModelingSnapshotMissingError


export function useGetModelingRecapitulation<TData = Awaited<ReturnType<typeof getModelingRecapitulation>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingRecapitulation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelingRecapitulation>>,
          TError,
          Awaited<ReturnType<typeof getModelingRecapitulation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelingRecapitulation<TData = Awaited<ReturnType<typeof getModelingRecapitulation>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingRecapitulation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelingRecapitulation>>,
          TError,
          Awaited<ReturnType<typeof getModelingRecapitulation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelingRecapitulation<TData = Awaited<ReturnType<typeof getModelingRecapitulation>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingRecapitulation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetModelingRecapitulation<TData = Awaited<ReturnType<typeof getModelingRecapitulation>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingRecapitulation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelingRecapitulationQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getModelingInsuranceExpenses = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<InsuranceExpenses>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/insurance-expenses`, method: 'GET', signal
    },
      options);
    }
  



export const getGetModelingInsuranceExpensesQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/modeling/insurance-expenses`
    ] as const;
    }

    
export const getGetModelingInsuranceExpensesQueryOptions = <TData = Awaited<ReturnType<typeof getModelingInsuranceExpenses>>, TError = ModelingSnapshotMissingError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceExpenses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelingInsuranceExpensesQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelingInsuranceExpenses>>> = ({ signal }) => getModelingInsuranceExpenses(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceExpenses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelingInsuranceExpensesQueryResult = NonNullable<Awaited<ReturnType<typeof getModelingInsuranceExpenses>>>
export type GetModelingInsuranceExpensesQueryError = ModelingSnapshotMissingError


export function useGetModelingInsuranceExpenses<TData = Awaited<ReturnType<typeof getModelingInsuranceExpenses>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceExpenses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelingInsuranceExpenses>>,
          TError,
          Awaited<ReturnType<typeof getModelingInsuranceExpenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelingInsuranceExpenses<TData = Awaited<ReturnType<typeof getModelingInsuranceExpenses>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceExpenses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelingInsuranceExpenses>>,
          TError,
          Awaited<ReturnType<typeof getModelingInsuranceExpenses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelingInsuranceExpenses<TData = Awaited<ReturnType<typeof getModelingInsuranceExpenses>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceExpenses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetModelingInsuranceExpenses<TData = Awaited<ReturnType<typeof getModelingInsuranceExpenses>>, TError = ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceExpenses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelingInsuranceExpensesQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getModelingInsuranceIncreasedAmount = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<InsuranceIncreasedAmount>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/insurance-increased-amount`, method: 'GET', signal
    },
      options);
    }
  



export const getGetModelingInsuranceIncreasedAmountQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/modeling/insurance-increased-amount`
    ] as const;
    }

    
export const getGetModelingInsuranceIncreasedAmountQueryOptions = <TData = Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>, TError = unknown>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetModelingInsuranceIncreasedAmountQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>> = ({ signal }) => getModelingInsuranceIncreasedAmount(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetModelingInsuranceIncreasedAmountQueryResult = NonNullable<Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>>
export type GetModelingInsuranceIncreasedAmountQueryError = unknown


export function useGetModelingInsuranceIncreasedAmount<TData = Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>, TError = unknown>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>,
          TError,
          Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelingInsuranceIncreasedAmount<TData = Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>, TError = unknown>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>,
          TError,
          Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetModelingInsuranceIncreasedAmount<TData = Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>, TError = unknown>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetModelingInsuranceIncreasedAmount<TData = Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>, TError = unknown>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getModelingInsuranceIncreasedAmount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetModelingInsuranceIncreasedAmountQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateModelingInsuranceIncreasedAmount = (
    analysisId: string,
    versionId: string,
    updateInsuranceIncreasedAmountBody: UpdateInsuranceIncreasedAmountBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<InsuranceIncreasedAmount>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/insurance-increased-amount`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateInsuranceIncreasedAmountBody
    },
      options);
    }
  


export const getUpdateModelingInsuranceIncreasedAmountMutationOptions = <TError = InvalidInsuranceIncreaseFrequencyError | AnalysisWriteForbiddenError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelingInsuranceIncreasedAmount>>, TError,{analysisId: string;versionId: string;data: UpdateInsuranceIncreasedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateModelingInsuranceIncreasedAmount>>, TError,{analysisId: string;versionId: string;data: UpdateInsuranceIncreasedAmountBody}, TContext> => {

const mutationKey = ['updateModelingInsuranceIncreasedAmount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateModelingInsuranceIncreasedAmount>>, {analysisId: string;versionId: string;data: UpdateInsuranceIncreasedAmountBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  updateModelingInsuranceIncreasedAmount(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateModelingInsuranceIncreasedAmountMutationResult = NonNullable<Awaited<ReturnType<typeof updateModelingInsuranceIncreasedAmount>>>
    export type UpdateModelingInsuranceIncreasedAmountMutationBody = UpdateInsuranceIncreasedAmountBody
    export type UpdateModelingInsuranceIncreasedAmountMutationError = InvalidInsuranceIncreaseFrequencyError | AnalysisWriteForbiddenError

    export const useUpdateModelingInsuranceIncreasedAmount = <TError = InvalidInsuranceIncreaseFrequencyError | AnalysisWriteForbiddenError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateModelingInsuranceIncreasedAmount>>, TError,{analysisId: string;versionId: string;data: UpdateInsuranceIncreasedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateModelingInsuranceIncreasedAmount>>,
        TError,
        {analysisId: string;versionId: string;data: UpdateInsuranceIncreasedAmountBody},
        TContext
      > => {

      const mutationOptions = getUpdateModelingInsuranceIncreasedAmountMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const resetModelingAllocatedAmounts = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/allocated-amounts`, method: 'DELETE'
    },
      options);
    }
  


export const getResetModelingAllocatedAmountsMutationOptions = <TError = AnalysisWriteForbiddenError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetModelingAllocatedAmounts>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetModelingAllocatedAmounts>>, TError,{analysisId: string;versionId: string}, TContext> => {

const mutationKey = ['resetModelingAllocatedAmounts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetModelingAllocatedAmounts>>, {analysisId: string;versionId: string}> = (props) => {
          const {analysisId,versionId} = props ?? {};

          return  resetModelingAllocatedAmounts(analysisId,versionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetModelingAllocatedAmountsMutationResult = NonNullable<Awaited<ReturnType<typeof resetModelingAllocatedAmounts>>>
    
    export type ResetModelingAllocatedAmountsMutationError = AnalysisWriteForbiddenError

    export const useResetModelingAllocatedAmounts = <TError = AnalysisWriteForbiddenError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetModelingAllocatedAmounts>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetModelingAllocatedAmounts>>,
        TError,
        {analysisId: string;versionId: string},
        TContext
      > => {

      const mutationOptions = getResetModelingAllocatedAmountsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const resetModelingAllocatedAssetAmounts = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/allocated-asset-amounts`, method: 'DELETE'
    },
      options);
    }
  


export const getResetModelingAllocatedAssetAmountsMutationOptions = <TError = AnalysisWriteForbiddenError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetModelingAllocatedAssetAmounts>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resetModelingAllocatedAssetAmounts>>, TError,{analysisId: string;versionId: string}, TContext> => {

const mutationKey = ['resetModelingAllocatedAssetAmounts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetModelingAllocatedAssetAmounts>>, {analysisId: string;versionId: string}> = (props) => {
          const {analysisId,versionId} = props ?? {};

          return  resetModelingAllocatedAssetAmounts(analysisId,versionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetModelingAllocatedAssetAmountsMutationResult = NonNullable<Awaited<ReturnType<typeof resetModelingAllocatedAssetAmounts>>>
    
    export type ResetModelingAllocatedAssetAmountsMutationError = AnalysisWriteForbiddenError

    export const useResetModelingAllocatedAssetAmounts = <TError = AnalysisWriteForbiddenError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetModelingAllocatedAssetAmounts>>, TError,{analysisId: string;versionId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetModelingAllocatedAssetAmounts>>,
        TError,
        {analysisId: string;versionId: string},
        TContext
      > => {

      const mutationOptions = getResetModelingAllocatedAssetAmountsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const reallocateModelingAssets = (
    analysisId: string,
    versionId: string,
    assetReallocationBody: AssetReallocationBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<unknown>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/asset-reallocation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assetReallocationBody, signal
    },
      options);
    }
  


export const getReallocateModelingAssetsMutationOptions = <TError = AnalysisWriteForbiddenError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reallocateModelingAssets>>, TError,{analysisId: string;versionId: string;data: AssetReallocationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reallocateModelingAssets>>, TError,{analysisId: string;versionId: string;data: AssetReallocationBody}, TContext> => {

const mutationKey = ['reallocateModelingAssets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reallocateModelingAssets>>, {analysisId: string;versionId: string;data: AssetReallocationBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  reallocateModelingAssets(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReallocateModelingAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof reallocateModelingAssets>>>
    export type ReallocateModelingAssetsMutationBody = AssetReallocationBody
    export type ReallocateModelingAssetsMutationError = AnalysisWriteForbiddenError

    export const useReallocateModelingAssets = <TError = AnalysisWriteForbiddenError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reallocateModelingAssets>>, TError,{analysisId: string;versionId: string;data: AssetReallocationBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reallocateModelingAssets>>,
        TError,
        {analysisId: string;versionId: string;data: AssetReallocationBody},
        TContext
      > => {

      const mutationOptions = getReallocateModelingAssetsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const previewFamilyGoalModeling = (
    analysisId: string,
    versionId: string,
    familyGoalModelingPreviewRequest: FamilyGoalModelingPreviewRequest,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FamilyGoalModelingPreview>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/family-goal-preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: familyGoalModelingPreviewRequest, signal
    },
      options);
    }
  


export const getPreviewFamilyGoalModelingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewFamilyGoalModeling>>, TError,{analysisId: string;versionId: string;data: FamilyGoalModelingPreviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewFamilyGoalModeling>>, TError,{analysisId: string;versionId: string;data: FamilyGoalModelingPreviewRequest}, TContext> => {

const mutationKey = ['previewFamilyGoalModeling'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewFamilyGoalModeling>>, {analysisId: string;versionId: string;data: FamilyGoalModelingPreviewRequest}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  previewFamilyGoalModeling(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PreviewFamilyGoalModelingMutationResult = NonNullable<Awaited<ReturnType<typeof previewFamilyGoalModeling>>>
    export type PreviewFamilyGoalModelingMutationBody = FamilyGoalModelingPreviewRequest
    export type PreviewFamilyGoalModelingMutationError = unknown

    export const usePreviewFamilyGoalModeling = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewFamilyGoalModeling>>, TError,{analysisId: string;versionId: string;data: FamilyGoalModelingPreviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewFamilyGoalModeling>>,
        TError,
        {analysisId: string;versionId: string;data: FamilyGoalModelingPreviewRequest},
        TContext
      > => {

      const mutationOptions = getPreviewFamilyGoalModelingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getFamilyGoalModeling = (
    analysisId: string,
    versionId: string,
    groupId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FamilyGoalModelingPreview>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/family-goals/${groupId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFamilyGoalModelingQueryKey = (analysisId?: string,
    versionId?: string,
    groupId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/modeling/family-goals/${groupId}`
    ] as const;
    }

    
export const getGetFamilyGoalModelingQueryOptions = <TData = Awaited<ReturnType<typeof getFamilyGoalModeling>>, TError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError>(analysisId: string,
    versionId: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoalModeling>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFamilyGoalModelingQueryKey(analysisId,versionId,groupId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFamilyGoalModeling>>> = ({ signal }) => getFamilyGoalModeling(analysisId,versionId,groupId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && groupId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoalModeling>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFamilyGoalModelingQueryResult = NonNullable<Awaited<ReturnType<typeof getFamilyGoalModeling>>>
export type GetFamilyGoalModelingQueryError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError


export function useGetFamilyGoalModeling<TData = Awaited<ReturnType<typeof getFamilyGoalModeling>>, TError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    groupId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoalModeling>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFamilyGoalModeling>>,
          TError,
          Awaited<ReturnType<typeof getFamilyGoalModeling>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFamilyGoalModeling<TData = Awaited<ReturnType<typeof getFamilyGoalModeling>>, TError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoalModeling>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFamilyGoalModeling>>,
          TError,
          Awaited<ReturnType<typeof getFamilyGoalModeling>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFamilyGoalModeling<TData = Awaited<ReturnType<typeof getFamilyGoalModeling>>, TError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoalModeling>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFamilyGoalModeling<TData = Awaited<ReturnType<typeof getFamilyGoalModeling>>, TError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    groupId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFamilyGoalModeling>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFamilyGoalModelingQueryOptions(analysisId,versionId,groupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getPensionGoalModeling = (
    analysisId: string,
    versionId: string,
    goalId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<PensionGoalModelingPreview>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/pension-goals/${goalId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPensionGoalModelingQueryKey = (analysisId?: string,
    versionId?: string,
    goalId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/modeling/pension-goals/${goalId}`
    ] as const;
    }

    
export const getGetPensionGoalModelingQueryOptions = <TData = Awaited<ReturnType<typeof getPensionGoalModeling>>, TError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError>(analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPensionGoalModeling>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPensionGoalModelingQueryKey(analysisId,versionId,goalId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPensionGoalModeling>>> = ({ signal }) => getPensionGoalModeling(analysisId,versionId,goalId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && goalId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPensionGoalModeling>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPensionGoalModelingQueryResult = NonNullable<Awaited<ReturnType<typeof getPensionGoalModeling>>>
export type GetPensionGoalModelingQueryError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError


export function useGetPensionGoalModeling<TData = Awaited<ReturnType<typeof getPensionGoalModeling>>, TError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPensionGoalModeling>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPensionGoalModeling>>,
          TError,
          Awaited<ReturnType<typeof getPensionGoalModeling>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPensionGoalModeling<TData = Awaited<ReturnType<typeof getPensionGoalModeling>>, TError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPensionGoalModeling>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPensionGoalModeling>>,
          TError,
          Awaited<ReturnType<typeof getPensionGoalModeling>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPensionGoalModeling<TData = Awaited<ReturnType<typeof getPensionGoalModeling>>, TError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPensionGoalModeling>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPensionGoalModeling<TData = Awaited<ReturnType<typeof getPensionGoalModeling>>, TError = AnalysisInProgressError | GoalNotFoundError | ModelingSnapshotMissingError>(
 analysisId: string,
    versionId: string,
    goalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPensionGoalModeling>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPensionGoalModelingQueryOptions(analysisId,versionId,goalId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const previewPensionGoalModeling = (
    analysisId: string,
    versionId: string,
    pensionGoalModelingPreviewRequest: PensionGoalModelingPreviewRequest,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<PensionGoalModelingPreview>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/modeling/pension-goal-preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pensionGoalModelingPreviewRequest, signal
    },
      options);
    }
  


export const getPreviewPensionGoalModelingMutationOptions = <TError = ClientBirthDateMissingError | GoalNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewPensionGoalModeling>>, TError,{analysisId: string;versionId: string;data: PensionGoalModelingPreviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof previewPensionGoalModeling>>, TError,{analysisId: string;versionId: string;data: PensionGoalModelingPreviewRequest}, TContext> => {

const mutationKey = ['previewPensionGoalModeling'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof previewPensionGoalModeling>>, {analysisId: string;versionId: string;data: PensionGoalModelingPreviewRequest}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  previewPensionGoalModeling(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PreviewPensionGoalModelingMutationResult = NonNullable<Awaited<ReturnType<typeof previewPensionGoalModeling>>>
    export type PreviewPensionGoalModelingMutationBody = PensionGoalModelingPreviewRequest
    export type PreviewPensionGoalModelingMutationError = ClientBirthDateMissingError | GoalNotFoundError

    export const usePreviewPensionGoalModeling = <TError = ClientBirthDateMissingError | GoalNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof previewPensionGoalModeling>>, TError,{analysisId: string;versionId: string;data: PensionGoalModelingPreviewRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof previewPensionGoalModeling>>,
        TError,
        {analysisId: string;versionId: string;data: PensionGoalModelingPreviewRequest},
        TContext
      > => {

      const mutationOptions = getPreviewPensionGoalModelingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getAssetsOverview = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AssetsOverview>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAssetsOverviewQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets`
    ] as const;
    }

    
export const getGetAssetsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getAssetsOverview>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetsOverviewQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetsOverview>>> = ({ signal }) => getAssetsOverview(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetsOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetsOverview>>>
export type GetAssetsOverviewQueryError = AnalysisNotFoundError


export function useGetAssetsOverview<TData = Awaited<ReturnType<typeof getAssetsOverview>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetsOverview>>,
          TError,
          Awaited<ReturnType<typeof getAssetsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetsOverview<TData = Awaited<ReturnType<typeof getAssetsOverview>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetsOverview>>,
          TError,
          Awaited<ReturnType<typeof getAssetsOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetsOverview<TData = Awaited<ReturnType<typeof getAssetsOverview>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAssetsOverview<TData = Awaited<ReturnType<typeof getAssetsOverview>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetsOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetsOverviewQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const deleteAssetItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
    params?: DeleteAssetItemParams,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/${itemId}`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteAssetItemMutationOptions = <TError = AssetItemNotFoundError | RelatedExpenseItemMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;params?: DeleteAssetItemParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;params?: DeleteAssetItemParams}, TContext> => {

const mutationKey = ['deleteAssetItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAssetItem>>, {analysisId: string;versionId: string;itemId: string;params?: DeleteAssetItemParams}> = (props) => {
          const {analysisId,versionId,itemId,params} = props ?? {};

          return  deleteAssetItem(analysisId,versionId,itemId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAssetItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAssetItem>>>
    
    export type DeleteAssetItemMutationError = AssetItemNotFoundError | RelatedExpenseItemMismatchError

    export const useDeleteAssetItem = <TError = AssetItemNotFoundError | RelatedExpenseItemMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;params?: DeleteAssetItemParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAssetItem>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;params?: DeleteAssetItemParams},
        TContext
      > => {

      const mutationOptions = getDeleteAssetItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteAssetContract = (
    analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/${itemId}/contracts/${contractId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteAssetContractMutationOptions = <TError = AssetItemOrContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string}, TContext> => {

const mutationKey = ['deleteAssetContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAssetContract>>, {analysisId: string;versionId: string;itemId: string;contractId: string}> = (props) => {
          const {analysisId,versionId,itemId,contractId} = props ?? {};

          return  deleteAssetContract(analysisId,versionId,itemId,contractId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAssetContractMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAssetContract>>>
    
    export type DeleteAssetContractMutationError = AssetItemOrContractNotFoundError

    export const useDeleteAssetContract = <TError = AssetItemOrContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAssetContract>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;contractId: string},
        TContext
      > => {

      const mutationOptions = getDeleteAssetContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listAssetContractExpenseOptions = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<LoadValuesOption[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/contracts/expense-options`, method: 'GET', signal
    },
      options);
    }
  



export const getListAssetContractExpenseOptionsQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/contracts/expense-options`
    ] as const;
    }

    
export const getListAssetContractExpenseOptionsQueryOptions = <TData = Awaited<ReturnType<typeof listAssetContractExpenseOptions>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetContractExpenseOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAssetContractExpenseOptionsQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssetContractExpenseOptions>>> = ({ signal }) => listAssetContractExpenseOptions(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAssetContractExpenseOptions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAssetContractExpenseOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAssetContractExpenseOptions>>>
export type ListAssetContractExpenseOptionsQueryError = AnalysisNotFoundError


export function useListAssetContractExpenseOptions<TData = Awaited<ReturnType<typeof listAssetContractExpenseOptions>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetContractExpenseOptions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssetContractExpenseOptions>>,
          TError,
          Awaited<ReturnType<typeof listAssetContractExpenseOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssetContractExpenseOptions<TData = Awaited<ReturnType<typeof listAssetContractExpenseOptions>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetContractExpenseOptions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAssetContractExpenseOptions>>,
          TError,
          Awaited<ReturnType<typeof listAssetContractExpenseOptions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAssetContractExpenseOptions<TData = Awaited<ReturnType<typeof listAssetContractExpenseOptions>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetContractExpenseOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAssetContractExpenseOptions<TData = Awaited<ReturnType<typeof listAssetContractExpenseOptions>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAssetContractExpenseOptions>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAssetContractExpenseOptionsQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const setFinancialAssetsEntryMode = (
    analysisId: string,
    versionId: string,
    mode: 'aggregate' | 'individual',
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AggregatedAssets>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/financial/entry-mode/${mode}`, method: 'PUT'
    },
      options);
    }
  


export const getSetFinancialAssetsEntryModeMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setFinancialAssetsEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setFinancialAssetsEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext> => {

const mutationKey = ['setFinancialAssetsEntryMode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setFinancialAssetsEntryMode>>, {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}> = (props) => {
          const {analysisId,versionId,mode} = props ?? {};

          return  setFinancialAssetsEntryMode(analysisId,versionId,mode,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetFinancialAssetsEntryModeMutationResult = NonNullable<Awaited<ReturnType<typeof setFinancialAssetsEntryMode>>>
    
    export type SetFinancialAssetsEntryModeMutationError = AnalysisNotFoundError

    export const useSetFinancialAssetsEntryMode = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setFinancialAssetsEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setFinancialAssetsEntryMode>>,
        TError,
        {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'},
        TContext
      > => {

      const mutationOptions = getSetFinancialAssetsEntryModeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateAggregatedFinancialAssets = (
    analysisId: string,
    versionId: string,
    aggregatedAssetsBody: AggregatedAssetsBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AggregatedAssets>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/financial/aggregated`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aggregatedAssetsBody
    },
      options);
    }
  


export const getUpdateAggregatedFinancialAssetsMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedFinancialAssets>>, TError,{analysisId: string;versionId: string;data: AggregatedAssetsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedFinancialAssets>>, TError,{analysisId: string;versionId: string;data: AggregatedAssetsBody}, TContext> => {

const mutationKey = ['updateAggregatedFinancialAssets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAggregatedFinancialAssets>>, {analysisId: string;versionId: string;data: AggregatedAssetsBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  updateAggregatedFinancialAssets(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAggregatedFinancialAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAggregatedFinancialAssets>>>
    export type UpdateAggregatedFinancialAssetsMutationBody = AggregatedAssetsBody
    export type UpdateAggregatedFinancialAssetsMutationError = AnalysisNotFoundError

    export const useUpdateAggregatedFinancialAssets = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedFinancialAssets>>, TError,{analysisId: string;versionId: string;data: AggregatedAssetsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAggregatedFinancialAssets>>,
        TError,
        {analysisId: string;versionId: string;data: AggregatedAssetsBody},
        TContext
      > => {

      const mutationOptions = getUpdateAggregatedFinancialAssetsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listFinancialAssetItems = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FinancialAssetItem[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/financial`, method: 'GET', signal
    },
      options);
    }
  



export const getListFinancialAssetItemsQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/financial`
    ] as const;
    }

    
export const getListFinancialAssetItemsQueryOptions = <TData = Awaited<ReturnType<typeof listFinancialAssetItems>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFinancialAssetItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFinancialAssetItemsQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFinancialAssetItems>>> = ({ signal }) => listFinancialAssetItems(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFinancialAssetItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListFinancialAssetItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listFinancialAssetItems>>>
export type ListFinancialAssetItemsQueryError = AnalysisNotFoundError


export function useListFinancialAssetItems<TData = Awaited<ReturnType<typeof listFinancialAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFinancialAssetItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFinancialAssetItems>>,
          TError,
          Awaited<ReturnType<typeof listFinancialAssetItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFinancialAssetItems<TData = Awaited<ReturnType<typeof listFinancialAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFinancialAssetItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFinancialAssetItems>>,
          TError,
          Awaited<ReturnType<typeof listFinancialAssetItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListFinancialAssetItems<TData = Awaited<ReturnType<typeof listFinancialAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFinancialAssetItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListFinancialAssetItems<TData = Awaited<ReturnType<typeof listFinancialAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFinancialAssetItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFinancialAssetItemsQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createFinancialAssetItem = (
    analysisId: string,
    versionId: string,
    financialAssetItemBody: FinancialAssetItemBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FinancialAssetItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/financial`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: financialAssetItemBody, signal
    },
      options);
    }
  


export const getCreateFinancialAssetItemMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFinancialAssetItem>>, TError,{analysisId: string;versionId: string;data: FinancialAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFinancialAssetItem>>, TError,{analysisId: string;versionId: string;data: FinancialAssetItemBody}, TContext> => {

const mutationKey = ['createFinancialAssetItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFinancialAssetItem>>, {analysisId: string;versionId: string;data: FinancialAssetItemBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createFinancialAssetItem(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFinancialAssetItemMutationResult = NonNullable<Awaited<ReturnType<typeof createFinancialAssetItem>>>
    export type CreateFinancialAssetItemMutationBody = FinancialAssetItemBody
    export type CreateFinancialAssetItemMutationError = AnalysisNotFoundError

    export const useCreateFinancialAssetItem = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFinancialAssetItem>>, TError,{analysisId: string;versionId: string;data: FinancialAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFinancialAssetItem>>,
        TError,
        {analysisId: string;versionId: string;data: FinancialAssetItemBody},
        TContext
      > => {

      const mutationOptions = getCreateFinancialAssetItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getFinancialAssetItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FinancialAssetItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/financial/${itemId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFinancialAssetItemQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/financial/${itemId}`
    ] as const;
    }

    
export const getGetFinancialAssetItemQueryOptions = <TData = Awaited<ReturnType<typeof getFinancialAssetItem>>, TError = AssetItemNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialAssetItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFinancialAssetItemQueryKey(analysisId,versionId,itemId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinancialAssetItem>>> = ({ signal }) => getFinancialAssetItem(analysisId,versionId,itemId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFinancialAssetItem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFinancialAssetItemQueryResult = NonNullable<Awaited<ReturnType<typeof getFinancialAssetItem>>>
export type GetFinancialAssetItemQueryError = AssetItemNotFoundError


export function useGetFinancialAssetItem<TData = Awaited<ReturnType<typeof getFinancialAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialAssetItem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialAssetItem>>,
          TError,
          Awaited<ReturnType<typeof getFinancialAssetItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialAssetItem<TData = Awaited<ReturnType<typeof getFinancialAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialAssetItem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialAssetItem>>,
          TError,
          Awaited<ReturnType<typeof getFinancialAssetItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialAssetItem<TData = Awaited<ReturnType<typeof getFinancialAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialAssetItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFinancialAssetItem<TData = Awaited<ReturnType<typeof getFinancialAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialAssetItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFinancialAssetItemQueryOptions(analysisId,versionId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateFinancialAssetItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
    financialAssetItemBody: FinancialAssetItemBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<FinancialAssetItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/financial/${itemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: financialAssetItemBody
    },
      options);
    }
  


export const getUpdateFinancialAssetItemMutationOptions = <TError = AssetItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFinancialAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: FinancialAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFinancialAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: FinancialAssetItemBody}, TContext> => {

const mutationKey = ['updateFinancialAssetItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFinancialAssetItem>>, {analysisId: string;versionId: string;itemId: string;data: FinancialAssetItemBody}> = (props) => {
          const {analysisId,versionId,itemId,data} = props ?? {};

          return  updateFinancialAssetItem(analysisId,versionId,itemId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFinancialAssetItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateFinancialAssetItem>>>
    export type UpdateFinancialAssetItemMutationBody = FinancialAssetItemBody
    export type UpdateFinancialAssetItemMutationError = AssetItemNotFoundError

    export const useUpdateFinancialAssetItem = <TError = AssetItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFinancialAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: FinancialAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFinancialAssetItem>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;data: FinancialAssetItemBody},
        TContext
      > => {

      const mutationOptions = getUpdateFinancialAssetItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setImmovableAssetsEntryMode = (
    analysisId: string,
    versionId: string,
    mode: 'aggregate' | 'individual',
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AggregatedAssets>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable/entry-mode/${mode}`, method: 'PUT'
    },
      options);
    }
  


export const getSetImmovableAssetsEntryModeMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setImmovableAssetsEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setImmovableAssetsEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext> => {

const mutationKey = ['setImmovableAssetsEntryMode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setImmovableAssetsEntryMode>>, {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}> = (props) => {
          const {analysisId,versionId,mode} = props ?? {};

          return  setImmovableAssetsEntryMode(analysisId,versionId,mode,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetImmovableAssetsEntryModeMutationResult = NonNullable<Awaited<ReturnType<typeof setImmovableAssetsEntryMode>>>
    
    export type SetImmovableAssetsEntryModeMutationError = AnalysisNotFoundError

    export const useSetImmovableAssetsEntryMode = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setImmovableAssetsEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setImmovableAssetsEntryMode>>,
        TError,
        {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'},
        TContext
      > => {

      const mutationOptions = getSetImmovableAssetsEntryModeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateAggregatedImmovableAssets = (
    analysisId: string,
    versionId: string,
    aggregatedAssetsBody: AggregatedAssetsBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AggregatedAssets>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable/aggregated`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aggregatedAssetsBody
    },
      options);
    }
  


export const getUpdateAggregatedImmovableAssetsMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedImmovableAssets>>, TError,{analysisId: string;versionId: string;data: AggregatedAssetsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedImmovableAssets>>, TError,{analysisId: string;versionId: string;data: AggregatedAssetsBody}, TContext> => {

const mutationKey = ['updateAggregatedImmovableAssets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAggregatedImmovableAssets>>, {analysisId: string;versionId: string;data: AggregatedAssetsBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  updateAggregatedImmovableAssets(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAggregatedImmovableAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAggregatedImmovableAssets>>>
    export type UpdateAggregatedImmovableAssetsMutationBody = AggregatedAssetsBody
    export type UpdateAggregatedImmovableAssetsMutationError = AnalysisNotFoundError

    export const useUpdateAggregatedImmovableAssets = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedImmovableAssets>>, TError,{analysisId: string;versionId: string;data: AggregatedAssetsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAggregatedImmovableAssets>>,
        TError,
        {analysisId: string;versionId: string;data: AggregatedAssetsBody},
        TContext
      > => {

      const mutationOptions = getUpdateAggregatedImmovableAssetsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listImmovableAssetItems = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ImmovableAssetItem[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable`, method: 'GET', signal
    },
      options);
    }
  



export const getListImmovableAssetItemsQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable`
    ] as const;
    }

    
export const getListImmovableAssetItemsQueryOptions = <TData = Awaited<ReturnType<typeof listImmovableAssetItems>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListImmovableAssetItemsQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listImmovableAssetItems>>> = ({ signal }) => listImmovableAssetItems(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListImmovableAssetItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listImmovableAssetItems>>>
export type ListImmovableAssetItemsQueryError = AnalysisNotFoundError


export function useListImmovableAssetItems<TData = Awaited<ReturnType<typeof listImmovableAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImmovableAssetItems>>,
          TError,
          Awaited<ReturnType<typeof listImmovableAssetItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImmovableAssetItems<TData = Awaited<ReturnType<typeof listImmovableAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImmovableAssetItems>>,
          TError,
          Awaited<ReturnType<typeof listImmovableAssetItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImmovableAssetItems<TData = Awaited<ReturnType<typeof listImmovableAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListImmovableAssetItems<TData = Awaited<ReturnType<typeof listImmovableAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListImmovableAssetItemsQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createImmovableAssetItem = (
    analysisId: string,
    versionId: string,
    immovableAssetItemBody: ImmovableAssetItemBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ImmovableAssetItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: immovableAssetItemBody, signal
    },
      options);
    }
  


export const getCreateImmovableAssetItemMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImmovableAssetItem>>, TError,{analysisId: string;versionId: string;data: ImmovableAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createImmovableAssetItem>>, TError,{analysisId: string;versionId: string;data: ImmovableAssetItemBody}, TContext> => {

const mutationKey = ['createImmovableAssetItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImmovableAssetItem>>, {analysisId: string;versionId: string;data: ImmovableAssetItemBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createImmovableAssetItem(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateImmovableAssetItemMutationResult = NonNullable<Awaited<ReturnType<typeof createImmovableAssetItem>>>
    export type CreateImmovableAssetItemMutationBody = ImmovableAssetItemBody
    export type CreateImmovableAssetItemMutationError = AnalysisNotFoundError

    export const useCreateImmovableAssetItem = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImmovableAssetItem>>, TError,{analysisId: string;versionId: string;data: ImmovableAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createImmovableAssetItem>>,
        TError,
        {analysisId: string;versionId: string;data: ImmovableAssetItemBody},
        TContext
      > => {

      const mutationOptions = getCreateImmovableAssetItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getImmovableAssetItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ImmovableAssetItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable/${itemId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetImmovableAssetItemQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable/${itemId}`
    ] as const;
    }

    
export const getGetImmovableAssetItemQueryOptions = <TData = Awaited<ReturnType<typeof getImmovableAssetItem>>, TError = AssetItemNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImmovableAssetItemQueryKey(analysisId,versionId,itemId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImmovableAssetItem>>> = ({ signal }) => getImmovableAssetItem(analysisId,versionId,itemId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetItem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetImmovableAssetItemQueryResult = NonNullable<Awaited<ReturnType<typeof getImmovableAssetItem>>>
export type GetImmovableAssetItemQueryError = AssetItemNotFoundError


export function useGetImmovableAssetItem<TData = Awaited<ReturnType<typeof getImmovableAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetItem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImmovableAssetItem>>,
          TError,
          Awaited<ReturnType<typeof getImmovableAssetItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImmovableAssetItem<TData = Awaited<ReturnType<typeof getImmovableAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetItem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImmovableAssetItem>>,
          TError,
          Awaited<ReturnType<typeof getImmovableAssetItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImmovableAssetItem<TData = Awaited<ReturnType<typeof getImmovableAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetImmovableAssetItem<TData = Awaited<ReturnType<typeof getImmovableAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetImmovableAssetItemQueryOptions(analysisId,versionId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateImmovableAssetItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
    immovableAssetItemBody: ImmovableAssetItemBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<ImmovableAssetItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable/${itemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: immovableAssetItemBody
    },
      options);
    }
  


export const getUpdateImmovableAssetItemMutationOptions = <TError = AssetItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateImmovableAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: ImmovableAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateImmovableAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: ImmovableAssetItemBody}, TContext> => {

const mutationKey = ['updateImmovableAssetItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateImmovableAssetItem>>, {analysisId: string;versionId: string;itemId: string;data: ImmovableAssetItemBody}> = (props) => {
          const {analysisId,versionId,itemId,data} = props ?? {};

          return  updateImmovableAssetItem(analysisId,versionId,itemId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateImmovableAssetItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateImmovableAssetItem>>>
    export type UpdateImmovableAssetItemMutationBody = ImmovableAssetItemBody
    export type UpdateImmovableAssetItemMutationError = AssetItemNotFoundError

    export const useUpdateImmovableAssetItem = <TError = AssetItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateImmovableAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: ImmovableAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateImmovableAssetItem>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;data: ImmovableAssetItemBody},
        TContext
      > => {

      const mutationOptions = getUpdateImmovableAssetItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listImmovableAssetContracts = (
    analysisId: string,
    versionId: string,
    itemId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AssetItemContractOverview>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable/${itemId}/contracts`, method: 'GET', signal
    },
      options);
    }
  



export const getListImmovableAssetContractsQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable/${itemId}/contracts`
    ] as const;
    }

    
export const getListImmovableAssetContractsQueryOptions = <TData = Awaited<ReturnType<typeof listImmovableAssetContracts>>, TError = AssetItemNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListImmovableAssetContractsQueryKey(analysisId,versionId,itemId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listImmovableAssetContracts>>> = ({ signal }) => listImmovableAssetContracts(analysisId,versionId,itemId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListImmovableAssetContractsQueryResult = NonNullable<Awaited<ReturnType<typeof listImmovableAssetContracts>>>
export type ListImmovableAssetContractsQueryError = AssetItemNotFoundError


export function useListImmovableAssetContracts<TData = Awaited<ReturnType<typeof listImmovableAssetContracts>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImmovableAssetContracts>>,
          TError,
          Awaited<ReturnType<typeof listImmovableAssetContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImmovableAssetContracts<TData = Awaited<ReturnType<typeof listImmovableAssetContracts>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImmovableAssetContracts>>,
          TError,
          Awaited<ReturnType<typeof listImmovableAssetContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListImmovableAssetContracts<TData = Awaited<ReturnType<typeof listImmovableAssetContracts>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListImmovableAssetContracts<TData = Awaited<ReturnType<typeof listImmovableAssetContracts>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listImmovableAssetContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListImmovableAssetContractsQueryOptions(analysisId,versionId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createImmovableAssetContract = (
    analysisId: string,
    versionId: string,
    itemId: string,
    immovableContractBody: ImmovableContractBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ImmovableContract>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable/${itemId}/contracts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: immovableContractBody, signal
    },
      options);
    }
  


export const getCreateImmovableAssetContractMutationOptions = <TError = AssetItemNotFoundOrContractShapeMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImmovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;data: ImmovableContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createImmovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;data: ImmovableContractBody}, TContext> => {

const mutationKey = ['createImmovableAssetContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createImmovableAssetContract>>, {analysisId: string;versionId: string;itemId: string;data: ImmovableContractBody}> = (props) => {
          const {analysisId,versionId,itemId,data} = props ?? {};

          return  createImmovableAssetContract(analysisId,versionId,itemId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateImmovableAssetContractMutationResult = NonNullable<Awaited<ReturnType<typeof createImmovableAssetContract>>>
    export type CreateImmovableAssetContractMutationBody = ImmovableContractBody
    export type CreateImmovableAssetContractMutationError = AssetItemNotFoundOrContractShapeMismatchError

    export const useCreateImmovableAssetContract = <TError = AssetItemNotFoundOrContractShapeMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createImmovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;data: ImmovableContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createImmovableAssetContract>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;data: ImmovableContractBody},
        TContext
      > => {

      const mutationOptions = getCreateImmovableAssetContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getImmovableAssetContract = (
    analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ImmovableContract>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable/${itemId}/contracts/${contractId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetImmovableAssetContractQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,
    contractId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable/${itemId}/contracts/${contractId}`
    ] as const;
    }

    
export const getGetImmovableAssetContractQueryOptions = <TData = Awaited<ReturnType<typeof getImmovableAssetContract>>, TError = AssetItemOrContractNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImmovableAssetContractQueryKey(analysisId,versionId,itemId,contractId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImmovableAssetContract>>> = ({ signal }) => getImmovableAssetContract(analysisId,versionId,itemId,contractId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId && contractId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetImmovableAssetContractQueryResult = NonNullable<Awaited<ReturnType<typeof getImmovableAssetContract>>>
export type GetImmovableAssetContractQueryError = AssetItemOrContractNotFoundError


export function useGetImmovableAssetContract<TData = Awaited<ReturnType<typeof getImmovableAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImmovableAssetContract>>,
          TError,
          Awaited<ReturnType<typeof getImmovableAssetContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImmovableAssetContract<TData = Awaited<ReturnType<typeof getImmovableAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImmovableAssetContract>>,
          TError,
          Awaited<ReturnType<typeof getImmovableAssetContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImmovableAssetContract<TData = Awaited<ReturnType<typeof getImmovableAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetImmovableAssetContract<TData = Awaited<ReturnType<typeof getImmovableAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImmovableAssetContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetImmovableAssetContractQueryOptions(analysisId,versionId,itemId,contractId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateImmovableAssetContract = (
    analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string,
    immovableContractBody: ImmovableContractBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<ImmovableContract>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/immovable/${itemId}/contracts/${contractId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: immovableContractBody
    },
      options);
    }
  


export const getUpdateImmovableAssetContractMutationOptions = <TError = AssetItemOrContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateImmovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string;data: ImmovableContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateImmovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string;data: ImmovableContractBody}, TContext> => {

const mutationKey = ['updateImmovableAssetContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateImmovableAssetContract>>, {analysisId: string;versionId: string;itemId: string;contractId: string;data: ImmovableContractBody}> = (props) => {
          const {analysisId,versionId,itemId,contractId,data} = props ?? {};

          return  updateImmovableAssetContract(analysisId,versionId,itemId,contractId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateImmovableAssetContractMutationResult = NonNullable<Awaited<ReturnType<typeof updateImmovableAssetContract>>>
    export type UpdateImmovableAssetContractMutationBody = ImmovableContractBody
    export type UpdateImmovableAssetContractMutationError = AssetItemOrContractNotFoundError

    export const useUpdateImmovableAssetContract = <TError = AssetItemOrContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateImmovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string;data: ImmovableContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateImmovableAssetContract>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;contractId: string;data: ImmovableContractBody},
        TContext
      > => {

      const mutationOptions = getUpdateImmovableAssetContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setMovableAssetsEntryMode = (
    analysisId: string,
    versionId: string,
    mode: 'aggregate' | 'individual',
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AggregatedAssets>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/entry-mode/${mode}`, method: 'PUT'
    },
      options);
    }
  


export const getSetMovableAssetsEntryModeMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMovableAssetsEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setMovableAssetsEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext> => {

const mutationKey = ['setMovableAssetsEntryMode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMovableAssetsEntryMode>>, {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}> = (props) => {
          const {analysisId,versionId,mode} = props ?? {};

          return  setMovableAssetsEntryMode(analysisId,versionId,mode,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetMovableAssetsEntryModeMutationResult = NonNullable<Awaited<ReturnType<typeof setMovableAssetsEntryMode>>>
    
    export type SetMovableAssetsEntryModeMutationError = AnalysisNotFoundError

    export const useSetMovableAssetsEntryMode = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMovableAssetsEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setMovableAssetsEntryMode>>,
        TError,
        {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'},
        TContext
      > => {

      const mutationOptions = getSetMovableAssetsEntryModeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateAggregatedMovableAssets = (
    analysisId: string,
    versionId: string,
    aggregatedAssetsBody: AggregatedAssetsBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AggregatedAssets>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/aggregated`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aggregatedAssetsBody
    },
      options);
    }
  


export const getUpdateAggregatedMovableAssetsMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedMovableAssets>>, TError,{analysisId: string;versionId: string;data: AggregatedAssetsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedMovableAssets>>, TError,{analysisId: string;versionId: string;data: AggregatedAssetsBody}, TContext> => {

const mutationKey = ['updateAggregatedMovableAssets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAggregatedMovableAssets>>, {analysisId: string;versionId: string;data: AggregatedAssetsBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  updateAggregatedMovableAssets(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAggregatedMovableAssetsMutationResult = NonNullable<Awaited<ReturnType<typeof updateAggregatedMovableAssets>>>
    export type UpdateAggregatedMovableAssetsMutationBody = AggregatedAssetsBody
    export type UpdateAggregatedMovableAssetsMutationError = AnalysisNotFoundError

    export const useUpdateAggregatedMovableAssets = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedMovableAssets>>, TError,{analysisId: string;versionId: string;data: AggregatedAssetsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAggregatedMovableAssets>>,
        TError,
        {analysisId: string;versionId: string;data: AggregatedAssetsBody},
        TContext
      > => {

      const mutationOptions = getUpdateAggregatedMovableAssetsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listMovableAssetItems = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<MovableAssetItem[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable`, method: 'GET', signal
    },
      options);
    }
  



export const getListMovableAssetItemsQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable`
    ] as const;
    }

    
export const getListMovableAssetItemsQueryOptions = <TData = Awaited<ReturnType<typeof listMovableAssetItems>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMovableAssetItemsQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMovableAssetItems>>> = ({ signal }) => listMovableAssetItems(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMovableAssetItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listMovableAssetItems>>>
export type ListMovableAssetItemsQueryError = AnalysisNotFoundError


export function useListMovableAssetItems<TData = Awaited<ReturnType<typeof listMovableAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMovableAssetItems>>,
          TError,
          Awaited<ReturnType<typeof listMovableAssetItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMovableAssetItems<TData = Awaited<ReturnType<typeof listMovableAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMovableAssetItems>>,
          TError,
          Awaited<ReturnType<typeof listMovableAssetItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMovableAssetItems<TData = Awaited<ReturnType<typeof listMovableAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMovableAssetItems<TData = Awaited<ReturnType<typeof listMovableAssetItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMovableAssetItemsQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createMovableAssetItem = (
    analysisId: string,
    versionId: string,
    movableAssetItemBody: MovableAssetItemBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<MovableAssetItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: movableAssetItemBody, signal
    },
      options);
    }
  


export const getCreateMovableAssetItemMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMovableAssetItem>>, TError,{analysisId: string;versionId: string;data: MovableAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMovableAssetItem>>, TError,{analysisId: string;versionId: string;data: MovableAssetItemBody}, TContext> => {

const mutationKey = ['createMovableAssetItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMovableAssetItem>>, {analysisId: string;versionId: string;data: MovableAssetItemBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createMovableAssetItem(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateMovableAssetItemMutationResult = NonNullable<Awaited<ReturnType<typeof createMovableAssetItem>>>
    export type CreateMovableAssetItemMutationBody = MovableAssetItemBody
    export type CreateMovableAssetItemMutationError = AnalysisNotFoundError

    export const useCreateMovableAssetItem = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMovableAssetItem>>, TError,{analysisId: string;versionId: string;data: MovableAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createMovableAssetItem>>,
        TError,
        {analysisId: string;versionId: string;data: MovableAssetItemBody},
        TContext
      > => {

      const mutationOptions = getCreateMovableAssetItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getMovableAssetItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<MovableAssetItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMovableAssetItemQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}`
    ] as const;
    }

    
export const getGetMovableAssetItemQueryOptions = <TData = Awaited<ReturnType<typeof getMovableAssetItem>>, TError = AssetItemNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMovableAssetItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMovableAssetItemQueryKey(analysisId,versionId,itemId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMovableAssetItem>>> = ({ signal }) => getMovableAssetItem(analysisId,versionId,itemId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMovableAssetItem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMovableAssetItemQueryResult = NonNullable<Awaited<ReturnType<typeof getMovableAssetItem>>>
export type GetMovableAssetItemQueryError = AssetItemNotFoundError


export function useGetMovableAssetItem<TData = Awaited<ReturnType<typeof getMovableAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMovableAssetItem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMovableAssetItem>>,
          TError,
          Awaited<ReturnType<typeof getMovableAssetItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMovableAssetItem<TData = Awaited<ReturnType<typeof getMovableAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMovableAssetItem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMovableAssetItem>>,
          TError,
          Awaited<ReturnType<typeof getMovableAssetItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMovableAssetItem<TData = Awaited<ReturnType<typeof getMovableAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMovableAssetItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMovableAssetItem<TData = Awaited<ReturnType<typeof getMovableAssetItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMovableAssetItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMovableAssetItemQueryOptions(analysisId,versionId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateMovableAssetItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
    movableAssetItemBody: MovableAssetItemBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<MovableAssetItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: movableAssetItemBody
    },
      options);
    }
  


export const getUpdateMovableAssetItemMutationOptions = <TError = AssetItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMovableAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: MovableAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMovableAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: MovableAssetItemBody}, TContext> => {

const mutationKey = ['updateMovableAssetItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMovableAssetItem>>, {analysisId: string;versionId: string;itemId: string;data: MovableAssetItemBody}> = (props) => {
          const {analysisId,versionId,itemId,data} = props ?? {};

          return  updateMovableAssetItem(analysisId,versionId,itemId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateMovableAssetItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateMovableAssetItem>>>
    export type UpdateMovableAssetItemMutationBody = MovableAssetItemBody
    export type UpdateMovableAssetItemMutationError = AssetItemNotFoundError

    export const useUpdateMovableAssetItem = <TError = AssetItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMovableAssetItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: MovableAssetItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateMovableAssetItem>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;data: MovableAssetItemBody},
        TContext
      > => {

      const mutationOptions = getUpdateMovableAssetItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listMovableAssetContracts = (
    analysisId: string,
    versionId: string,
    itemId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AssetItemContractOverview>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}/contracts`, method: 'GET', signal
    },
      options);
    }
  



export const getListMovableAssetContractsQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}/contracts`
    ] as const;
    }

    
export const getListMovableAssetContractsQueryOptions = <TData = Awaited<ReturnType<typeof listMovableAssetContracts>>, TError = AssetItemNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMovableAssetContractsQueryKey(analysisId,versionId,itemId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMovableAssetContracts>>> = ({ signal }) => listMovableAssetContracts(analysisId,versionId,itemId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListMovableAssetContractsQueryResult = NonNullable<Awaited<ReturnType<typeof listMovableAssetContracts>>>
export type ListMovableAssetContractsQueryError = AssetItemNotFoundError


export function useListMovableAssetContracts<TData = Awaited<ReturnType<typeof listMovableAssetContracts>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMovableAssetContracts>>,
          TError,
          Awaited<ReturnType<typeof listMovableAssetContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMovableAssetContracts<TData = Awaited<ReturnType<typeof listMovableAssetContracts>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMovableAssetContracts>>,
          TError,
          Awaited<ReturnType<typeof listMovableAssetContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListMovableAssetContracts<TData = Awaited<ReturnType<typeof listMovableAssetContracts>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListMovableAssetContracts<TData = Awaited<ReturnType<typeof listMovableAssetContracts>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listMovableAssetContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListMovableAssetContractsQueryOptions(analysisId,versionId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getVehicleAssetContract = (
    analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<VehicleContract>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}/vehicle-contracts/${contractId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVehicleAssetContractQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,
    contractId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}/vehicle-contracts/${contractId}`
    ] as const;
    }

    
export const getGetVehicleAssetContractQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleAssetContract>>, TError = AssetItemOrContractNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleAssetContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleAssetContractQueryKey(analysisId,versionId,itemId,contractId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleAssetContract>>> = ({ signal }) => getVehicleAssetContract(analysisId,versionId,itemId,contractId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId && contractId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicleAssetContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleAssetContractQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleAssetContract>>>
export type GetVehicleAssetContractQueryError = AssetItemOrContractNotFoundError


export function useGetVehicleAssetContract<TData = Awaited<ReturnType<typeof getVehicleAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleAssetContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleAssetContract>>,
          TError,
          Awaited<ReturnType<typeof getVehicleAssetContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleAssetContract<TData = Awaited<ReturnType<typeof getVehicleAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleAssetContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleAssetContract>>,
          TError,
          Awaited<ReturnType<typeof getVehicleAssetContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleAssetContract<TData = Awaited<ReturnType<typeof getVehicleAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleAssetContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetVehicleAssetContract<TData = Awaited<ReturnType<typeof getVehicleAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleAssetContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleAssetContractQueryOptions(analysisId,versionId,itemId,contractId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateVehicleAssetContract = (
    analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string,
    vehicleContractBody: VehicleContractBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<VehicleContract>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}/vehicle-contracts/${contractId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: vehicleContractBody
    },
      options);
    }
  


export const getUpdateVehicleAssetContractMutationOptions = <TError = AssetItemOrContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string;data: VehicleContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVehicleAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string;data: VehicleContractBody}, TContext> => {

const mutationKey = ['updateVehicleAssetContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVehicleAssetContract>>, {analysisId: string;versionId: string;itemId: string;contractId: string;data: VehicleContractBody}> = (props) => {
          const {analysisId,versionId,itemId,contractId,data} = props ?? {};

          return  updateVehicleAssetContract(analysisId,versionId,itemId,contractId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVehicleAssetContractMutationResult = NonNullable<Awaited<ReturnType<typeof updateVehicleAssetContract>>>
    export type UpdateVehicleAssetContractMutationBody = VehicleContractBody
    export type UpdateVehicleAssetContractMutationError = AssetItemOrContractNotFoundError

    export const useUpdateVehicleAssetContract = <TError = AssetItemOrContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicleAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string;data: VehicleContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVehicleAssetContract>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;contractId: string;data: VehicleContractBody},
        TContext
      > => {

      const mutationOptions = getUpdateVehicleAssetContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createVehicleAssetContract = (
    analysisId: string,
    versionId: string,
    itemId: string,
    vehicleContractBody: VehicleContractBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<VehicleContract>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}/vehicle-contracts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: vehicleContractBody, signal
    },
      options);
    }
  


export const getCreateVehicleAssetContractMutationOptions = <TError = AssetItemNotFoundOrContractShapeMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicleAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;data: VehicleContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createVehicleAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;data: VehicleContractBody}, TContext> => {

const mutationKey = ['createVehicleAssetContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVehicleAssetContract>>, {analysisId: string;versionId: string;itemId: string;data: VehicleContractBody}> = (props) => {
          const {analysisId,versionId,itemId,data} = props ?? {};

          return  createVehicleAssetContract(analysisId,versionId,itemId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateVehicleAssetContractMutationResult = NonNullable<Awaited<ReturnType<typeof createVehicleAssetContract>>>
    export type CreateVehicleAssetContractMutationBody = VehicleContractBody
    export type CreateVehicleAssetContractMutationError = AssetItemNotFoundOrContractShapeMismatchError

    export const useCreateVehicleAssetContract = <TError = AssetItemNotFoundOrContractShapeMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVehicleAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;data: VehicleContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createVehicleAssetContract>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;data: VehicleContractBody},
        TContext
      > => {

      const mutationOptions = getCreateVehicleAssetContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getOtherMovableAssetContract = (
    analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<OtherMovableContract>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}/other-contracts/${contractId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetOtherMovableAssetContractQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,
    contractId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}/other-contracts/${contractId}`
    ] as const;
    }

    
export const getGetOtherMovableAssetContractQueryOptions = <TData = Awaited<ReturnType<typeof getOtherMovableAssetContract>>, TError = AssetItemOrContractNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherMovableAssetContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOtherMovableAssetContractQueryKey(analysisId,versionId,itemId,contractId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOtherMovableAssetContract>>> = ({ signal }) => getOtherMovableAssetContract(analysisId,versionId,itemId,contractId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId && contractId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOtherMovableAssetContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOtherMovableAssetContractQueryResult = NonNullable<Awaited<ReturnType<typeof getOtherMovableAssetContract>>>
export type GetOtherMovableAssetContractQueryError = AssetItemOrContractNotFoundError


export function useGetOtherMovableAssetContract<TData = Awaited<ReturnType<typeof getOtherMovableAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherMovableAssetContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOtherMovableAssetContract>>,
          TError,
          Awaited<ReturnType<typeof getOtherMovableAssetContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOtherMovableAssetContract<TData = Awaited<ReturnType<typeof getOtherMovableAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherMovableAssetContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOtherMovableAssetContract>>,
          TError,
          Awaited<ReturnType<typeof getOtherMovableAssetContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOtherMovableAssetContract<TData = Awaited<ReturnType<typeof getOtherMovableAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherMovableAssetContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOtherMovableAssetContract<TData = Awaited<ReturnType<typeof getOtherMovableAssetContract>>, TError = AssetItemOrContractNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherMovableAssetContract>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOtherMovableAssetContractQueryOptions(analysisId,versionId,itemId,contractId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateOtherMovableAssetContract = (
    analysisId: string,
    versionId: string,
    itemId: string,
    contractId: string,
    otherMovableContractBody: OtherMovableContractBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<OtherMovableContract>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}/other-contracts/${contractId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: otherMovableContractBody
    },
      options);
    }
  


export const getUpdateOtherMovableAssetContractMutationOptions = <TError = AssetItemOrContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOtherMovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string;data: OtherMovableContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOtherMovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string;data: OtherMovableContractBody}, TContext> => {

const mutationKey = ['updateOtherMovableAssetContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOtherMovableAssetContract>>, {analysisId: string;versionId: string;itemId: string;contractId: string;data: OtherMovableContractBody}> = (props) => {
          const {analysisId,versionId,itemId,contractId,data} = props ?? {};

          return  updateOtherMovableAssetContract(analysisId,versionId,itemId,contractId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOtherMovableAssetContractMutationResult = NonNullable<Awaited<ReturnType<typeof updateOtherMovableAssetContract>>>
    export type UpdateOtherMovableAssetContractMutationBody = OtherMovableContractBody
    export type UpdateOtherMovableAssetContractMutationError = AssetItemOrContractNotFoundError

    export const useUpdateOtherMovableAssetContract = <TError = AssetItemOrContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOtherMovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;contractId: string;data: OtherMovableContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOtherMovableAssetContract>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;contractId: string;data: OtherMovableContractBody},
        TContext
      > => {

      const mutationOptions = getUpdateOtherMovableAssetContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const createOtherMovableAssetContract = (
    analysisId: string,
    versionId: string,
    itemId: string,
    otherMovableContractBody: OtherMovableContractBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<OtherMovableContract>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/movable/${itemId}/other-contracts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: otherMovableContractBody, signal
    },
      options);
    }
  


export const getCreateOtherMovableAssetContractMutationOptions = <TError = AssetItemNotFoundOrContractShapeMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOtherMovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;data: OtherMovableContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createOtherMovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;data: OtherMovableContractBody}, TContext> => {

const mutationKey = ['createOtherMovableAssetContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOtherMovableAssetContract>>, {analysisId: string;versionId: string;itemId: string;data: OtherMovableContractBody}> = (props) => {
          const {analysisId,versionId,itemId,data} = props ?? {};

          return  createOtherMovableAssetContract(analysisId,versionId,itemId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOtherMovableAssetContractMutationResult = NonNullable<Awaited<ReturnType<typeof createOtherMovableAssetContract>>>
    export type CreateOtherMovableAssetContractMutationBody = OtherMovableContractBody
    export type CreateOtherMovableAssetContractMutationError = AssetItemNotFoundOrContractShapeMismatchError

    export const useCreateOtherMovableAssetContract = <TError = AssetItemNotFoundOrContractShapeMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOtherMovableAssetContract>>, TError,{analysisId: string;versionId: string;itemId: string;data: OtherMovableContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createOtherMovableAssetContract>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;data: OtherMovableContractBody},
        TContext
      > => {

      const mutationOptions = getCreateOtherMovableAssetContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setLiabilitiesEntryMode = (
    analysisId: string,
    versionId: string,
    mode: 'aggregate' | 'individual',
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AggregatedLiabilities>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/liabilities/entry-mode/${mode}`, method: 'PUT'
    },
      options);
    }
  


export const getSetLiabilitiesEntryModeMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLiabilitiesEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setLiabilitiesEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext> => {

const mutationKey = ['setLiabilitiesEntryMode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setLiabilitiesEntryMode>>, {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}> = (props) => {
          const {analysisId,versionId,mode} = props ?? {};

          return  setLiabilitiesEntryMode(analysisId,versionId,mode,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetLiabilitiesEntryModeMutationResult = NonNullable<Awaited<ReturnType<typeof setLiabilitiesEntryMode>>>
    
    export type SetLiabilitiesEntryModeMutationError = AnalysisNotFoundError

    export const useSetLiabilitiesEntryMode = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setLiabilitiesEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setLiabilitiesEntryMode>>,
        TError,
        {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'},
        TContext
      > => {

      const mutationOptions = getSetLiabilitiesEntryModeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateAggregatedLiabilities = (
    analysisId: string,
    versionId: string,
    aggregatedLiabilitiesBody: AggregatedLiabilitiesBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AggregatedLiabilities>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/liabilities/aggregated`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aggregatedLiabilitiesBody
    },
      options);
    }
  


export const getUpdateAggregatedLiabilitiesMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedLiabilities>>, TError,{analysisId: string;versionId: string;data: AggregatedLiabilitiesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedLiabilities>>, TError,{analysisId: string;versionId: string;data: AggregatedLiabilitiesBody}, TContext> => {

const mutationKey = ['updateAggregatedLiabilities'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAggregatedLiabilities>>, {analysisId: string;versionId: string;data: AggregatedLiabilitiesBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  updateAggregatedLiabilities(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAggregatedLiabilitiesMutationResult = NonNullable<Awaited<ReturnType<typeof updateAggregatedLiabilities>>>
    export type UpdateAggregatedLiabilitiesMutationBody = AggregatedLiabilitiesBody
    export type UpdateAggregatedLiabilitiesMutationError = AnalysisNotFoundError

    export const useUpdateAggregatedLiabilities = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedLiabilities>>, TError,{analysisId: string;versionId: string;data: AggregatedLiabilitiesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAggregatedLiabilities>>,
        TError,
        {analysisId: string;versionId: string;data: AggregatedLiabilitiesBody},
        TContext
      > => {

      const mutationOptions = getUpdateAggregatedLiabilitiesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listLiabilityItems = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<LiabilityItem[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/liabilities`, method: 'GET', signal
    },
      options);
    }
  



export const getListLiabilityItemsQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/liabilities`
    ] as const;
    }

    
export const getListLiabilityItemsQueryOptions = <TData = Awaited<ReturnType<typeof listLiabilityItems>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLiabilityItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLiabilityItemsQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLiabilityItems>>> = ({ signal }) => listLiabilityItems(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLiabilityItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLiabilityItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listLiabilityItems>>>
export type ListLiabilityItemsQueryError = AnalysisNotFoundError


export function useListLiabilityItems<TData = Awaited<ReturnType<typeof listLiabilityItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLiabilityItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLiabilityItems>>,
          TError,
          Awaited<ReturnType<typeof listLiabilityItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLiabilityItems<TData = Awaited<ReturnType<typeof listLiabilityItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLiabilityItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLiabilityItems>>,
          TError,
          Awaited<ReturnType<typeof listLiabilityItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLiabilityItems<TData = Awaited<ReturnType<typeof listLiabilityItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLiabilityItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListLiabilityItems<TData = Awaited<ReturnType<typeof listLiabilityItems>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLiabilityItems>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLiabilityItemsQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createLiabilityItem = (
    analysisId: string,
    versionId: string,
    liabilityItemBody: LiabilityItemBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<LiabilityItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/liabilities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: liabilityItemBody, signal
    },
      options);
    }
  


export const getCreateLiabilityItemMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLiabilityItem>>, TError,{analysisId: string;versionId: string;data: LiabilityItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLiabilityItem>>, TError,{analysisId: string;versionId: string;data: LiabilityItemBody}, TContext> => {

const mutationKey = ['createLiabilityItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLiabilityItem>>, {analysisId: string;versionId: string;data: LiabilityItemBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createLiabilityItem(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLiabilityItemMutationResult = NonNullable<Awaited<ReturnType<typeof createLiabilityItem>>>
    export type CreateLiabilityItemMutationBody = LiabilityItemBody
    export type CreateLiabilityItemMutationError = AnalysisNotFoundError

    export const useCreateLiabilityItem = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLiabilityItem>>, TError,{analysisId: string;versionId: string;data: LiabilityItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLiabilityItem>>,
        TError,
        {analysisId: string;versionId: string;data: LiabilityItemBody},
        TContext
      > => {

      const mutationOptions = getCreateLiabilityItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getLiabilityItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<LiabilityItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/liabilities/${itemId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLiabilityItemQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/assets/liabilities/${itemId}`
    ] as const;
    }

    
export const getGetLiabilityItemQueryOptions = <TData = Awaited<ReturnType<typeof getLiabilityItem>>, TError = AssetItemNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiabilityItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLiabilityItemQueryKey(analysisId,versionId,itemId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLiabilityItem>>> = ({ signal }) => getLiabilityItem(analysisId,versionId,itemId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLiabilityItem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLiabilityItemQueryResult = NonNullable<Awaited<ReturnType<typeof getLiabilityItem>>>
export type GetLiabilityItemQueryError = AssetItemNotFoundError


export function useGetLiabilityItem<TData = Awaited<ReturnType<typeof getLiabilityItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiabilityItem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLiabilityItem>>,
          TError,
          Awaited<ReturnType<typeof getLiabilityItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLiabilityItem<TData = Awaited<ReturnType<typeof getLiabilityItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiabilityItem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLiabilityItem>>,
          TError,
          Awaited<ReturnType<typeof getLiabilityItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLiabilityItem<TData = Awaited<ReturnType<typeof getLiabilityItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiabilityItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLiabilityItem<TData = Awaited<ReturnType<typeof getLiabilityItem>>, TError = AssetItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLiabilityItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLiabilityItemQueryOptions(analysisId,versionId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateLiabilityItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
    liabilityItemBody: LiabilityItemBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<LiabilityItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/assets/liabilities/${itemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: liabilityItemBody
    },
      options);
    }
  


export const getUpdateLiabilityItemMutationOptions = <TError = AssetItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLiabilityItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: LiabilityItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLiabilityItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: LiabilityItemBody}, TContext> => {

const mutationKey = ['updateLiabilityItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLiabilityItem>>, {analysisId: string;versionId: string;itemId: string;data: LiabilityItemBody}> = (props) => {
          const {analysisId,versionId,itemId,data} = props ?? {};

          return  updateLiabilityItem(analysisId,versionId,itemId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLiabilityItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateLiabilityItem>>>
    export type UpdateLiabilityItemMutationBody = LiabilityItemBody
    export type UpdateLiabilityItemMutationError = AssetItemNotFoundError

    export const useUpdateLiabilityItem = <TError = AssetItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLiabilityItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: LiabilityItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLiabilityItem>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;data: LiabilityItemBody},
        TContext
      > => {

      const mutationOptions = getUpdateLiabilityItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getHousingExpense = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<HousingExpense>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/housing`, method: 'GET', signal
    },
      options);
    }
  



export const getGetHousingExpenseQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/housing`
    ] as const;
    }

    
export const getGetHousingExpenseQueryOptions = <TData = Awaited<ReturnType<typeof getHousingExpense>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHousingExpenseQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHousingExpense>>> = ({ signal }) => getHousingExpense(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHousingExpense>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHousingExpenseQueryResult = NonNullable<Awaited<ReturnType<typeof getHousingExpense>>>
export type GetHousingExpenseQueryError = AnalysisNotFoundError


export function useGetHousingExpense<TData = Awaited<ReturnType<typeof getHousingExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingExpense>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHousingExpense>>,
          TError,
          Awaited<ReturnType<typeof getHousingExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHousingExpense<TData = Awaited<ReturnType<typeof getHousingExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingExpense>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHousingExpense>>,
          TError,
          Awaited<ReturnType<typeof getHousingExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHousingExpense<TData = Awaited<ReturnType<typeof getHousingExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetHousingExpense<TData = Awaited<ReturnType<typeof getHousingExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHousingExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHousingExpenseQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const replaceHousingExpense = (
    analysisId: string,
    versionId: string,
    housingExpenseBody: HousingExpenseBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<HousingExpense>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/housing`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: housingExpenseBody
    },
      options);
    }
  


export const getReplaceHousingExpenseMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceHousingExpense>>, TError,{analysisId: string;versionId: string;data: HousingExpenseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceHousingExpense>>, TError,{analysisId: string;versionId: string;data: HousingExpenseBody}, TContext> => {

const mutationKey = ['replaceHousingExpense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceHousingExpense>>, {analysisId: string;versionId: string;data: HousingExpenseBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  replaceHousingExpense(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReplaceHousingExpenseMutationResult = NonNullable<Awaited<ReturnType<typeof replaceHousingExpense>>>
    export type ReplaceHousingExpenseMutationBody = HousingExpenseBody
    export type ReplaceHousingExpenseMutationError = AnalysisNotFoundError

    /**
 * @deprecated
 */
export const useReplaceHousingExpense = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceHousingExpense>>, TError,{analysisId: string;versionId: string;data: HousingExpenseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceHousingExpense>>,
        TError,
        {analysisId: string;versionId: string;data: HousingExpenseBody},
        TContext
      > => {

      const mutationOptions = getReplaceHousingExpenseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getConsumptionExpense = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ConsumptionExpense>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/consumption`, method: 'GET', signal
    },
      options);
    }
  



export const getGetConsumptionExpenseQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/consumption`
    ] as const;
    }

    
export const getGetConsumptionExpenseQueryOptions = <TData = Awaited<ReturnType<typeof getConsumptionExpense>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsumptionExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConsumptionExpenseQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConsumptionExpense>>> = ({ signal }) => getConsumptionExpense(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConsumptionExpense>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConsumptionExpenseQueryResult = NonNullable<Awaited<ReturnType<typeof getConsumptionExpense>>>
export type GetConsumptionExpenseQueryError = AnalysisNotFoundError


export function useGetConsumptionExpense<TData = Awaited<ReturnType<typeof getConsumptionExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsumptionExpense>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsumptionExpense>>,
          TError,
          Awaited<ReturnType<typeof getConsumptionExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsumptionExpense<TData = Awaited<ReturnType<typeof getConsumptionExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsumptionExpense>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConsumptionExpense>>,
          TError,
          Awaited<ReturnType<typeof getConsumptionExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConsumptionExpense<TData = Awaited<ReturnType<typeof getConsumptionExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsumptionExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetConsumptionExpense<TData = Awaited<ReturnType<typeof getConsumptionExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConsumptionExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConsumptionExpenseQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const replaceConsumptionExpense = (
    analysisId: string,
    versionId: string,
    consumptionExpenseBody: ConsumptionExpenseBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<ConsumptionExpense>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/consumption`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: consumptionExpenseBody
    },
      options);
    }
  


export const getReplaceConsumptionExpenseMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceConsumptionExpense>>, TError,{analysisId: string;versionId: string;data: ConsumptionExpenseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceConsumptionExpense>>, TError,{analysisId: string;versionId: string;data: ConsumptionExpenseBody}, TContext> => {

const mutationKey = ['replaceConsumptionExpense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceConsumptionExpense>>, {analysisId: string;versionId: string;data: ConsumptionExpenseBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  replaceConsumptionExpense(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReplaceConsumptionExpenseMutationResult = NonNullable<Awaited<ReturnType<typeof replaceConsumptionExpense>>>
    export type ReplaceConsumptionExpenseMutationBody = ConsumptionExpenseBody
    export type ReplaceConsumptionExpenseMutationError = AnalysisNotFoundError

    /**
 * @deprecated
 */
export const useReplaceConsumptionExpense = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceConsumptionExpense>>, TError,{analysisId: string;versionId: string;data: ConsumptionExpenseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceConsumptionExpense>>,
        TError,
        {analysisId: string;versionId: string;data: ConsumptionExpenseBody},
        TContext
      > => {

      const mutationOptions = getReplaceConsumptionExpenseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getLifeStyleExpense = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<LifeStyleExpense>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/life-style`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLifeStyleExpenseQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/life-style`
    ] as const;
    }

    
export const getGetLifeStyleExpenseQueryOptions = <TData = Awaited<ReturnType<typeof getLifeStyleExpense>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLifeStyleExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLifeStyleExpenseQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLifeStyleExpense>>> = ({ signal }) => getLifeStyleExpense(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLifeStyleExpense>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLifeStyleExpenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLifeStyleExpense>>>
export type GetLifeStyleExpenseQueryError = AnalysisNotFoundError


export function useGetLifeStyleExpense<TData = Awaited<ReturnType<typeof getLifeStyleExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLifeStyleExpense>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLifeStyleExpense>>,
          TError,
          Awaited<ReturnType<typeof getLifeStyleExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLifeStyleExpense<TData = Awaited<ReturnType<typeof getLifeStyleExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLifeStyleExpense>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLifeStyleExpense>>,
          TError,
          Awaited<ReturnType<typeof getLifeStyleExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLifeStyleExpense<TData = Awaited<ReturnType<typeof getLifeStyleExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLifeStyleExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLifeStyleExpense<TData = Awaited<ReturnType<typeof getLifeStyleExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLifeStyleExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLifeStyleExpenseQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const replaceLifeStyleExpense = (
    analysisId: string,
    versionId: string,
    lifeStyleExpenseBody: LifeStyleExpenseBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<LifeStyleExpense>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/life-style`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: lifeStyleExpenseBody
    },
      options);
    }
  


export const getReplaceLifeStyleExpenseMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceLifeStyleExpense>>, TError,{analysisId: string;versionId: string;data: LifeStyleExpenseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceLifeStyleExpense>>, TError,{analysisId: string;versionId: string;data: LifeStyleExpenseBody}, TContext> => {

const mutationKey = ['replaceLifeStyleExpense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceLifeStyleExpense>>, {analysisId: string;versionId: string;data: LifeStyleExpenseBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  replaceLifeStyleExpense(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReplaceLifeStyleExpenseMutationResult = NonNullable<Awaited<ReturnType<typeof replaceLifeStyleExpense>>>
    export type ReplaceLifeStyleExpenseMutationBody = LifeStyleExpenseBody
    export type ReplaceLifeStyleExpenseMutationError = AnalysisNotFoundError

    /**
 * @deprecated
 */
export const useReplaceLifeStyleExpense = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceLifeStyleExpense>>, TError,{analysisId: string;versionId: string;data: LifeStyleExpenseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceLifeStyleExpense>>,
        TError,
        {analysisId: string;versionId: string;data: LifeStyleExpenseBody},
        TContext
      > => {

      const mutationOptions = getReplaceLifeStyleExpenseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateAggregatedOtherExpenses = (
    analysisId: string,
    versionId: string,
    aggregatedAmountBody: AggregatedAmountBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AggregatedAmount>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/other/aggregated`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aggregatedAmountBody
    },
      options);
    }
  


export const getUpdateAggregatedOtherExpensesMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedOtherExpenses>>, TError,{analysisId: string;versionId: string;data: AggregatedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedOtherExpenses>>, TError,{analysisId: string;versionId: string;data: AggregatedAmountBody}, TContext> => {

const mutationKey = ['updateAggregatedOtherExpenses'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAggregatedOtherExpenses>>, {analysisId: string;versionId: string;data: AggregatedAmountBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  updateAggregatedOtherExpenses(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAggregatedOtherExpensesMutationResult = NonNullable<Awaited<ReturnType<typeof updateAggregatedOtherExpenses>>>
    export type UpdateAggregatedOtherExpensesMutationBody = AggregatedAmountBody
    export type UpdateAggregatedOtherExpensesMutationError = AnalysisNotFoundError

    export const useUpdateAggregatedOtherExpenses = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedOtherExpenses>>, TError,{analysisId: string;versionId: string;data: AggregatedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAggregatedOtherExpenses>>,
        TError,
        {analysisId: string;versionId: string;data: AggregatedAmountBody},
        TContext
      > => {

      const mutationOptions = getUpdateAggregatedOtherExpensesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getOtherExpense = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<OtherExpense>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/other`, method: 'GET', signal
    },
      options);
    }
  



export const getGetOtherExpenseQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/other`
    ] as const;
    }

    
export const getGetOtherExpenseQueryOptions = <TData = Awaited<ReturnType<typeof getOtherExpense>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOtherExpenseQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOtherExpense>>> = ({ signal }) => getOtherExpense(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOtherExpense>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOtherExpenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOtherExpense>>>
export type GetOtherExpenseQueryError = AnalysisNotFoundError


export function useGetOtherExpense<TData = Awaited<ReturnType<typeof getOtherExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherExpense>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOtherExpense>>,
          TError,
          Awaited<ReturnType<typeof getOtherExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOtherExpense<TData = Awaited<ReturnType<typeof getOtherExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherExpense>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOtherExpense>>,
          TError,
          Awaited<ReturnType<typeof getOtherExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOtherExpense<TData = Awaited<ReturnType<typeof getOtherExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOtherExpense<TData = Awaited<ReturnType<typeof getOtherExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOtherExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOtherExpenseQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const replaceOtherExpense = (
    analysisId: string,
    versionId: string,
    otherExpenseBody: OtherExpenseBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<OtherExpense>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/other`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: otherExpenseBody
    },
      options);
    }
  


export const getReplaceOtherExpenseMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceOtherExpense>>, TError,{analysisId: string;versionId: string;data: OtherExpenseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceOtherExpense>>, TError,{analysisId: string;versionId: string;data: OtherExpenseBody}, TContext> => {

const mutationKey = ['replaceOtherExpense'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceOtherExpense>>, {analysisId: string;versionId: string;data: OtherExpenseBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  replaceOtherExpense(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReplaceOtherExpenseMutationResult = NonNullable<Awaited<ReturnType<typeof replaceOtherExpense>>>
    export type ReplaceOtherExpenseMutationBody = OtherExpenseBody
    export type ReplaceOtherExpenseMutationError = AnalysisNotFoundError

    /**
 * @deprecated
 */
export const useReplaceOtherExpense = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceOtherExpense>>, TError,{analysisId: string;versionId: string;data: OtherExpenseBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceOtherExpense>>,
        TError,
        {analysisId: string;versionId: string;data: OtherExpenseBody},
        TContext
      > => {

      const mutationOptions = getReplaceOtherExpenseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getBudgetOverview = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<BudgetOverview>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget`, method: 'GET', signal
    },
      options);
    }
  



export const getGetBudgetOverviewQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget`
    ] as const;
    }

    
export const getGetBudgetOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getBudgetOverview>>, TError = AnalysisNotFoundError | AmountMismatchError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudgetOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBudgetOverviewQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBudgetOverview>>> = ({ signal }) => getBudgetOverview(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBudgetOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBudgetOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getBudgetOverview>>>
export type GetBudgetOverviewQueryError = AnalysisNotFoundError | AmountMismatchError


export function useGetBudgetOverview<TData = Awaited<ReturnType<typeof getBudgetOverview>>, TError = AnalysisNotFoundError | AmountMismatchError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudgetOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBudgetOverview>>,
          TError,
          Awaited<ReturnType<typeof getBudgetOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBudgetOverview<TData = Awaited<ReturnType<typeof getBudgetOverview>>, TError = AnalysisNotFoundError | AmountMismatchError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudgetOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBudgetOverview>>,
          TError,
          Awaited<ReturnType<typeof getBudgetOverview>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBudgetOverview<TData = Awaited<ReturnType<typeof getBudgetOverview>>, TError = AnalysisNotFoundError | AmountMismatchError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudgetOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBudgetOverview<TData = Awaited<ReturnType<typeof getBudgetOverview>>, TError = AnalysisNotFoundError | AmountMismatchError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBudgetOverview>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBudgetOverviewQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Saves the expense categories present in the body in one transaction - nothing is saved when any item fails, a category left out stays untouched. Within Loan/FinancialProduct/Insurance deletes run first, then updates, then creates
 */
export const saveExpensesBatch = (
    analysisId: string,
    versionId: string,
    expensesBatchBody: ExpensesBatchBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: expensesBatchBody, signal
    },
      options);
    }
  


export const getSaveExpensesBatchMutationOptions = <TError = BudgetBatchBadRequestError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveExpensesBatch>>, TError,{analysisId: string;versionId: string;data: ExpensesBatchBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveExpensesBatch>>, TError,{analysisId: string;versionId: string;data: ExpensesBatchBody}, TContext> => {

const mutationKey = ['saveExpensesBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveExpensesBatch>>, {analysisId: string;versionId: string;data: ExpensesBatchBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  saveExpensesBatch(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveExpensesBatchMutationResult = NonNullable<Awaited<ReturnType<typeof saveExpensesBatch>>>
    export type SaveExpensesBatchMutationBody = ExpensesBatchBody
    export type SaveExpensesBatchMutationError = BudgetBatchBadRequestError | AnalysisNotFoundError

    export const useSaveExpensesBatch = <TError = BudgetBatchBadRequestError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveExpensesBatch>>, TError,{analysisId: string;versionId: string;data: ExpensesBatchBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveExpensesBatch>>,
        TError,
        {analysisId: string;versionId: string;data: ExpensesBatchBody},
        TContext
      > => {

      const mutationOptions = getSaveExpensesBatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setExpensesEntryMode = (
    analysisId: string,
    versionId: string,
    mode: 'aggregate' | 'individual',
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/entry-mode/${mode}`, method: 'PUT'
    },
      options);
    }
  


export const getSetExpensesEntryModeMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setExpensesEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setExpensesEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext> => {

const mutationKey = ['setExpensesEntryMode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setExpensesEntryMode>>, {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}> = (props) => {
          const {analysisId,versionId,mode} = props ?? {};

          return  setExpensesEntryMode(analysisId,versionId,mode,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetExpensesEntryModeMutationResult = NonNullable<Awaited<ReturnType<typeof setExpensesEntryMode>>>
    
    export type SetExpensesEntryModeMutationError = AnalysisNotFoundError

    export const useSetExpensesEntryMode = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setExpensesEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setExpensesEntryMode>>,
        TError,
        {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'},
        TContext
      > => {

      const mutationOptions = getSetExpensesEntryModeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateAggregatedExpenseCategory = (
    analysisId: string,
    versionId: string,
    category: 'loan' | 'financial-product' | 'insurance',
    aggregatedAmountBody: AggregatedAmountBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AggregatedAmount>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/${category}/aggregated`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aggregatedAmountBody
    },
      options);
    }
  


export const getUpdateAggregatedExpenseCategoryMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedExpenseCategory>>, TError,{analysisId: string;versionId: string;category: 'loan' | 'financial-product' | 'insurance';data: AggregatedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedExpenseCategory>>, TError,{analysisId: string;versionId: string;category: 'loan' | 'financial-product' | 'insurance';data: AggregatedAmountBody}, TContext> => {

const mutationKey = ['updateAggregatedExpenseCategory'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAggregatedExpenseCategory>>, {analysisId: string;versionId: string;category: 'loan' | 'financial-product' | 'insurance';data: AggregatedAmountBody}> = (props) => {
          const {analysisId,versionId,category,data} = props ?? {};

          return  updateAggregatedExpenseCategory(analysisId,versionId,category,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAggregatedExpenseCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateAggregatedExpenseCategory>>>
    export type UpdateAggregatedExpenseCategoryMutationBody = AggregatedAmountBody
    export type UpdateAggregatedExpenseCategoryMutationError = AnalysisNotFoundError

    export const useUpdateAggregatedExpenseCategory = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedExpenseCategory>>, TError,{analysisId: string;versionId: string;category: 'loan' | 'financial-product' | 'insurance';data: AggregatedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAggregatedExpenseCategory>>,
        TError,
        {analysisId: string;versionId: string;category: 'loan' | 'financial-product' | 'insurance';data: AggregatedAmountBody},
        TContext
      > => {

      const mutationOptions = getUpdateAggregatedExpenseCategoryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates, updates and deletes incomes in one transaction - nothing is saved when any item fails. Deletes run first, then updates, then creates
 */
export const saveIncomesBatch = (
    analysisId: string,
    versionId: string,
    incomesBatchBody: IncomesBatchBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/incomes/batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: incomesBatchBody, signal
    },
      options);
    }
  


export const getSaveIncomesBatchMutationOptions = <TError = BudgetBatchBadRequestError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveIncomesBatch>>, TError,{analysisId: string;versionId: string;data: IncomesBatchBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveIncomesBatch>>, TError,{analysisId: string;versionId: string;data: IncomesBatchBody}, TContext> => {

const mutationKey = ['saveIncomesBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveIncomesBatch>>, {analysisId: string;versionId: string;data: IncomesBatchBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  saveIncomesBatch(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveIncomesBatchMutationResult = NonNullable<Awaited<ReturnType<typeof saveIncomesBatch>>>
    export type SaveIncomesBatchMutationBody = IncomesBatchBody
    export type SaveIncomesBatchMutationError = BudgetBatchBadRequestError | AnalysisNotFoundError

    export const useSaveIncomesBatch = <TError = BudgetBatchBadRequestError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveIncomesBatch>>, TError,{analysisId: string;versionId: string;data: IncomesBatchBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveIncomesBatch>>,
        TError,
        {analysisId: string;versionId: string;data: IncomesBatchBody},
        TContext
      > => {

      const mutationOptions = getSaveIncomesBatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setIncomesEntryMode = (
    analysisId: string,
    versionId: string,
    mode: 'aggregate' | 'individual',
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/incomes/entry-mode/${mode}`, method: 'PUT'
    },
      options);
    }
  


export const getSetIncomesEntryModeMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setIncomesEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setIncomesEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext> => {

const mutationKey = ['setIncomesEntryMode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setIncomesEntryMode>>, {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}> = (props) => {
          const {analysisId,versionId,mode} = props ?? {};

          return  setIncomesEntryMode(analysisId,versionId,mode,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetIncomesEntryModeMutationResult = NonNullable<Awaited<ReturnType<typeof setIncomesEntryMode>>>
    
    export type SetIncomesEntryModeMutationError = AnalysisNotFoundError

    export const useSetIncomesEntryMode = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setIncomesEntryMode>>, TError,{analysisId: string;versionId: string;mode: 'aggregate' | 'individual'}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setIncomesEntryMode>>,
        TError,
        {analysisId: string;versionId: string;mode: 'aggregate' | 'individual'},
        TContext
      > => {

      const mutationOptions = getSetIncomesEntryModeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateAggregatedIncomes = (
    analysisId: string,
    versionId: string,
    aggregatedAmountBody: AggregatedAmountBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AggregatedAmount>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/incomes/aggregated`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aggregatedAmountBody
    },
      options);
    }
  


export const getUpdateAggregatedIncomesMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedIncomes>>, TError,{analysisId: string;versionId: string;data: AggregatedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedIncomes>>, TError,{analysisId: string;versionId: string;data: AggregatedAmountBody}, TContext> => {

const mutationKey = ['updateAggregatedIncomes'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAggregatedIncomes>>, {analysisId: string;versionId: string;data: AggregatedAmountBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  updateAggregatedIncomes(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAggregatedIncomesMutationResult = NonNullable<Awaited<ReturnType<typeof updateAggregatedIncomes>>>
    export type UpdateAggregatedIncomesMutationBody = AggregatedAmountBody
    export type UpdateAggregatedIncomesMutationError = AnalysisNotFoundError

    export const useUpdateAggregatedIncomes = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAggregatedIncomes>>, TError,{analysisId: string;versionId: string;data: AggregatedAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAggregatedIncomes>>,
        TError,
        {analysisId: string;versionId: string;data: AggregatedAmountBody},
        TContext
      > => {

      const mutationOptions = getUpdateAggregatedIncomesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateAllocatedGoalAmount = (
    analysisId: string,
    versionId: string,
    allocatedGoalAmountBody: AllocatedGoalAmountBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<AllocatedGoalAmount>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/incomes/allocated-goal-amount`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: allocatedGoalAmountBody
    },
      options);
    }
  


export const getUpdateAllocatedGoalAmountMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAllocatedGoalAmount>>, TError,{analysisId: string;versionId: string;data: AllocatedGoalAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAllocatedGoalAmount>>, TError,{analysisId: string;versionId: string;data: AllocatedGoalAmountBody}, TContext> => {

const mutationKey = ['updateAllocatedGoalAmount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAllocatedGoalAmount>>, {analysisId: string;versionId: string;data: AllocatedGoalAmountBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  updateAllocatedGoalAmount(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAllocatedGoalAmountMutationResult = NonNullable<Awaited<ReturnType<typeof updateAllocatedGoalAmount>>>
    export type UpdateAllocatedGoalAmountMutationBody = AllocatedGoalAmountBody
    export type UpdateAllocatedGoalAmountMutationError = AnalysisNotFoundError

    export const useUpdateAllocatedGoalAmount = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAllocatedGoalAmount>>, TError,{analysisId: string;versionId: string;data: AllocatedGoalAmountBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAllocatedGoalAmount>>,
        TError,
        {analysisId: string;versionId: string;data: AllocatedGoalAmountBody},
        TContext
      > => {

      const mutationOptions = getUpdateAllocatedGoalAmountMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listIncomes = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Income[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/incomes`, method: 'GET', signal
    },
      options);
    }
  



export const getListIncomesQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/incomes`
    ] as const;
    }

    
export const getListIncomesQueryOptions = <TData = Awaited<ReturnType<typeof listIncomes>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIncomes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListIncomesQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listIncomes>>> = ({ signal }) => listIncomes(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listIncomes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListIncomesQueryResult = NonNullable<Awaited<ReturnType<typeof listIncomes>>>
export type ListIncomesQueryError = AnalysisNotFoundError


export function useListIncomes<TData = Awaited<ReturnType<typeof listIncomes>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIncomes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIncomes>>,
          TError,
          Awaited<ReturnType<typeof listIncomes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIncomes<TData = Awaited<ReturnType<typeof listIncomes>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIncomes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIncomes>>,
          TError,
          Awaited<ReturnType<typeof listIncomes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListIncomes<TData = Awaited<ReturnType<typeof listIncomes>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIncomes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListIncomes<TData = Awaited<ReturnType<typeof listIncomes>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listIncomes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListIncomesQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/incomes/batch`
 * @deprecated
 */
export const createIncome = (
    analysisId: string,
    versionId: string,
    incomeBody: IncomeBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Income>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/incomes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: incomeBody, signal
    },
      options);
    }
  


export const getCreateIncomeMutationOptions = <TError = InvalidIncomeAmountTypeError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIncome>>, TError,{analysisId: string;versionId: string;data: IncomeBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createIncome>>, TError,{analysisId: string;versionId: string;data: IncomeBody}, TContext> => {

const mutationKey = ['createIncome'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createIncome>>, {analysisId: string;versionId: string;data: IncomeBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createIncome(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateIncomeMutationResult = NonNullable<Awaited<ReturnType<typeof createIncome>>>
    export type CreateIncomeMutationBody = IncomeBody
    export type CreateIncomeMutationError = InvalidIncomeAmountTypeError | AnalysisNotFoundError

    /**
 * @deprecated
 */
export const useCreateIncome = <TError = InvalidIncomeAmountTypeError | AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIncome>>, TError,{analysisId: string;versionId: string;data: IncomeBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createIncome>>,
        TError,
        {analysisId: string;versionId: string;data: IncomeBody},
        TContext
      > => {

      const mutationOptions = getCreateIncomeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getIncome = (
    analysisId: string,
    versionId: string,
    incomeId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Income>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/incomes/${incomeId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIncomeQueryKey = (analysisId?: string,
    versionId?: string,
    incomeId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/incomes/${incomeId}`
    ] as const;
    }

    
export const getGetIncomeQueryOptions = <TData = Awaited<ReturnType<typeof getIncome>>, TError = IncomeNotFoundError>(analysisId: string,
    versionId: string,
    incomeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIncome>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIncomeQueryKey(analysisId,versionId,incomeId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIncome>>> = ({ signal }) => getIncome(analysisId,versionId,incomeId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && incomeId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIncome>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIncomeQueryResult = NonNullable<Awaited<ReturnType<typeof getIncome>>>
export type GetIncomeQueryError = IncomeNotFoundError


export function useGetIncome<TData = Awaited<ReturnType<typeof getIncome>>, TError = IncomeNotFoundError>(
 analysisId: string,
    versionId: string,
    incomeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIncome>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIncome>>,
          TError,
          Awaited<ReturnType<typeof getIncome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIncome<TData = Awaited<ReturnType<typeof getIncome>>, TError = IncomeNotFoundError>(
 analysisId: string,
    versionId: string,
    incomeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIncome>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIncome>>,
          TError,
          Awaited<ReturnType<typeof getIncome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIncome<TData = Awaited<ReturnType<typeof getIncome>>, TError = IncomeNotFoundError>(
 analysisId: string,
    versionId: string,
    incomeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIncome>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIncome<TData = Awaited<ReturnType<typeof getIncome>>, TError = IncomeNotFoundError>(
 analysisId: string,
    versionId: string,
    incomeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIncome>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIncomeQueryOptions(analysisId,versionId,incomeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/incomes/batch`
 * @deprecated
 */
export const updateIncome = (
    analysisId: string,
    versionId: string,
    incomeId: string,
    incomeBody: IncomeBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<Income>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/incomes/${incomeId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: incomeBody
    },
      options);
    }
  


export const getUpdateIncomeMutationOptions = <TError = InvalidIncomeAmountTypeError | IncomeNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIncome>>, TError,{analysisId: string;versionId: string;incomeId: string;data: IncomeBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateIncome>>, TError,{analysisId: string;versionId: string;incomeId: string;data: IncomeBody}, TContext> => {

const mutationKey = ['updateIncome'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateIncome>>, {analysisId: string;versionId: string;incomeId: string;data: IncomeBody}> = (props) => {
          const {analysisId,versionId,incomeId,data} = props ?? {};

          return  updateIncome(analysisId,versionId,incomeId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateIncomeMutationResult = NonNullable<Awaited<ReturnType<typeof updateIncome>>>
    export type UpdateIncomeMutationBody = IncomeBody
    export type UpdateIncomeMutationError = InvalidIncomeAmountTypeError | IncomeNotFoundError

    /**
 * @deprecated
 */
export const useUpdateIncome = <TError = InvalidIncomeAmountTypeError | IncomeNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateIncome>>, TError,{analysisId: string;versionId: string;incomeId: string;data: IncomeBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateIncome>>,
        TError,
        {analysisId: string;versionId: string;incomeId: string;data: IncomeBody},
        TContext
      > => {

      const mutationOptions = getUpdateIncomeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Replaced by `POST /budget/incomes/batch`
 * @deprecated
 */
export const deleteIncome = (
    analysisId: string,
    versionId: string,
    incomeId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/incomes/${incomeId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteIncomeMutationOptions = <TError = IncomeNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIncome>>, TError,{analysisId: string;versionId: string;incomeId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIncome>>, TError,{analysisId: string;versionId: string;incomeId: string}, TContext> => {

const mutationKey = ['deleteIncome'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIncome>>, {analysisId: string;versionId: string;incomeId: string}> = (props) => {
          const {analysisId,versionId,incomeId} = props ?? {};

          return  deleteIncome(analysisId,versionId,incomeId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIncomeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIncome>>>
    
    export type DeleteIncomeMutationError = IncomeNotFoundError

    /**
 * @deprecated
 */
export const useDeleteIncome = <TError = IncomeNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIncome>>, TError,{analysisId: string;versionId: string;incomeId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIncome>>,
        TError,
        {analysisId: string;versionId: string;incomeId: string},
        TContext
      > => {

      const mutationOptions = getDeleteIncomeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const updateLoanExpenseSettings = (
    analysisId: string,
    versionId: string,
    complexExpenseSettingsBody: ComplexExpenseSettingsBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<ComplexExpenseSettings>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/loan`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: complexExpenseSettingsBody
    },
      options);
    }
  


export const getUpdateLoanExpenseSettingsMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLoanExpenseSettings>>, TError,{analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLoanExpenseSettings>>, TError,{analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}, TContext> => {

const mutationKey = ['updateLoanExpenseSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLoanExpenseSettings>>, {analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  updateLoanExpenseSettings(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLoanExpenseSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateLoanExpenseSettings>>>
    export type UpdateLoanExpenseSettingsMutationBody = ComplexExpenseSettingsBody
    export type UpdateLoanExpenseSettingsMutationError = AnalysisNotFoundError

    /**
 * @deprecated
 */
export const useUpdateLoanExpenseSettings = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLoanExpenseSettings>>, TError,{analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLoanExpenseSettings>>,
        TError,
        {analysisId: string;versionId: string;data: ComplexExpenseSettingsBody},
        TContext
      > => {

      const mutationOptions = getUpdateLoanExpenseSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getLoanExpense = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<LoanExpense>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/loan`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLoanExpenseQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/loan`
    ] as const;
    }

    
export const getGetLoanExpenseQueryOptions = <TData = Awaited<ReturnType<typeof getLoanExpense>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanExpenseQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanExpense>>> = ({ signal }) => getLoanExpense(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanExpense>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanExpenseQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanExpense>>>
export type GetLoanExpenseQueryError = AnalysisNotFoundError


export function useGetLoanExpense<TData = Awaited<ReturnType<typeof getLoanExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanExpense>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanExpense>>,
          TError,
          Awaited<ReturnType<typeof getLoanExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanExpense<TData = Awaited<ReturnType<typeof getLoanExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanExpense>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanExpense>>,
          TError,
          Awaited<ReturnType<typeof getLoanExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanExpense<TData = Awaited<ReturnType<typeof getLoanExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLoanExpense<TData = Awaited<ReturnType<typeof getLoanExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanExpenseQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const createLoanExpenseItem = (
    analysisId: string,
    versionId: string,
    loanExpenseItemBody: LoanExpenseItemBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<LoanExpenseItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/loan`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loanExpenseItemBody, signal
    },
      options);
    }
  


export const getCreateLoanExpenseItemMutationOptions = <TError = CreateComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLoanExpenseItem>>, TError,{analysisId: string;versionId: string;data: LoanExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLoanExpenseItem>>, TError,{analysisId: string;versionId: string;data: LoanExpenseItemBody}, TContext> => {

const mutationKey = ['createLoanExpenseItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLoanExpenseItem>>, {analysisId: string;versionId: string;data: LoanExpenseItemBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createLoanExpenseItem(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateLoanExpenseItemMutationResult = NonNullable<Awaited<ReturnType<typeof createLoanExpenseItem>>>
    export type CreateLoanExpenseItemMutationBody = LoanExpenseItemBody
    export type CreateLoanExpenseItemMutationError = CreateComplexExpenseItemNotFoundError

    /**
 * @deprecated
 */
export const useCreateLoanExpenseItem = <TError = CreateComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLoanExpenseItem>>, TError,{analysisId: string;versionId: string;data: LoanExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLoanExpenseItem>>,
        TError,
        {analysisId: string;versionId: string;data: LoanExpenseItemBody},
        TContext
      > => {

      const mutationOptions = getCreateLoanExpenseItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getLoanExpenseItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<LoanExpenseItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/loan/${itemId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLoanExpenseItemQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/loan/${itemId}`
    ] as const;
    }

    
export const getGetLoanExpenseItemQueryOptions = <TData = Awaited<ReturnType<typeof getLoanExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanExpenseItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoanExpenseItemQueryKey(analysisId,versionId,itemId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoanExpenseItem>>> = ({ signal }) => getLoanExpenseItem(analysisId,versionId,itemId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoanExpenseItem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLoanExpenseItemQueryResult = NonNullable<Awaited<ReturnType<typeof getLoanExpenseItem>>>
export type GetLoanExpenseItemQueryError = ComplexExpenseItemNotFoundError


export function useGetLoanExpenseItem<TData = Awaited<ReturnType<typeof getLoanExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanExpenseItem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanExpenseItem>>,
          TError,
          Awaited<ReturnType<typeof getLoanExpenseItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanExpenseItem<TData = Awaited<ReturnType<typeof getLoanExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanExpenseItem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoanExpenseItem>>,
          TError,
          Awaited<ReturnType<typeof getLoanExpenseItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLoanExpenseItem<TData = Awaited<ReturnType<typeof getLoanExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanExpenseItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetLoanExpenseItem<TData = Awaited<ReturnType<typeof getLoanExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoanExpenseItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLoanExpenseItemQueryOptions(analysisId,versionId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const updateLoanExpenseItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
    loanExpenseItemBody: LoanExpenseItemBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<LoanExpenseItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/loan/${itemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: loanExpenseItemBody
    },
      options);
    }
  


export const getUpdateLoanExpenseItemMutationOptions = <TError = UpdateComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLoanExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: LoanExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLoanExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: LoanExpenseItemBody}, TContext> => {

const mutationKey = ['updateLoanExpenseItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLoanExpenseItem>>, {analysisId: string;versionId: string;itemId: string;data: LoanExpenseItemBody}> = (props) => {
          const {analysisId,versionId,itemId,data} = props ?? {};

          return  updateLoanExpenseItem(analysisId,versionId,itemId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateLoanExpenseItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateLoanExpenseItem>>>
    export type UpdateLoanExpenseItemMutationBody = LoanExpenseItemBody
    export type UpdateLoanExpenseItemMutationError = UpdateComplexExpenseItemNotFoundError

    /**
 * @deprecated
 */
export const useUpdateLoanExpenseItem = <TError = UpdateComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLoanExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: LoanExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLoanExpenseItem>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;data: LoanExpenseItemBody},
        TContext
      > => {

      const mutationOptions = getUpdateLoanExpenseItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const deleteLoanExpenseItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
    params?: DeleteLoanExpenseItemParams,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/loan/${itemId}`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteLoanExpenseItemMutationOptions = <TError = ComplexExpenseItemNotFoundError | RelatedAssetItemMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLoanExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;params?: DeleteLoanExpenseItemParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLoanExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;params?: DeleteLoanExpenseItemParams}, TContext> => {

const mutationKey = ['deleteLoanExpenseItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLoanExpenseItem>>, {analysisId: string;versionId: string;itemId: string;params?: DeleteLoanExpenseItemParams}> = (props) => {
          const {analysisId,versionId,itemId,params} = props ?? {};

          return  deleteLoanExpenseItem(analysisId,versionId,itemId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteLoanExpenseItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLoanExpenseItem>>>
    
    export type DeleteLoanExpenseItemMutationError = ComplexExpenseItemNotFoundError | RelatedAssetItemMismatchError

    /**
 * @deprecated
 */
export const useDeleteLoanExpenseItem = <TError = ComplexExpenseItemNotFoundError | RelatedAssetItemMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLoanExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;params?: DeleteLoanExpenseItemParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLoanExpenseItem>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;params?: DeleteLoanExpenseItemParams},
        TContext
      > => {

      const mutationOptions = getDeleteLoanExpenseItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const updateFinancialProductExpenseSettings = (
    analysisId: string,
    versionId: string,
    complexExpenseSettingsBody: ComplexExpenseSettingsBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<ComplexExpenseSettings>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/financial-product`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: complexExpenseSettingsBody
    },
      options);
    }
  


export const getUpdateFinancialProductExpenseSettingsMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFinancialProductExpenseSettings>>, TError,{analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFinancialProductExpenseSettings>>, TError,{analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}, TContext> => {

const mutationKey = ['updateFinancialProductExpenseSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFinancialProductExpenseSettings>>, {analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  updateFinancialProductExpenseSettings(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFinancialProductExpenseSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateFinancialProductExpenseSettings>>>
    export type UpdateFinancialProductExpenseSettingsMutationBody = ComplexExpenseSettingsBody
    export type UpdateFinancialProductExpenseSettingsMutationError = AnalysisNotFoundError

    /**
 * @deprecated
 */
export const useUpdateFinancialProductExpenseSettings = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFinancialProductExpenseSettings>>, TError,{analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFinancialProductExpenseSettings>>,
        TError,
        {analysisId: string;versionId: string;data: ComplexExpenseSettingsBody},
        TContext
      > => {

      const mutationOptions = getUpdateFinancialProductExpenseSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getFinancialProductExpense = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FinancialProductExpense>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/financial-product`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFinancialProductExpenseQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/financial-product`
    ] as const;
    }

    
export const getGetFinancialProductExpenseQueryOptions = <TData = Awaited<ReturnType<typeof getFinancialProductExpense>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFinancialProductExpenseQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinancialProductExpense>>> = ({ signal }) => getFinancialProductExpense(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpense>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFinancialProductExpenseQueryResult = NonNullable<Awaited<ReturnType<typeof getFinancialProductExpense>>>
export type GetFinancialProductExpenseQueryError = AnalysisNotFoundError


export function useGetFinancialProductExpense<TData = Awaited<ReturnType<typeof getFinancialProductExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpense>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialProductExpense>>,
          TError,
          Awaited<ReturnType<typeof getFinancialProductExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialProductExpense<TData = Awaited<ReturnType<typeof getFinancialProductExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpense>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialProductExpense>>,
          TError,
          Awaited<ReturnType<typeof getFinancialProductExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialProductExpense<TData = Awaited<ReturnType<typeof getFinancialProductExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFinancialProductExpense<TData = Awaited<ReturnType<typeof getFinancialProductExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFinancialProductExpenseQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const createFinancialProductExpenseItem = (
    analysisId: string,
    versionId: string,
    financialProductExpenseItemBody: FinancialProductExpenseItemBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FinancialProductExpenseItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/financial-product`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: financialProductExpenseItemBody, signal
    },
      options);
    }
  


export const getCreateFinancialProductExpenseItemMutationOptions = <TError = CreateComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFinancialProductExpenseItem>>, TError,{analysisId: string;versionId: string;data: FinancialProductExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createFinancialProductExpenseItem>>, TError,{analysisId: string;versionId: string;data: FinancialProductExpenseItemBody}, TContext> => {

const mutationKey = ['createFinancialProductExpenseItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFinancialProductExpenseItem>>, {analysisId: string;versionId: string;data: FinancialProductExpenseItemBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createFinancialProductExpenseItem(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateFinancialProductExpenseItemMutationResult = NonNullable<Awaited<ReturnType<typeof createFinancialProductExpenseItem>>>
    export type CreateFinancialProductExpenseItemMutationBody = FinancialProductExpenseItemBody
    export type CreateFinancialProductExpenseItemMutationError = CreateComplexExpenseItemNotFoundError

    /**
 * @deprecated
 */
export const useCreateFinancialProductExpenseItem = <TError = CreateComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFinancialProductExpenseItem>>, TError,{analysisId: string;versionId: string;data: FinancialProductExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFinancialProductExpenseItem>>,
        TError,
        {analysisId: string;versionId: string;data: FinancialProductExpenseItemBody},
        TContext
      > => {

      const mutationOptions = getCreateFinancialProductExpenseItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getFinancialProductExpenseItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FinancialProductExpenseItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/financial-product/${itemId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFinancialProductExpenseItemQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/financial-product/${itemId}`
    ] as const;
    }

    
export const getGetFinancialProductExpenseItemQueryOptions = <TData = Awaited<ReturnType<typeof getFinancialProductExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpenseItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFinancialProductExpenseItemQueryKey(analysisId,versionId,itemId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFinancialProductExpenseItem>>> = ({ signal }) => getFinancialProductExpenseItem(analysisId,versionId,itemId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpenseItem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFinancialProductExpenseItemQueryResult = NonNullable<Awaited<ReturnType<typeof getFinancialProductExpenseItem>>>
export type GetFinancialProductExpenseItemQueryError = ComplexExpenseItemNotFoundError


export function useGetFinancialProductExpenseItem<TData = Awaited<ReturnType<typeof getFinancialProductExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpenseItem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialProductExpenseItem>>,
          TError,
          Awaited<ReturnType<typeof getFinancialProductExpenseItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialProductExpenseItem<TData = Awaited<ReturnType<typeof getFinancialProductExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpenseItem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFinancialProductExpenseItem>>,
          TError,
          Awaited<ReturnType<typeof getFinancialProductExpenseItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFinancialProductExpenseItem<TData = Awaited<ReturnType<typeof getFinancialProductExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpenseItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFinancialProductExpenseItem<TData = Awaited<ReturnType<typeof getFinancialProductExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFinancialProductExpenseItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFinancialProductExpenseItemQueryOptions(analysisId,versionId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const updateFinancialProductExpenseItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
    financialProductExpenseItemBody: FinancialProductExpenseItemBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<FinancialProductExpenseItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/financial-product/${itemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: financialProductExpenseItemBody
    },
      options);
    }
  


export const getUpdateFinancialProductExpenseItemMutationOptions = <TError = UpdateComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFinancialProductExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: FinancialProductExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateFinancialProductExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: FinancialProductExpenseItemBody}, TContext> => {

const mutationKey = ['updateFinancialProductExpenseItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFinancialProductExpenseItem>>, {analysisId: string;versionId: string;itemId: string;data: FinancialProductExpenseItemBody}> = (props) => {
          const {analysisId,versionId,itemId,data} = props ?? {};

          return  updateFinancialProductExpenseItem(analysisId,versionId,itemId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateFinancialProductExpenseItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateFinancialProductExpenseItem>>>
    export type UpdateFinancialProductExpenseItemMutationBody = FinancialProductExpenseItemBody
    export type UpdateFinancialProductExpenseItemMutationError = UpdateComplexExpenseItemNotFoundError

    /**
 * @deprecated
 */
export const useUpdateFinancialProductExpenseItem = <TError = UpdateComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFinancialProductExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: FinancialProductExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateFinancialProductExpenseItem>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;data: FinancialProductExpenseItemBody},
        TContext
      > => {

      const mutationOptions = getUpdateFinancialProductExpenseItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const deleteFinancialProductExpenseItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
    params?: DeleteFinancialProductExpenseItemParams,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/financial-product/${itemId}`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteFinancialProductExpenseItemMutationOptions = <TError = ComplexExpenseItemNotFoundError | RelatedAssetItemMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFinancialProductExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;params?: DeleteFinancialProductExpenseItemParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFinancialProductExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;params?: DeleteFinancialProductExpenseItemParams}, TContext> => {

const mutationKey = ['deleteFinancialProductExpenseItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFinancialProductExpenseItem>>, {analysisId: string;versionId: string;itemId: string;params?: DeleteFinancialProductExpenseItemParams}> = (props) => {
          const {analysisId,versionId,itemId,params} = props ?? {};

          return  deleteFinancialProductExpenseItem(analysisId,versionId,itemId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteFinancialProductExpenseItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFinancialProductExpenseItem>>>
    
    export type DeleteFinancialProductExpenseItemMutationError = ComplexExpenseItemNotFoundError | RelatedAssetItemMismatchError

    /**
 * @deprecated
 */
export const useDeleteFinancialProductExpenseItem = <TError = ComplexExpenseItemNotFoundError | RelatedAssetItemMismatchError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFinancialProductExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;params?: DeleteFinancialProductExpenseItemParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFinancialProductExpenseItem>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;params?: DeleteFinancialProductExpenseItemParams},
        TContext
      > => {

      const mutationOptions = getDeleteFinancialProductExpenseItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const updateInsuranceExpenseSettings = (
    analysisId: string,
    versionId: string,
    complexExpenseSettingsBody: ComplexExpenseSettingsBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<ComplexExpenseSettings>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/insurance`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: complexExpenseSettingsBody
    },
      options);
    }
  


export const getUpdateInsuranceExpenseSettingsMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceExpenseSettings>>, TError,{analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceExpenseSettings>>, TError,{analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}, TContext> => {

const mutationKey = ['updateInsuranceExpenseSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInsuranceExpenseSettings>>, {analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  updateInsuranceExpenseSettings(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInsuranceExpenseSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateInsuranceExpenseSettings>>>
    export type UpdateInsuranceExpenseSettingsMutationBody = ComplexExpenseSettingsBody
    export type UpdateInsuranceExpenseSettingsMutationError = AnalysisNotFoundError

    /**
 * @deprecated
 */
export const useUpdateInsuranceExpenseSettings = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceExpenseSettings>>, TError,{analysisId: string;versionId: string;data: ComplexExpenseSettingsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInsuranceExpenseSettings>>,
        TError,
        {analysisId: string;versionId: string;data: ComplexExpenseSettingsBody},
        TContext
      > => {

      const mutationOptions = getUpdateInsuranceExpenseSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getInsuranceExpense = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<InsuranceExpense>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/insurance`, method: 'GET', signal
    },
      options);
    }
  



export const getGetInsuranceExpenseQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/insurance`
    ] as const;
    }

    
export const getGetInsuranceExpenseQueryOptions = <TData = Awaited<ReturnType<typeof getInsuranceExpense>>, TError = AnalysisNotFoundError>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInsuranceExpenseQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInsuranceExpense>>> = ({ signal }) => getInsuranceExpense(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpense>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInsuranceExpenseQueryResult = NonNullable<Awaited<ReturnType<typeof getInsuranceExpense>>>
export type GetInsuranceExpenseQueryError = AnalysisNotFoundError


export function useGetInsuranceExpense<TData = Awaited<ReturnType<typeof getInsuranceExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpense>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsuranceExpense>>,
          TError,
          Awaited<ReturnType<typeof getInsuranceExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInsuranceExpense<TData = Awaited<ReturnType<typeof getInsuranceExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpense>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsuranceExpense>>,
          TError,
          Awaited<ReturnType<typeof getInsuranceExpense>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInsuranceExpense<TData = Awaited<ReturnType<typeof getInsuranceExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInsuranceExpense<TData = Awaited<ReturnType<typeof getInsuranceExpense>>, TError = AnalysisNotFoundError>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpense>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInsuranceExpenseQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const createInsuranceExpenseItem = (
    analysisId: string,
    versionId: string,
    insuranceExpenseItemBody: InsuranceExpenseItemBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<InsuranceExpenseItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/insurance`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: insuranceExpenseItemBody, signal
    },
      options);
    }
  


export const getCreateInsuranceExpenseItemMutationOptions = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInsuranceExpenseItem>>, TError,{analysisId: string;versionId: string;data: InsuranceExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInsuranceExpenseItem>>, TError,{analysisId: string;versionId: string;data: InsuranceExpenseItemBody}, TContext> => {

const mutationKey = ['createInsuranceExpenseItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInsuranceExpenseItem>>, {analysisId: string;versionId: string;data: InsuranceExpenseItemBody}> = (props) => {
          const {analysisId,versionId,data} = props ?? {};

          return  createInsuranceExpenseItem(analysisId,versionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInsuranceExpenseItemMutationResult = NonNullable<Awaited<ReturnType<typeof createInsuranceExpenseItem>>>
    export type CreateInsuranceExpenseItemMutationBody = InsuranceExpenseItemBody
    export type CreateInsuranceExpenseItemMutationError = AnalysisNotFoundError

    /**
 * @deprecated
 */
export const useCreateInsuranceExpenseItem = <TError = AnalysisNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInsuranceExpenseItem>>, TError,{analysisId: string;versionId: string;data: InsuranceExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInsuranceExpenseItem>>,
        TError,
        {analysisId: string;versionId: string;data: InsuranceExpenseItemBody},
        TContext
      > => {

      const mutationOptions = getCreateInsuranceExpenseItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getInsuranceExpenseItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<InsuranceExpenseItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/insurance/${itemId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetInsuranceExpenseItemQueryKey = (analysisId?: string,
    versionId?: string,
    itemId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/insurance/${itemId}`
    ] as const;
    }

    
export const getGetInsuranceExpenseItemQueryOptions = <TData = Awaited<ReturnType<typeof getInsuranceExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpenseItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInsuranceExpenseItemQueryKey(analysisId,versionId,itemId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInsuranceExpenseItem>>> = ({ signal }) => getInsuranceExpenseItem(analysisId,versionId,itemId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && itemId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpenseItem>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInsuranceExpenseItemQueryResult = NonNullable<Awaited<ReturnType<typeof getInsuranceExpenseItem>>>
export type GetInsuranceExpenseItemQueryError = ComplexExpenseItemNotFoundError


export function useGetInsuranceExpenseItem<TData = Awaited<ReturnType<typeof getInsuranceExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpenseItem>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsuranceExpenseItem>>,
          TError,
          Awaited<ReturnType<typeof getInsuranceExpenseItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInsuranceExpenseItem<TData = Awaited<ReturnType<typeof getInsuranceExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpenseItem>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsuranceExpenseItem>>,
          TError,
          Awaited<ReturnType<typeof getInsuranceExpenseItem>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInsuranceExpenseItem<TData = Awaited<ReturnType<typeof getInsuranceExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpenseItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInsuranceExpenseItem<TData = Awaited<ReturnType<typeof getInsuranceExpenseItem>>, TError = ComplexExpenseItemNotFoundError>(
 analysisId: string,
    versionId: string,
    itemId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceExpenseItem>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInsuranceExpenseItemQueryOptions(analysisId,versionId,itemId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const updateInsuranceExpenseItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
    insuranceExpenseItemBody: InsuranceExpenseItemBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<InsuranceExpenseItem>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/insurance/${itemId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: insuranceExpenseItemBody
    },
      options);
    }
  


export const getUpdateInsuranceExpenseItemMutationOptions = <TError = ComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: InsuranceExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: InsuranceExpenseItemBody}, TContext> => {

const mutationKey = ['updateInsuranceExpenseItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInsuranceExpenseItem>>, {analysisId: string;versionId: string;itemId: string;data: InsuranceExpenseItemBody}> = (props) => {
          const {analysisId,versionId,itemId,data} = props ?? {};

          return  updateInsuranceExpenseItem(analysisId,versionId,itemId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInsuranceExpenseItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateInsuranceExpenseItem>>>
    export type UpdateInsuranceExpenseItemMutationBody = InsuranceExpenseItemBody
    export type UpdateInsuranceExpenseItemMutationError = ComplexExpenseItemNotFoundError

    /**
 * @deprecated
 */
export const useUpdateInsuranceExpenseItem = <TError = ComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string;data: InsuranceExpenseItemBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInsuranceExpenseItem>>,
        TError,
        {analysisId: string;versionId: string;itemId: string;data: InsuranceExpenseItemBody},
        TContext
      > => {

      const mutationOptions = getUpdateInsuranceExpenseItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Replaced by `POST /budget/expenses/batch`
 * @deprecated
 */
export const deleteInsuranceExpenseItem = (
    analysisId: string,
    versionId: string,
    itemId: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/budget/expenses/insurance/${itemId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteInsuranceExpenseItemMutationOptions = <TError = ComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInsuranceExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInsuranceExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string}, TContext> => {

const mutationKey = ['deleteInsuranceExpenseItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInsuranceExpenseItem>>, {analysisId: string;versionId: string;itemId: string}> = (props) => {
          const {analysisId,versionId,itemId} = props ?? {};

          return  deleteInsuranceExpenseItem(analysisId,versionId,itemId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInsuranceExpenseItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInsuranceExpenseItem>>>
    
    export type DeleteInsuranceExpenseItemMutationError = ComplexExpenseItemNotFoundError

    /**
 * @deprecated
 */
export const useDeleteInsuranceExpenseItem = <TError = ComplexExpenseItemNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInsuranceExpenseItem>>, TError,{analysisId: string;versionId: string;itemId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInsuranceExpenseItem>>,
        TError,
        {analysisId: string;versionId: string;itemId: string},
        TContext
      > => {

      const mutationOptions = getDeleteInsuranceExpenseItemMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listInsuranceRisks = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Risk[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/risks`, method: 'GET', signal
    },
      options);
    }
  



export const getListInsuranceRisksQueryKey = (analysisId?: string,
    versionId?: string,
    clientGuid?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/risks`
    ] as const;
    }

    
export const getListInsuranceRisksQueryOptions = <TData = Awaited<ReturnType<typeof listInsuranceRisks>>, TError = unknown>(analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceRisks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInsuranceRisksQueryKey(analysisId,versionId,clientGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInsuranceRisks>>> = ({ signal }) => listInsuranceRisks(analysisId,versionId,clientGuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && clientGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInsuranceRisks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInsuranceRisksQueryResult = NonNullable<Awaited<ReturnType<typeof listInsuranceRisks>>>
export type ListInsuranceRisksQueryError = unknown


export function useListInsuranceRisks<TData = Awaited<ReturnType<typeof listInsuranceRisks>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceRisks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInsuranceRisks>>,
          TError,
          Awaited<ReturnType<typeof listInsuranceRisks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInsuranceRisks<TData = Awaited<ReturnType<typeof listInsuranceRisks>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceRisks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInsuranceRisks>>,
          TError,
          Awaited<ReturnType<typeof listInsuranceRisks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInsuranceRisks<TData = Awaited<ReturnType<typeof listInsuranceRisks>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceRisks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListInsuranceRisks<TData = Awaited<ReturnType<typeof listInsuranceRisks>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceRisks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInsuranceRisksQueryOptions(analysisId,versionId,clientGuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createInsuranceRisk = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
    createRiskBody: CreateRiskBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Risk>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/risks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRiskBody, signal
    },
      options);
    }
  


export const getCreateInsuranceRiskMutationOptions = <TError = RiskAlreadyExistsError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInsuranceRisk>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: CreateRiskBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInsuranceRisk>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: CreateRiskBody}, TContext> => {

const mutationKey = ['createInsuranceRisk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInsuranceRisk>>, {analysisId: string;versionId: string;clientGuid: string;data: CreateRiskBody}> = (props) => {
          const {analysisId,versionId,clientGuid,data} = props ?? {};

          return  createInsuranceRisk(analysisId,versionId,clientGuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInsuranceRiskMutationResult = NonNullable<Awaited<ReturnType<typeof createInsuranceRisk>>>
    export type CreateInsuranceRiskMutationBody = CreateRiskBody
    export type CreateInsuranceRiskMutationError = RiskAlreadyExistsError

    export const useCreateInsuranceRisk = <TError = RiskAlreadyExistsError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInsuranceRisk>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: CreateRiskBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInsuranceRisk>>,
        TError,
        {analysisId: string;versionId: string;clientGuid: string;data: CreateRiskBody},
        TContext
      > => {

      const mutationOptions = getCreateInsuranceRiskMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const recalculateAllInsuranceRisks = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Risk[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/risks/recalculate-all`, method: 'POST', signal
    },
      options);
    }
  


export const getRecalculateAllInsuranceRisksMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateAllInsuranceRisks>>, TError,{analysisId: string;versionId: string;clientGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recalculateAllInsuranceRisks>>, TError,{analysisId: string;versionId: string;clientGuid: string}, TContext> => {

const mutationKey = ['recalculateAllInsuranceRisks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recalculateAllInsuranceRisks>>, {analysisId: string;versionId: string;clientGuid: string}> = (props) => {
          const {analysisId,versionId,clientGuid} = props ?? {};

          return  recalculateAllInsuranceRisks(analysisId,versionId,clientGuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RecalculateAllInsuranceRisksMutationResult = NonNullable<Awaited<ReturnType<typeof recalculateAllInsuranceRisks>>>
    
    export type RecalculateAllInsuranceRisksMutationError = unknown

    export const useRecalculateAllInsuranceRisks = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recalculateAllInsuranceRisks>>, TError,{analysisId: string;versionId: string;clientGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof recalculateAllInsuranceRisks>>,
        TError,
        {analysisId: string;versionId: string;clientGuid: string},
        TContext
      > => {

      const mutationOptions = getRecalculateAllInsuranceRisksMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateInsuranceRisk = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
    riskGuid: string,
    updateRiskBody: UpdateRiskBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<Risk>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/risks/${riskGuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateRiskBody
    },
      options);
    }
  


export const getUpdateInsuranceRiskMutationOptions = <TError = RiskNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceRisk>>, TError,{analysisId: string;versionId: string;clientGuid: string;riskGuid: string;data: UpdateRiskBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceRisk>>, TError,{analysisId: string;versionId: string;clientGuid: string;riskGuid: string;data: UpdateRiskBody}, TContext> => {

const mutationKey = ['updateInsuranceRisk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInsuranceRisk>>, {analysisId: string;versionId: string;clientGuid: string;riskGuid: string;data: UpdateRiskBody}> = (props) => {
          const {analysisId,versionId,clientGuid,riskGuid,data} = props ?? {};

          return  updateInsuranceRisk(analysisId,versionId,clientGuid,riskGuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInsuranceRiskMutationResult = NonNullable<Awaited<ReturnType<typeof updateInsuranceRisk>>>
    export type UpdateInsuranceRiskMutationBody = UpdateRiskBody
    export type UpdateInsuranceRiskMutationError = RiskNotFoundError

    export const useUpdateInsuranceRisk = <TError = RiskNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceRisk>>, TError,{analysisId: string;versionId: string;clientGuid: string;riskGuid: string;data: UpdateRiskBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInsuranceRisk>>,
        TError,
        {analysisId: string;versionId: string;clientGuid: string;riskGuid: string;data: UpdateRiskBody},
        TContext
      > => {

      const mutationOptions = getUpdateInsuranceRiskMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteInsuranceRisk = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
    riskGuid: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/risks/${riskGuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteInsuranceRiskMutationOptions = <TError = RiskNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInsuranceRisk>>, TError,{analysisId: string;versionId: string;clientGuid: string;riskGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInsuranceRisk>>, TError,{analysisId: string;versionId: string;clientGuid: string;riskGuid: string}, TContext> => {

const mutationKey = ['deleteInsuranceRisk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInsuranceRisk>>, {analysisId: string;versionId: string;clientGuid: string;riskGuid: string}> = (props) => {
          const {analysisId,versionId,clientGuid,riskGuid} = props ?? {};

          return  deleteInsuranceRisk(analysisId,versionId,clientGuid,riskGuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInsuranceRiskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInsuranceRisk>>>
    
    export type DeleteInsuranceRiskMutationError = RiskNotFoundError

    export const useDeleteInsuranceRisk = <TError = RiskNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInsuranceRisk>>, TError,{analysisId: string;versionId: string;clientGuid: string;riskGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInsuranceRisk>>,
        TError,
        {analysisId: string;versionId: string;clientGuid: string;riskGuid: string},
        TContext
      > => {

      const mutationOptions = getDeleteInsuranceRiskMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listInsuranceContracts = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Contract[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/contracts`, method: 'GET', signal
    },
      options);
    }
  



export const getListInsuranceContractsQueryKey = (analysisId?: string,
    versionId?: string,
    clientGuid?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/contracts`
    ] as const;
    }

    
export const getListInsuranceContractsQueryOptions = <TData = Awaited<ReturnType<typeof listInsuranceContracts>>, TError = unknown>(analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInsuranceContractsQueryKey(analysisId,versionId,clientGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInsuranceContracts>>> = ({ signal }) => listInsuranceContracts(analysisId,versionId,clientGuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && clientGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInsuranceContracts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInsuranceContractsQueryResult = NonNullable<Awaited<ReturnType<typeof listInsuranceContracts>>>
export type ListInsuranceContractsQueryError = unknown


export function useListInsuranceContracts<TData = Awaited<ReturnType<typeof listInsuranceContracts>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceContracts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInsuranceContracts>>,
          TError,
          Awaited<ReturnType<typeof listInsuranceContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInsuranceContracts<TData = Awaited<ReturnType<typeof listInsuranceContracts>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceContracts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInsuranceContracts>>,
          TError,
          Awaited<ReturnType<typeof listInsuranceContracts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInsuranceContracts<TData = Awaited<ReturnType<typeof listInsuranceContracts>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListInsuranceContracts<TData = Awaited<ReturnType<typeof listInsuranceContracts>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceContracts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInsuranceContractsQueryOptions(analysisId,versionId,clientGuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const createInsuranceContract = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
    contractBody: ContractBody,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Contract>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/contracts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contractBody, signal
    },
      options);
    }
  


export const getCreateInsuranceContractMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInsuranceContract>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: ContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInsuranceContract>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: ContractBody}, TContext> => {

const mutationKey = ['createInsuranceContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInsuranceContract>>, {analysisId: string;versionId: string;clientGuid: string;data: ContractBody}> = (props) => {
          const {analysisId,versionId,clientGuid,data} = props ?? {};

          return  createInsuranceContract(analysisId,versionId,clientGuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateInsuranceContractMutationResult = NonNullable<Awaited<ReturnType<typeof createInsuranceContract>>>
    export type CreateInsuranceContractMutationBody = ContractBody
    export type CreateInsuranceContractMutationError = unknown

    export const useCreateInsuranceContract = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInsuranceContract>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: ContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createInsuranceContract>>,
        TError,
        {analysisId: string;versionId: string;clientGuid: string;data: ContractBody},
        TContext
      > => {

      const mutationOptions = getCreateInsuranceContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateInsuranceContract = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
    contractGuid: string,
    contractBody: ContractBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<Contract>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/contracts/${contractGuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: contractBody
    },
      options);
    }
  


export const getUpdateInsuranceContractMutationOptions = <TError = ContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceContract>>, TError,{analysisId: string;versionId: string;clientGuid: string;contractGuid: string;data: ContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceContract>>, TError,{analysisId: string;versionId: string;clientGuid: string;contractGuid: string;data: ContractBody}, TContext> => {

const mutationKey = ['updateInsuranceContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInsuranceContract>>, {analysisId: string;versionId: string;clientGuid: string;contractGuid: string;data: ContractBody}> = (props) => {
          const {analysisId,versionId,clientGuid,contractGuid,data} = props ?? {};

          return  updateInsuranceContract(analysisId,versionId,clientGuid,contractGuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInsuranceContractMutationResult = NonNullable<Awaited<ReturnType<typeof updateInsuranceContract>>>
    export type UpdateInsuranceContractMutationBody = ContractBody
    export type UpdateInsuranceContractMutationError = ContractNotFoundError

    export const useUpdateInsuranceContract = <TError = ContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceContract>>, TError,{analysisId: string;versionId: string;clientGuid: string;contractGuid: string;data: ContractBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInsuranceContract>>,
        TError,
        {analysisId: string;versionId: string;clientGuid: string;contractGuid: string;data: ContractBody},
        TContext
      > => {

      const mutationOptions = getUpdateInsuranceContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const deleteInsuranceContract = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
    contractGuid: string,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<void>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/contracts/${contractGuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteInsuranceContractMutationOptions = <TError = ContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInsuranceContract>>, TError,{analysisId: string;versionId: string;clientGuid: string;contractGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInsuranceContract>>, TError,{analysisId: string;versionId: string;clientGuid: string;contractGuid: string}, TContext> => {

const mutationKey = ['deleteInsuranceContract'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInsuranceContract>>, {analysisId: string;versionId: string;clientGuid: string;contractGuid: string}> = (props) => {
          const {analysisId,versionId,clientGuid,contractGuid} = props ?? {};

          return  deleteInsuranceContract(analysisId,versionId,clientGuid,contractGuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInsuranceContractMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInsuranceContract>>>
    
    export type DeleteInsuranceContractMutationError = ContractNotFoundError

    export const useDeleteInsuranceContract = <TError = ContractNotFoundError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInsuranceContract>>, TError,{analysisId: string;versionId: string;clientGuid: string;contractGuid: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInsuranceContract>>,
        TError,
        {analysisId: string;versionId: string;clientGuid: string;contractGuid: string},
        TContext
      > => {

      const mutationOptions = getDeleteInsuranceContractMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getInsuranceRiskParameters = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<CoverageParameters>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/risk-parameters`, method: 'GET', signal
    },
      options);
    }
  



export const getGetInsuranceRiskParametersQueryKey = (analysisId?: string,
    versionId?: string,
    clientGuid?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/risk-parameters`
    ] as const;
    }

    
export const getGetInsuranceRiskParametersQueryOptions = <TData = Awaited<ReturnType<typeof getInsuranceRiskParameters>>, TError = unknown>(analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceRiskParameters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInsuranceRiskParametersQueryKey(analysisId,versionId,clientGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInsuranceRiskParameters>>> = ({ signal }) => getInsuranceRiskParameters(analysisId,versionId,clientGuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && clientGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInsuranceRiskParameters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInsuranceRiskParametersQueryResult = NonNullable<Awaited<ReturnType<typeof getInsuranceRiskParameters>>>
export type GetInsuranceRiskParametersQueryError = unknown


export function useGetInsuranceRiskParameters<TData = Awaited<ReturnType<typeof getInsuranceRiskParameters>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceRiskParameters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsuranceRiskParameters>>,
          TError,
          Awaited<ReturnType<typeof getInsuranceRiskParameters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInsuranceRiskParameters<TData = Awaited<ReturnType<typeof getInsuranceRiskParameters>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceRiskParameters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInsuranceRiskParameters>>,
          TError,
          Awaited<ReturnType<typeof getInsuranceRiskParameters>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInsuranceRiskParameters<TData = Awaited<ReturnType<typeof getInsuranceRiskParameters>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceRiskParameters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInsuranceRiskParameters<TData = Awaited<ReturnType<typeof getInsuranceRiskParameters>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInsuranceRiskParameters>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInsuranceRiskParametersQueryOptions(analysisId,versionId,clientGuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateInsuranceRiskParameters = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
    coverageParametersBody: CoverageParametersBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<CoverageParameters>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/risk-parameters`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: coverageParametersBody
    },
      options);
    }
  


export const getUpdateInsuranceRiskParametersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceRiskParameters>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: CoverageParametersBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceRiskParameters>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: CoverageParametersBody}, TContext> => {

const mutationKey = ['updateInsuranceRiskParameters'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInsuranceRiskParameters>>, {analysisId: string;versionId: string;clientGuid: string;data: CoverageParametersBody}> = (props) => {
          const {analysisId,versionId,clientGuid,data} = props ?? {};

          return  updateInsuranceRiskParameters(analysisId,versionId,clientGuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateInsuranceRiskParametersMutationResult = NonNullable<Awaited<ReturnType<typeof updateInsuranceRiskParameters>>>
    export type UpdateInsuranceRiskParametersMutationBody = CoverageParametersBody
    export type UpdateInsuranceRiskParametersMutationError = unknown

    export const useUpdateInsuranceRiskParameters = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInsuranceRiskParameters>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: CoverageParametersBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateInsuranceRiskParameters>>,
        TError,
        {analysisId: string;versionId: string;clientGuid: string;data: CoverageParametersBody},
        TContext
      > => {

      const mutationOptions = getUpdateInsuranceRiskParametersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const getSocialSupport = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<SocialSupport>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/social-support`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSocialSupportQueryKey = (analysisId?: string,
    versionId?: string,
    clientGuid?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/social-support`
    ] as const;
    }

    
export const getGetSocialSupportQueryOptions = <TData = Awaited<ReturnType<typeof getSocialSupport>>, TError = unknown>(analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialSupport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSocialSupportQueryKey(analysisId,versionId,clientGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSocialSupport>>> = ({ signal }) => getSocialSupport(analysisId,versionId,clientGuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && clientGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSocialSupport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSocialSupportQueryResult = NonNullable<Awaited<ReturnType<typeof getSocialSupport>>>
export type GetSocialSupportQueryError = unknown


export function useGetSocialSupport<TData = Awaited<ReturnType<typeof getSocialSupport>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialSupport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSocialSupport>>,
          TError,
          Awaited<ReturnType<typeof getSocialSupport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSocialSupport<TData = Awaited<ReturnType<typeof getSocialSupport>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialSupport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSocialSupport>>,
          TError,
          Awaited<ReturnType<typeof getSocialSupport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSocialSupport<TData = Awaited<ReturnType<typeof getSocialSupport>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialSupport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSocialSupport<TData = Awaited<ReturnType<typeof getSocialSupport>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSocialSupport>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSocialSupportQueryOptions(analysisId,versionId,clientGuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const updateSocialSupport = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
    socialSupportBody: SocialSupportBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<SocialSupport>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/social-support`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: socialSupportBody
    },
      options);
    }
  


export const getUpdateSocialSupportMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialSupport>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: SocialSupportBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSocialSupport>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: SocialSupportBody}, TContext> => {

const mutationKey = ['updateSocialSupport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSocialSupport>>, {analysisId: string;versionId: string;clientGuid: string;data: SocialSupportBody}> = (props) => {
          const {analysisId,versionId,clientGuid,data} = props ?? {};

          return  updateSocialSupport(analysisId,versionId,clientGuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSocialSupportMutationResult = NonNullable<Awaited<ReturnType<typeof updateSocialSupport>>>
    export type UpdateSocialSupportMutationBody = SocialSupportBody
    export type UpdateSocialSupportMutationError = unknown

    export const useUpdateSocialSupport = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialSupport>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: SocialSupportBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSocialSupport>>,
        TError,
        {analysisId: string;versionId: string;clientGuid: string;data: SocialSupportBody},
        TContext
      > => {

      const mutationOptions = getUpdateSocialSupportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const setSocialSupportCalculationMode = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
    mode: 'individual' | 'average',
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<SocialSupport>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/social-support/calculation-mode/${mode}`, method: 'PATCH'
    },
      options);
    }
  


export const getSetSocialSupportCalculationModeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSocialSupportCalculationMode>>, TError,{analysisId: string;versionId: string;clientGuid: string;mode: 'individual' | 'average'}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setSocialSupportCalculationMode>>, TError,{analysisId: string;versionId: string;clientGuid: string;mode: 'individual' | 'average'}, TContext> => {

const mutationKey = ['setSocialSupportCalculationMode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setSocialSupportCalculationMode>>, {analysisId: string;versionId: string;clientGuid: string;mode: 'individual' | 'average'}> = (props) => {
          const {analysisId,versionId,clientGuid,mode} = props ?? {};

          return  setSocialSupportCalculationMode(analysisId,versionId,clientGuid,mode,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetSocialSupportCalculationModeMutationResult = NonNullable<Awaited<ReturnType<typeof setSocialSupportCalculationMode>>>
    
    export type SetSocialSupportCalculationModeMutationError = unknown

    export const useSetSocialSupportCalculationMode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setSocialSupportCalculationMode>>, TError,{analysisId: string;versionId: string;clientGuid: string;mode: 'individual' | 'average'}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setSocialSupportCalculationMode>>,
        TError,
        {analysisId: string;versionId: string;clientGuid: string;mode: 'individual' | 'average'},
        TContext
      > => {

      const mutationOptions = getSetSocialSupportCalculationModeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const updateSocialSupportCalculationParameters = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
    calculationParametersBody: CalculationParametersBody,
 options?: SecondParameter<typeof customFetch>,) => {
      
      
      return customFetch<SocialSupport>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/social-support/calculation-parameters`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: calculationParametersBody
    },
      options);
    }
  


export const getUpdateSocialSupportCalculationParametersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialSupportCalculationParameters>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: CalculationParametersBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSocialSupportCalculationParameters>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: CalculationParametersBody}, TContext> => {

const mutationKey = ['updateSocialSupportCalculationParameters'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSocialSupportCalculationParameters>>, {analysisId: string;versionId: string;clientGuid: string;data: CalculationParametersBody}> = (props) => {
          const {analysisId,versionId,clientGuid,data} = props ?? {};

          return  updateSocialSupportCalculationParameters(analysisId,versionId,clientGuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSocialSupportCalculationParametersMutationResult = NonNullable<Awaited<ReturnType<typeof updateSocialSupportCalculationParameters>>>
    export type UpdateSocialSupportCalculationParametersMutationBody = CalculationParametersBody
    export type UpdateSocialSupportCalculationParametersMutationError = unknown

    export const useUpdateSocialSupportCalculationParameters = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSocialSupportCalculationParameters>>, TError,{analysisId: string;versionId: string;clientGuid: string;data: CalculationParametersBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSocialSupportCalculationParameters>>,
        TError,
        {analysisId: string;versionId: string;clientGuid: string;data: CalculationParametersBody},
        TContext
      > => {

      const mutationOptions = getUpdateSocialSupportCalculationParametersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export const listInsuranceFamilyLiabilities = (
    analysisId: string,
    versionId: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<FamilyLiabilityOverview[]>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/insurance/family-liabilities`, method: 'GET', signal
    },
      options);
    }
  



export const getListInsuranceFamilyLiabilitiesQueryKey = (analysisId?: string,
    versionId?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/insurance/family-liabilities`
    ] as const;
    }

    
export const getListInsuranceFamilyLiabilitiesQueryOptions = <TData = Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>, TError = unknown>(analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInsuranceFamilyLiabilitiesQueryKey(analysisId,versionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>> = ({ signal }) => listInsuranceFamilyLiabilities(analysisId,versionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListInsuranceFamilyLiabilitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>>
export type ListInsuranceFamilyLiabilitiesQueryError = unknown


export function useListInsuranceFamilyLiabilities<TData = Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>, TError = unknown>(
 analysisId: string,
    versionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>,
          TError,
          Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInsuranceFamilyLiabilities<TData = Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>, TError = unknown>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>,
          TError,
          Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListInsuranceFamilyLiabilities<TData = Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>, TError = unknown>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListInsuranceFamilyLiabilities<TData = Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>, TError = unknown>(
 analysisId: string,
    versionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listInsuranceFamilyLiabilities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListInsuranceFamilyLiabilitiesQueryOptions(analysisId,versionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getClientInsuranceRecapitulation = (
    analysisId: string,
    versionId: string,
    clientGuid: string,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<ClientBudgetRecapitulation>(
      {url: `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/family-recapitulation`, method: 'GET', signal
    },
      options);
    }
  



export const getGetClientInsuranceRecapitulationQueryKey = (analysisId?: string,
    versionId?: string,
    clientGuid?: string,) => {
    return [
    `/v1/analyses/${analysisId}/versions/${versionId}/clients/${clientGuid}/insurance/family-recapitulation`
    ] as const;
    }

    
export const getGetClientInsuranceRecapitulationQueryOptions = <TData = Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>, TError = unknown>(analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientInsuranceRecapitulationQueryKey(analysisId,versionId,clientGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>> = ({ signal }) => getClientInsuranceRecapitulation(analysisId,versionId,clientGuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(analysisId && versionId && clientGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientInsuranceRecapitulationQueryResult = NonNullable<Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>>
export type GetClientInsuranceRecapitulationQueryError = unknown


export function useGetClientInsuranceRecapitulation<TData = Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>,
          TError,
          Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientInsuranceRecapitulation<TData = Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>,
          TError,
          Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientInsuranceRecapitulation<TData = Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetClientInsuranceRecapitulation<TData = Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>, TError = unknown>(
 analysisId: string,
    versionId: string,
    clientGuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientInsuranceRecapitulation>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClientInsuranceRecapitulationQueryOptions(analysisId,versionId,clientGuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listAnalyzerPartners = (
    params?: ListAnalyzerPartnersParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<AnalyzerPartner[]>(
      {url: `/v1/partners`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getListAnalyzerPartnersQueryKey = (params?: ListAnalyzerPartnersParams,) => {
    return [
    `/v1/partners`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getListAnalyzerPartnersQueryOptions = <TData = Awaited<ReturnType<typeof listAnalyzerPartners>>, TError = unknown>(params?: ListAnalyzerPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalyzerPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnalyzerPartnersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnalyzerPartners>>> = ({ signal }) => listAnalyzerPartners(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAnalyzerPartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAnalyzerPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof listAnalyzerPartners>>>
export type ListAnalyzerPartnersQueryError = unknown


export function useListAnalyzerPartners<TData = Awaited<ReturnType<typeof listAnalyzerPartners>>, TError = unknown>(
 params: undefined |  ListAnalyzerPartnersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalyzerPartners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnalyzerPartners>>,
          TError,
          Awaited<ReturnType<typeof listAnalyzerPartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnalyzerPartners<TData = Awaited<ReturnType<typeof listAnalyzerPartners>>, TError = unknown>(
 params?: ListAnalyzerPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalyzerPartners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnalyzerPartners>>,
          TError,
          Awaited<ReturnType<typeof listAnalyzerPartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnalyzerPartners<TData = Awaited<ReturnType<typeof listAnalyzerPartners>>, TError = unknown>(
 params?: ListAnalyzerPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalyzerPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListAnalyzerPartners<TData = Awaited<ReturnType<typeof listAnalyzerPartners>>, TError = unknown>(
 params?: ListAnalyzerPartnersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnalyzerPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAnalyzerPartnersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getInstruments = (
    params?: GetInstrumentsParams,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<InstrumentsListResponse>(
      {url: `/v1/instruments`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetInstrumentsQueryKey = (params?: GetInstrumentsParams,) => {
    return [
    `/v1/instruments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetInstrumentsQueryOptions = <TData = Awaited<ReturnType<typeof getInstruments>>, TError = unknown>(params?: GetInstrumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInstrumentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInstruments>>> = ({ signal }) => getInstruments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInstruments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInstrumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getInstruments>>>
export type GetInstrumentsQueryError = unknown


export function useGetInstruments<TData = Awaited<ReturnType<typeof getInstruments>>, TError = unknown>(
 params: undefined |  GetInstrumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstruments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstruments>>,
          TError,
          Awaited<ReturnType<typeof getInstruments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstruments<TData = Awaited<ReturnType<typeof getInstruments>>, TError = unknown>(
 params?: GetInstrumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstruments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstruments>>,
          TError,
          Awaited<ReturnType<typeof getInstruments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstruments<TData = Awaited<ReturnType<typeof getInstruments>>, TError = unknown>(
 params?: GetInstrumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInstruments<TData = Awaited<ReturnType<typeof getInstruments>>, TError = unknown>(
 params?: GetInstrumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstruments>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInstrumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const getInstrumentDetail = (
    instrumentID: number,
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Instrument>(
      {url: `/v1/instruments/${instrumentID}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetInstrumentDetailQueryKey = (instrumentID?: number,) => {
    return [
    `/v1/instruments/${instrumentID}`
    ] as const;
    }

    
export const getGetInstrumentDetailQueryOptions = <TData = Awaited<ReturnType<typeof getInstrumentDetail>>, TError = InstrumentNotFoundError>(instrumentID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInstrumentDetailQueryKey(instrumentID);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInstrumentDetail>>> = ({ signal }) => getInstrumentDetail(instrumentID, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(instrumentID), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDetail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInstrumentDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getInstrumentDetail>>>
export type GetInstrumentDetailQueryError = InstrumentNotFoundError


export function useGetInstrumentDetail<TData = Awaited<ReturnType<typeof getInstrumentDetail>>, TError = InstrumentNotFoundError>(
 instrumentID: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDetail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstrumentDetail>>,
          TError,
          Awaited<ReturnType<typeof getInstrumentDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentDetail<TData = Awaited<ReturnType<typeof getInstrumentDetail>>, TError = InstrumentNotFoundError>(
 instrumentID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDetail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInstrumentDetail>>,
          TError,
          Awaited<ReturnType<typeof getInstrumentDetail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInstrumentDetail<TData = Awaited<ReturnType<typeof getInstrumentDetail>>, TError = InstrumentNotFoundError>(
 instrumentID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetInstrumentDetail<TData = Awaited<ReturnType<typeof getInstrumentDetail>>, TError = InstrumentNotFoundError>(
 instrumentID: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInstrumentDetail>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInstrumentDetailQueryOptions(instrumentID,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listCountries = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<Country[]>(
      {url: `/v1/lookups/countries`, method: 'GET', signal
    },
      options);
    }
  



export const getListCountriesQueryKey = () => {
    return [
    `/v1/lookups/countries`
    ] as const;
    }

    
export const getListCountriesQueryOptions = <TData = Awaited<ReturnType<typeof listCountries>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCountriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCountries>>> = ({ signal }) => listCountries(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCountriesQueryResult = NonNullable<Awaited<ReturnType<typeof listCountries>>>
export type ListCountriesQueryError = unknown


export function useListCountries<TData = Awaited<ReturnType<typeof listCountries>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCountries>>,
          TError,
          Awaited<ReturnType<typeof listCountries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCountries<TData = Awaited<ReturnType<typeof listCountries>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCountries>>,
          TError,
          Awaited<ReturnType<typeof listCountries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCountries<TData = Awaited<ReturnType<typeof listCountries>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListCountries<TData = Awaited<ReturnType<typeof listCountries>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCountries>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCountriesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export const listPhonePrefixes = (
    
 options?: SecondParameter<typeof customFetch>,signal?: AbortSignal
) => {
      
      
      return customFetch<PhonePrefix[]>(
      {url: `/v1/lookups/phone-prefixes`, method: 'GET', signal
    },
      options);
    }
  



export const getListPhonePrefixesQueryKey = () => {
    return [
    `/v1/lookups/phone-prefixes`
    ] as const;
    }

    
export const getListPhonePrefixesQueryOptions = <TData = Awaited<ReturnType<typeof listPhonePrefixes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhonePrefixes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPhonePrefixesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPhonePrefixes>>> = ({ signal }) => listPhonePrefixes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPhonePrefixes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPhonePrefixesQueryResult = NonNullable<Awaited<ReturnType<typeof listPhonePrefixes>>>
export type ListPhonePrefixesQueryError = unknown


export function useListPhonePrefixes<TData = Awaited<ReturnType<typeof listPhonePrefixes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhonePrefixes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPhonePrefixes>>,
          TError,
          Awaited<ReturnType<typeof listPhonePrefixes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPhonePrefixes<TData = Awaited<ReturnType<typeof listPhonePrefixes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhonePrefixes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPhonePrefixes>>,
          TError,
          Awaited<ReturnType<typeof listPhonePrefixes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPhonePrefixes<TData = Awaited<ReturnType<typeof listPhonePrefixes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhonePrefixes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListPhonePrefixes<TData = Awaited<ReturnType<typeof listPhonePrefixes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPhonePrefixes>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPhonePrefixesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
